import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type AcceptFinancingApplicationResponse = {
  __typename?: 'AcceptFinancingApplicationResponse';
  contractId?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AcceptTransferDealInput = {
  documentType: DocumentType;
  transferDealId: Scalars['ID']['input'];
};

export enum AgeCategory {
  Primary = 'PRIMARY',
  U13 = 'U13',
  U14 = 'U14',
  U15 = 'U15',
  U16 = 'U16',
  U17 = 'U17',
  U18 = 'U18',
  U19 = 'U19',
  U20 = 'U20',
  U21 = 'U21',
  U23 = 'U23'
}

export type Application = {
  __typename?: 'Application';
  applicationId: Scalars['ID']['output'];
  clauses: Array<ApplicationClause>;
  contracts: Array<ContractSummary>;
  createdByOrganisationId: Scalars['Int']['output'];
  createdByUserId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  status: ApplicationStatus;
  type: ApplicationType;
};

export type ApplicationClause = {
  __typename?: 'ApplicationClause';
  data?: Maybe<Scalars['JSON']['output']>;
  label: Scalars['String']['output'];
};

export type ApplicationClausesDetails = {
  clauses?: InputMaybe<Array<InputMaybe<ClauseDetails>>>;
};

export type ApplicationDetails = {
  clauses?: InputMaybe<Array<InputMaybe<ClauseDetails>>>;
  type: ApplicationType;
};

export type ApplicationMetadataDetails = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationRequestFurtherDetail = {
  __typename?: 'ApplicationRequestFurtherDetail';
  applicationRequestFurtherDetailId: Scalars['Int']['output'];
  applicationRequestId: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  createdByOrganisationId: Scalars['Int']['output'];
  createdByUserId: Scalars['Int']['output'];
  fieldsData?: Maybe<ApplicationRequestFurtherDetailFieldsData>;
  receivedAt?: Maybe<Scalars['String']['output']>;
  receivedByUserId?: Maybe<Scalars['Int']['output']>;
  sentAt?: Maybe<Scalars['String']['output']>;
  status: ApplicationRequestFurtherDetailStatus;
  submissionData?: Maybe<ApplicationRequestFurtherDetailSubmissionData>;
  submittedAt?: Maybe<Scalars['String']['output']>;
  submittedByOrganisationId?: Maybe<Scalars['Int']['output']>;
  submittedByUserId?: Maybe<Scalars['Int']['output']>;
};

export type ApplicationRequestFurtherDetailField = {
  __typename?: 'ApplicationRequestFurtherDetailField';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ApplicationRequestFurtherDetailFieldInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationRequestFurtherDetailFieldsData = {
  __typename?: 'ApplicationRequestFurtherDetailFieldsData';
  fields?: Maybe<Array<ApplicationRequestFurtherDetailField>>;
};

export type ApplicationRequestFurtherDetailFieldsDataInput = {
  fields?: InputMaybe<Array<ApplicationRequestFurtherDetailFieldInput>>;
};

export enum ApplicationRequestFurtherDetailStatus {
  ConfirmedReceipt = 'CONFIRMED_RECEIPT',
  Draft = 'DRAFT',
  Sent = 'SENT',
  Submitted = 'SUBMITTED'
}

export type ApplicationRequestFurtherDetailSubmission = {
  __typename?: 'ApplicationRequestFurtherDetailSubmission';
  fieldId?: Maybe<Scalars['String']['output']>;
  uploadIds?: Maybe<Array<Scalars['Int']['output']>>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ApplicationRequestFurtherDetailSubmissionData = {
  __typename?: 'ApplicationRequestFurtherDetailSubmissionData';
  partialSubmissionReason?: Maybe<Scalars['String']['output']>;
  submissions?: Maybe<Array<ApplicationRequestFurtherDetailSubmission>>;
};

export type ApplicationRequestFurtherDetailSubmissionDataInput = {
  partialSubmissionReason?: InputMaybe<Scalars['String']['input']>;
  submissions?: InputMaybe<Array<ApplicationRequestFurtherDetailSubmissionInput>>;
};

export type ApplicationRequestFurtherDetailSubmissionInput = {
  fieldId?: InputMaybe<Scalars['String']['input']>;
  uploadIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum ApplicationRequestStatus {
  Accepted = 'ACCEPTED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Revoked = 'REVOKED'
}

export enum ApplicationRequestType {
  Financing = 'FINANCING'
}

export enum ApplicationStatus {
  Approved = 'APPROVED',
  Concluded = 'CONCLUDED',
  Draft = 'DRAFT',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Withdrawn = 'WITHDRAWN'
}

export type ApplicationSubmitDetails = {
  applicationId: Scalars['ID']['input'];
  financierOrganisationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ApplicationSummary = {
  __typename?: 'ApplicationSummary';
  applicationId: Scalars['ID']['output'];
  createdByOrganisationId: Scalars['Int']['output'];
  createdByUserId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  status: ApplicationStatus;
  type: ApplicationType;
};

export enum ApplicationType {
  BridgeLoanFinancing = 'BRIDGE_LOAN_FINANCING',
  GeneralApplicationFinancing = 'GENERAL_APPLICATION_FINANCING',
  GeneralEnquiryFinancing = 'GENERAL_ENQUIRY_FINANCING',
  MediaRightsFinancing = 'MEDIA_RIGHTS_FINANCING',
  PayableFinancing = 'PAYABLE_FINANCING',
  PlayerTransferFinancing = 'PLAYER_TRANSFER_FINANCING',
  SellOnFeesFinancing = 'SELL_ON_FEES_FINANCING',
  TermLoanFinancing = 'TERM_LOAN_FINANCING'
}

export type Area = {
  __typename?: 'Area';
  alpha2Code: Scalars['String']['output'];
  alpha3Code: Scalars['String']['output'];
  areaId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AreasFilter = {
  areaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ClauseDetails = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  label: Scalars['String']['input'];
};

export enum ClauseType {
  AgentFees = 'AGENT_FEES',
  ContractDetails = 'CONTRACT_DETAILS',
  ContractPaymentTerms = 'CONTRACT_PAYMENT_TERMS',
  DealFinancingDetails = 'DEAL_FINANCING_DETAILS',
  ExitClause = 'EXIT_CLAUSE',
  FinancialTermsAndFees = 'FINANCIAL_TERMS_AND_FEES',
  FinancingApplicationSetup = 'FINANCING_APPLICATION_SETUP',
  FinancingSchedule = 'FINANCING_SCHEDULE',
  FreeFormBonus = 'FREE_FORM_BONUS',
  LegalAndComplianceDetails = 'LEGAL_AND_COMPLIANCE_DETAILS',
  LoanStructureAndTimeline = 'LOAN_STRUCTURE_AND_TIMELINE',
  MultipleUploads = 'MULTIPLE_UPLOADS',
  PaymentSchedule = 'PAYMENT_SCHEDULE',
  PaymentTerms = 'PAYMENT_TERMS',
  PerformanceBonus = 'PERFORMANCE_BONUS',
  PlayerDetails = 'PLAYER_DETAILS',
  PlayerTransferFinancingSchedule = 'PLAYER_TRANSFER_FINANCING_SCHEDULE',
  SingleUpload = 'SINGLE_UPLOAD',
  TransferClauses = 'TRANSFER_CLAUSES',
  TransferDealDetails = 'TRANSFER_DEAL_DETAILS',
  TransferDealReference = 'TRANSFER_DEAL_REFERENCE',
  TransferDetails = 'TRANSFER_DETAILS'
}

export type Club = {
  __typename?: 'Club';
  areaId: Scalars['Int']['output'];
  city?: Maybe<Scalars['String']['output']>;
  clubId: Scalars['ID']['output'];
  commonName?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  officialName: Scalars['String']['output'];
  players: Array<ClubPlayer>;
  teams: Array<ClubTeam>;
};

export type ClubOrganisation = {
  __typename?: 'ClubOrganisation';
  address?: Maybe<Scalars['String']['output']>;
  billing?: Maybe<OrganisationBilling>;
  contracts: Array<Contract>;
  name: Scalars['String']['output'];
  organisationId: Scalars['ID']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  type?: Maybe<OrganisationType>;
  users: Array<OrganisationUser>;
};


export type ClubOrganisationContractsArgs = {
  filter?: InputMaybe<FilterContractsParams>;
};

export type ClubPlayer = {
  __typename?: 'ClubPlayer';
  firstName: Scalars['String']['output'];
  foot?: Maybe<PlayerFoot>;
  gender?: Maybe<Gender>;
  heightCm?: Maybe<Scalars['Int']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  playerId: Scalars['ID']['output'];
  role?: Maybe<PlayerRole>;
  shortName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PersonActivityStatus>;
  teams: Array<ClubPlayerTeam>;
  weightKg?: Maybe<Scalars['Int']['output']>;
};

export type ClubPlayerTeam = {
  __typename?: 'ClubPlayerTeam';
  teamId: Scalars['ID']['output'];
  type?: Maybe<TeamType>;
};

export type ClubSummary = {
  __typename?: 'ClubSummary';
  clubId: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  officialName: Scalars['String']['output'];
};

export type ClubTeam = {
  __typename?: 'ClubTeam';
  commonName: Scalars['String']['output'];
  gender?: Maybe<Gender>;
  isYouth?: Maybe<Scalars['Boolean']['output']>;
  officialName: Scalars['String']['output'];
  teamId: Scalars['ID']['output'];
  type?: Maybe<TeamType>;
};

export type Competition = {
  __typename?: 'Competition';
  ageCategory: AgeCategory;
  areaId: Scalars['Int']['output'];
  areaName?: Maybe<Scalars['String']['output']>;
  competitionId: Scalars['ID']['output'];
  divisionLevel?: Maybe<Scalars['Int']['output']>;
  format: CompetitionFormat;
  gender: Gender;
  isInternational?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  participantTeamType: ParticipantTeamType;
  seasonFrequency?: Maybe<SeasonFrequency>;
  structure?: Maybe<CompetitionStructure>;
};

export enum CompetitionFormat {
  Cup = 'CUP',
  League = 'LEAGUE',
  SuperCup = 'SUPER_CUP'
}

export enum CompetitionStructure {
  Hybrid = 'HYBRID',
  Knockout = 'KNOCKOUT',
  RoundRobin = 'ROUND_ROBIN'
}

export type CompetitionSummary = {
  __typename?: 'CompetitionSummary';
  areaName?: Maybe<Scalars['String']['output']>;
  competitionId?: Maybe<Scalars['ID']['output']>;
  format?: Maybe<CompetitionFormat>;
  gender?: Maybe<Gender>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ConfirmApplicationRequestFurtherDetailReceiptInput = {
  applicationRequestFurtherDetailId: Scalars['Int']['input'];
};

export type Contract = {
  __typename?: 'Contract';
  clauses: Array<ContractClause>;
  contractId: Scalars['ID']['output'];
  createdByOrganisationId: Scalars['Int']['output'];
  editableByOrganisationId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  rejectionReasonOption?: Maybe<Scalars['String']['output']>;
  sentToOrganisationId?: Maybe<Scalars['Int']['output']>;
  shareRejectionReason?: Maybe<Scalars['Boolean']['output']>;
  status: ContractStatus;
  type: ContractType;
};

export type ContractClause = {
  __typename?: 'ContractClause';
  isAccepted: Scalars['Boolean']['output'];
  isModified: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  versions?: Maybe<ContractClauseVersionMap>;
};

export type ContractClauseVersion = {
  __typename?: 'ContractClauseVersion';
  createdAt: Scalars['DateTime']['output'];
  createdByOrganisationId: Scalars['Int']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
};

export type ContractClauseVersionMap = {
  __typename?: 'ContractClauseVersionMap';
  ACCEPTED?: Maybe<ContractClauseVersion>;
  DRAFT?: Maybe<DraftContractClauseVersion>;
  PROPOSED?: Maybe<ContractClauseVersion>;
  REJECTED: Array<ContractClauseVersion>;
};

export type ContractClausesDetails = {
  clauses?: InputMaybe<Array<InputMaybe<ClauseDetails>>>;
};

export type ContractDetails = {
  clauses?: InputMaybe<Array<InputMaybe<ClauseDetails>>>;
  type: ContractType;
};

export type ContractInviteUserDetails = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ContractMetadataDetails = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ContractSendDetails = {
  counterparty?: InputMaybe<ContractInviteUserDetails>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export enum ContractStatus {
  Accepted = 'ACCEPTED',
  AwaitingResponse = 'AWAITING_RESPONSE',
  Draft = 'DRAFT',
  InNegotiation = 'IN_NEGOTIATION',
  Rejected = 'REJECTED',
  Void = 'VOID'
}

export type ContractStatusFilterInput = {
  statuses?: InputMaybe<Array<ContractStatus>>;
};

export type ContractSummary = {
  __typename?: 'ContractSummary';
  contractId: Scalars['ID']['output'];
  createdByOrganisationId: Scalars['Int']['output'];
  editableByOrganisationId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  sentToOrganisationId?: Maybe<Scalars['Int']['output']>;
  status: ContractStatus;
  type: ContractType;
};

export enum ContractType {
  BridgeLoanFinancing = 'BRIDGE_LOAN_FINANCING',
  GeneralApplicationFinancing = 'GENERAL_APPLICATION_FINANCING',
  GeneralEnquiryFinancing = 'GENERAL_ENQUIRY_FINANCING',
  MediaRightsFinancing = 'MEDIA_RIGHTS_FINANCING',
  PayableFinancing = 'PAYABLE_FINANCING',
  PlayerContract = 'PLAYER_CONTRACT',
  PlayerTransfer = 'PLAYER_TRANSFER',
  PlayerTransferFinancing = 'PLAYER_TRANSFER_FINANCING',
  SellOnFeesFinancing = 'SELL_ON_FEES_FINANCING',
  TermLoanFinancing = 'TERM_LOAN_FINANCING'
}

export enum ContractVersionStatus {
  Accepted = 'ACCEPTED',
  Draft = 'DRAFT',
  Proposed = 'PROPOSED',
  Rejected = 'REJECTED'
}

export type CounterPartyDetailsInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};

export enum DocumentType {
  ImageRightsAgreement = 'IMAGE_RIGHTS_AGREEMENT',
  PlayerContract = 'PLAYER_CONTRACT',
  PlayerIdentification = 'PLAYER_IDENTIFICATION',
  ProofOfTermination = 'PROOF_OF_TERMINATION',
  RegistrationForms = 'REGISTRATION_FORMS',
  RepresentationAndCommission = 'REPRESENTATION_AND_COMMISSION',
  TransferAgreement = 'TRANSFER_AGREEMENT',
  WorkPermitVisa = 'WORK_PERMIT_VISA'
}

export type DraftContractClauseVersion = {
  __typename?: 'DraftContractClauseVersion';
  data?: Maybe<Scalars['JSON']['output']>;
};

export type EnterContractResponse = {
  __typename?: 'EnterContractResponse';
  contract: Contract;
};

export type EnterTransferDealInput = {
  playerOrganisationId?: InputMaybe<Scalars['Int']['input']>;
  sellingClubOrganisationId?: InputMaybe<Scalars['Int']['input']>;
  transferDealId: Scalars['ID']['input'];
};

export type EnterTransferDealResponse = {
  __typename?: 'EnterTransferDealResponse';
  transferDeal: TransferDeal;
};

export enum ExclusivityAction {
  Remove = 'REMOVE',
  Set = 'SET'
}

export type FileDetailsInput = {
  fileName: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  s3Key: Scalars['String']['input'];
};

export type FilterContractsInput = {
  counterPartyOrganisationId?: InputMaybe<Scalars['Int']['input']>;
  createdByOrganisationId?: InputMaybe<Scalars['Int']['input']>;
  organisationId?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<ContractStatus>>;
  types?: InputMaybe<Array<ContractType>>;
};

export type FilterContractsParams = {
  counterPartyOrganisationId?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<ContractStatus>>;
};

export type FilterInput = {
  field: Scalars['String']['input'];
  operator: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
};

export type FilterInvitesParams = {
  contractId?: InputMaybe<Scalars['Int']['input']>;
  organisationId?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<InviteStatus>>;
  types?: InputMaybe<Array<InviteType>>;
};

export enum FinancierType {
  AssetManager = 'ASSET_MANAGER',
  BankFinancialInstitution = 'BANK_FINANCIAL_INSTITUTION',
  FamilyOfficeHnwCapital = 'FAMILY_OFFICE_HNW_CAPITAL',
  HedgeFund = 'HEDGE_FUND',
  PrivateCreditFund = 'PRIVATE_CREDIT_FUND',
  PrivateEquity = 'PRIVATE_EQUITY',
  SovereignWealthFund = 'SOVEREIGN_WEALTH_FUND',
  SpecialSituation = 'SPECIAL_SITUATION'
}

export type FinancingApplicationFilter = {
  statuses?: InputMaybe<Array<ApplicationStatus>>;
  types?: InputMaybe<Array<ApplicationType>>;
};

export type FinancingApplicationRequest = {
  __typename?: 'FinancingApplicationRequest';
  application: Application;
  applicationId: Scalars['Int']['output'];
  applicationRequestId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  isExplicit: Scalars['Boolean']['output'];
  isOutsideRisk: Scalars['Boolean']['output'];
  organisationId: Scalars['Int']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  rejectionReasonOption?: Maybe<Scalars['String']['output']>;
  shareRejectionReason?: Maybe<Scalars['Boolean']['output']>;
  status: ApplicationRequestStatus;
  type: ApplicationRequestType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type FinancingApplicationRequestFilter = {
  contractStatuses?: InputMaybe<Array<ContractStatus>>;
  statuses?: InputMaybe<Array<ApplicationRequestStatus>>;
  types?: InputMaybe<Array<ApplicationRequestType>>;
};

export type FinancingApplicationRequestSummary = {
  __typename?: 'FinancingApplicationRequestSummary';
  application: FinancingApplicationSummary;
  applicationId: Scalars['Int']['output'];
  applicationRequestId: Scalars['ID']['output'];
  contract?: Maybe<FinancingContractSummary>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  isExplicit: Scalars['Boolean']['output'];
  isOutsideRisk: Scalars['Boolean']['output'];
  leagueName?: Maybe<Scalars['String']['output']>;
  organisationId: Scalars['Int']['output'];
  status: ApplicationRequestStatus;
  type: ApplicationRequestType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type FinancingApplicationRequestSummaryLite = {
  __typename?: 'FinancingApplicationRequestSummaryLite';
  applicationId: Scalars['Int']['output'];
  applicationRequestId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  isExplicit: Scalars['Boolean']['output'];
  isOutsideRisk: Scalars['Boolean']['output'];
  organisationId: Scalars['Int']['output'];
  status: ApplicationRequestStatus;
  type: ApplicationRequestType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type FinancingApplicationSummary = {
  __typename?: 'FinancingApplicationSummary';
  applicationId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdByOrganisationId: Scalars['Int']['output'];
  createdByUserId: Scalars['Int']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  dealName?: Maybe<Scalars['String']['output']>;
  grossAmount?: Maybe<Scalars['Float']['output']>;
  leagueName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organisationName?: Maybe<Scalars['String']['output']>;
  organisationType?: Maybe<OrganisationType>;
  status: ApplicationStatus;
  term?: Maybe<Scalars['String']['output']>;
  type: ApplicationType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type FinancingContractInvite = {
  __typename?: 'FinancingContractInvite';
  contract: FinancingContractSummary;
  inviteId: Scalars['Int']['output'];
  status: InviteStatus;
  token: Scalars['String']['output'];
  type: InviteType;
};

export type FinancingContractOrRequestSummary = {
  __typename?: 'FinancingContractOrRequestSummary';
  allInRate?: Maybe<Scalars['Float']['output']>;
  applicationRequestId?: Maybe<Scalars['ID']['output']>;
  contractId?: Maybe<Scalars['ID']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isExplicitInvite?: Maybe<Scalars['Boolean']['output']>;
  lenderName: Scalars['String']['output'];
  netValue?: Maybe<Scalars['Float']['output']>;
  sourceType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  timeToClose?: Maybe<Scalars['String']['output']>;
  totalCosts?: Maybe<Scalars['Float']['output']>;
};

export type FinancingContractSummary = {
  __typename?: 'FinancingContractSummary';
  allInRate?: Maybe<Scalars['Float']['output']>;
  contractId: Scalars['ID']['output'];
  createdByOrganisationId: Scalars['Int']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  editableByOrganisationId?: Maybe<Scalars['Int']['output']>;
  legalCost?: Maybe<Scalars['Float']['output']>;
  lenderName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  netValue?: Maybe<Scalars['Float']['output']>;
  sentToOrganisationId?: Maybe<Scalars['Int']['output']>;
  status: ContractStatus;
  timeToClose?: Maybe<Scalars['String']['output']>;
  totalCosts?: Maybe<Scalars['Float']['output']>;
  type: ContractType;
};

export enum FinancingType {
  BridgeLoan = 'BRIDGE_LOAN',
  GeneralApplication = 'GENERAL_APPLICATION',
  GeneralEnquiry = 'GENERAL_ENQUIRY',
  MediaRights = 'MEDIA_RIGHTS',
  Payable = 'PAYABLE',
  PlayerTransfer = 'PLAYER_TRANSFER',
  SellOnFees = 'SELL_ON_FEES',
  TermLoan = 'TERM_LOAN'
}

export type FinancingTypeExclusivity = {
  __typename?: 'FinancingTypeExclusivity';
  financingType: FinancingType;
  organisationIds: Array<Scalars['ID']['output']>;
};

export type FinancingTypeExclusivityRule = {
  __typename?: 'FinancingTypeExclusivityRule';
  createdAt: Scalars['String']['output'];
  financingType: FinancingType;
  financingTypeExclusivityId: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  organisationId: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE'
}

export type GetCompetitionByIdParams = {
  competitionId: Scalars['Int']['input'];
};

export type Invite = {
  __typename?: 'Invite';
  club?: Maybe<Club>;
  contract?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<InviteCreatedBy>;
  inviteId: Scalars['Int']['output'];
  lastSent?: Maybe<Scalars['DateTime']['output']>;
  organisation: InviteOrganisation;
  organisationUser?: Maybe<InviteOrganisationUser>;
  player?: Maybe<Player>;
  requestedAt?: Maybe<Scalars['Date']['output']>;
  requestedBy?: Maybe<InviteRequestedBy>;
  status: InviteStatus;
  token: Scalars['String']['output'];
  transferDeal?: Maybe<Scalars['JSON']['output']>;
  type: InviteType;
  user: InviteUser;
};

export type InviteClubDetails = {
  clubId: Scalars['Int']['input'];
};

export type InviteContractDetails = {
  contractId: Scalars['Int']['input'];
};

export type InviteCreatedBy = {
  __typename?: 'InviteCreatedBy';
  userId: Scalars['Int']['output'];
};

export type InviteDetails = {
  club?: InputMaybe<InviteClubDetails>;
  contract?: InputMaybe<InviteContractDetails>;
  organisation?: InputMaybe<InviteOrganisationDetails>;
  organisationUser?: InputMaybe<InviteOrganisationUserDetails>;
  player?: InputMaybe<InvitePlayerDetails>;
  transferDeal?: InputMaybe<InviteTransferDealDetails>;
  type: InviteType;
  user: InviteUserDetails;
};

export type InviteOrganisation = {
  __typename?: 'InviteOrganisation';
  address?: Maybe<Scalars['String']['output']>;
  allowedFinancingTypes?: Maybe<Array<Maybe<FinancingType>>>;
  billing?: Maybe<OrganisationBilling>;
  financierType?: Maybe<FinancierType>;
  licenseType?: Maybe<LicenseType>;
  name?: Maybe<Scalars['String']['output']>;
  organisationId?: Maybe<Scalars['Int']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  type?: Maybe<OrganisationType>;
};

export type InviteOrganisationDetails = {
  address?: InputMaybe<Scalars['String']['input']>;
  allowedFinancingTypes?: InputMaybe<Array<InputMaybe<FinancingType>>>;
  billing?: InputMaybe<OrganisationBillingDetails>;
  financierType?: InputMaybe<FinancierType>;
  licenseType?: InputMaybe<LicenseType>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['Int']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OrganisationType>;
};

export type InviteOrganisationUser = {
  __typename?: 'InviteOrganisationUser';
  permissions?: Maybe<Scalars['JSON']['output']>;
  role: OrganisationUserRole;
};

export type InviteOrganisationUserDetails = {
  permissions?: InputMaybe<Scalars['JSON']['input']>;
  role: OrganisationUserRole;
};

export type InvitePlayerDetails = {
  playerId: Scalars['Int']['input'];
};

export type InviteRequestedBy = {
  __typename?: 'InviteRequestedBy';
  organisationId?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export enum InviteStatus {
  InviteCreated = 'INVITE_CREATED',
  InviteSent = 'INVITE_SENT',
  InviteWithdrawn = 'INVITE_WITHDRAWN',
  OnboardingCompleted = 'ONBOARDING_COMPLETED',
  OnboardingStarted = 'ONBOARDING_STARTED',
  Provisional = 'PROVISIONAL'
}

export type InviteTransferDealDetails = {
  transferDealId: Scalars['Int']['input'];
};

export enum InviteType {
  AdminUser = 'ADMIN_USER',
  FinancingContract = 'FINANCING_CONTRACT',
  Organisation = 'ORGANISATION',
  OrganisationUser = 'ORGANISATION_USER',
  PlayerContract = 'PLAYER_CONTRACT',
  PlayerTransfer = 'PLAYER_TRANSFER',
  PlayerTransferDeal = 'PLAYER_TRANSFER_DEAL'
}

export type InviteUser = {
  __typename?: 'InviteUser';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type InviteUserDetails = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type LeagueRules = {
  __typename?: 'LeagueRules';
  competitionIds: Array<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  financierTypes: Array<FinancierType>;
  financingTypes: Array<FinancingType>;
  leagueRuleId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type LeagueRulesInput = {
  competitionIds: Array<Scalars['Int']['input']>;
  financierTypes: Array<FinancierType>;
  financingTypes: Array<FinancingType>;
};

export enum LicenseType {
  SingleClub = 'SINGLE_CLUB'
}

export type Mutation = {
  __typename?: 'Mutation';
  applicationsCreate: Application;
  applicationsDelete: StatusResponse;
  applicationsResubmit: Application;
  applicationsSubmit: StatusResponse;
  applicationsUpdateClauses: StatusResponse;
  applicationsUpdateMetadata: StatusResponse;
  contractsAcceptClause: StatusResponse;
  contractsCreate: Contract;
  contractsReject: StatusResponse;
  contractsSend: StatusResponse;
  contractsUpdateClauses: StatusResponse;
  contractsUpdateMetadata: StatusResponse;
  enterContract: EnterContractResponse;
  enterOrganisation: Scalars['Boolean']['output'];
  enterTransferDeal: EnterTransferDealResponse;
  financingApplicationRequestFurtherDetailConfirmReceipt: StatusResponse;
  financingApplicationRequestFurtherDetailCreate: ApplicationRequestFurtherDetail;
  financingApplicationRequestFurtherDetailDelete: StatusResponse;
  financingApplicationRequestFurtherDetailSend: StatusResponse;
  financingApplicationRequestFurtherDetailSubmit: StatusResponse;
  financingApplicationRequestFurtherDetailUpdate: StatusResponse;
  financingApplicationRequestsAccept: AcceptFinancingApplicationResponse;
  financingApplicationRequestsCreate: FinancingApplicationRequest;
  financingApplicationRequestsReject: StatusResponse;
  invitesCreate: StatusResponse;
  invitesCreateProvisional: StatusResponse;
  invitesResend: StatusResponse;
  leagueRulesCreate: LeagueRules;
  leagueRulesDelete: Scalars['Boolean']['output'];
  leagueRulesUpdate: LeagueRules;
  onboardOrganisation: OnboardOrganisationResponse;
  onboardUser: OnboardUserResponse;
  organisationsRemoveUser: StatusResponse;
  organisationsUpdateFinancierProfile: StatusResponse;
  organisationsUpdateFinancingTypeExclusivity: StatusResponse;
  organisationsUpdateProfile: StatusResponse;
  playerCalculationsCreate: PlayerCalculation;
  playerCalculationsUpdate: PlayerCalculation;
  transferDealsAcceptDocument: StatusResponse;
  transferDealsEnterExecution: TransferDeal;
  transferDealsExecuteDeal: TransferDeal;
  transferDealsLinkDocument: TransferDealDocument;
  transferDealsSetup: TransferDeal;
  uploadsCreate: Upload;
  uploadsDelete: Scalars['Boolean']['output'];
  usersCreate: User;
  usersSendPasswordResetEmail: StatusResponse;
  usersSetDefaultOrganisation: StatusResponse;
  usersUpdateLastLogin: StatusResponse;
  usersUpdateProfile: StatusResponse;
};


export type MutationApplicationsCreateArgs = {
  details: ApplicationDetails;
};


export type MutationApplicationsDeleteArgs = {
  applicationId: Scalars['ID']['input'];
};


export type MutationApplicationsResubmitArgs = {
  applicationId: Scalars['ID']['input'];
};


export type MutationApplicationsSubmitArgs = {
  details?: InputMaybe<ApplicationSubmitDetails>;
};


export type MutationApplicationsUpdateClausesArgs = {
  applicationId: Scalars['ID']['input'];
  details: ApplicationClausesDetails;
};


export type MutationApplicationsUpdateMetadataArgs = {
  applicationId: Scalars['ID']['input'];
  details: ApplicationMetadataDetails;
};


export type MutationContractsAcceptClauseArgs = {
  clauseLabel: Scalars['String']['input'];
  contractId: Scalars['ID']['input'];
};


export type MutationContractsCreateArgs = {
  details: ContractDetails;
};


export type MutationContractsRejectArgs = {
  contractId: Scalars['ID']['input'];
  rejectionReason: Scalars['String']['input'];
  rejectionReasonOption: Scalars['String']['input'];
  shareRejectionReason?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationContractsSendArgs = {
  contractId: Scalars['ID']['input'];
  details: ContractSendDetails;
};


export type MutationContractsUpdateClausesArgs = {
  contractId: Scalars['ID']['input'];
  details: ContractClausesDetails;
};


export type MutationContractsUpdateMetadataArgs = {
  contractId: Scalars['ID']['input'];
  details: ContractMetadataDetails;
};


export type MutationEnterContractArgs = {
  inviteToken: Scalars['String']['input'];
};


export type MutationEnterOrganisationArgs = {
  inviteToken: Scalars['String']['input'];
};


export type MutationEnterTransferDealArgs = {
  inviteToken: Scalars['String']['input'];
};


export type MutationFinancingApplicationRequestFurtherDetailConfirmReceiptArgs = {
  input: ConfirmApplicationRequestFurtherDetailReceiptInput;
};


export type MutationFinancingApplicationRequestFurtherDetailCreateArgs = {
  applicationRequestId: Scalars['Int']['input'];
};


export type MutationFinancingApplicationRequestFurtherDetailDeleteArgs = {
  applicationRequestFurtherDetailId: Scalars['Int']['input'];
};


export type MutationFinancingApplicationRequestFurtherDetailSendArgs = {
  applicationRequestFurtherDetailId: Scalars['Int']['input'];
};


export type MutationFinancingApplicationRequestFurtherDetailSubmitArgs = {
  input: SubmitApplicationRequestFurtherDetailInput;
};


export type MutationFinancingApplicationRequestFurtherDetailUpdateArgs = {
  input: UpdateApplicationRequestFurtherDetailInput;
};


export type MutationFinancingApplicationRequestsAcceptArgs = {
  applicationRequestId: Scalars['ID']['input'];
};


export type MutationFinancingApplicationRequestsCreateArgs = {
  applicationId: Scalars['ID']['input'];
};


export type MutationFinancingApplicationRequestsRejectArgs = {
  applicationRequestId: Scalars['ID']['input'];
  rejectionReason: Scalars['String']['input'];
  rejectionReasonOption: Scalars['String']['input'];
  shareRejectionReason: Scalars['Boolean']['input'];
};


export type MutationInvitesCreateArgs = {
  inviteDetails: InviteDetails;
  inviteId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationInvitesCreateProvisionalArgs = {
  provisionalInviteDetails: ProvisionalInviteDetails;
};


export type MutationInvitesResendArgs = {
  inviteId: Scalars['Int']['input'];
};


export type MutationLeagueRulesCreateArgs = {
  leagueRules: LeagueRulesInput;
};


export type MutationLeagueRulesDeleteArgs = {
  leagueRuleId: Scalars['ID']['input'];
};


export type MutationLeagueRulesUpdateArgs = {
  input: LeagueRulesInput;
  leagueRuleId: Scalars['ID']['input'];
};


export type MutationOnboardOrganisationArgs = {
  inviteToken: Scalars['String']['input'];
  organisationDetails: OnboardingOrganisationDetails;
};


export type MutationOnboardUserArgs = {
  inviteToken: Scalars['String']['input'];
  userDetails: OnboardingUserDetails;
};


export type MutationOrganisationsRemoveUserArgs = {
  organisationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationOrganisationsUpdateFinancierProfileArgs = {
  organisationFinancierProfileDetails?: InputMaybe<OrganisationFinancierProfileDetails>;
  organisationId: Scalars['ID']['input'];
};


export type MutationOrganisationsUpdateFinancingTypeExclusivityArgs = {
  exclusivityAction: ExclusivityAction;
  financingTypes: Array<FinancingType>;
  organisationIds: Array<Scalars['ID']['input']>;
};


export type MutationOrganisationsUpdateProfileArgs = {
  organisationId: Scalars['ID']['input'];
  organisationProfileDetails?: InputMaybe<OrganisationProfileDetails>;
};


export type MutationPlayerCalculationsCreateArgs = {
  playerCalculationDetails?: InputMaybe<PlayerCalculationDetails>;
};


export type MutationPlayerCalculationsUpdateArgs = {
  calculationParams?: InputMaybe<Scalars['JSON']['input']>;
  playerCalculationId: Scalars['ID']['input'];
};


export type MutationTransferDealsAcceptDocumentArgs = {
  details: AcceptTransferDealInput;
};


export type MutationTransferDealsEnterExecutionArgs = {
  transferDealId: Scalars['ID']['input'];
};


export type MutationTransferDealsExecuteDealArgs = {
  transferDealId: Scalars['ID']['input'];
};


export type MutationTransferDealsLinkDocumentArgs = {
  fileDetails: FileDetailsInput;
  transferDealId: Scalars['ID']['input'];
};


export type MutationTransferDealsSetupArgs = {
  details: SetupTransferDealInput;
};


export type MutationUploadsCreateArgs = {
  details: FileDetailsInput;
};


export type MutationUploadsDeleteArgs = {
  uploadId: Scalars['Int']['input'];
};


export type MutationUsersCreateArgs = {
  userDetails?: InputMaybe<UserDetails>;
};


export type MutationUsersSendPasswordResetEmailArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationUsersSetDefaultOrganisationArgs = {
  organisationId: Scalars['ID']['input'];
};


export type MutationUsersUpdateProfileArgs = {
  userId: Scalars['ID']['input'];
  userProfileDetails?: InputMaybe<UserProfileDetails>;
};

export type OnboardOrganisationResponse = {
  __typename?: 'OnboardOrganisationResponse';
  accessToken: Scalars['String']['output'];
  organisation: Organisation;
};

export type OnboardUserResponse = {
  __typename?: 'OnboardUserResponse';
  accessToken: Scalars['String']['output'];
  user: User;
};

export type OnboardingOrganisationDetails = {
  address: Scalars['String']['input'];
  billing?: InputMaybe<OrganisationBillingDetails>;
  countryId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
};

export type OnboardingUserDetails = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  termsAndConditions: Scalars['Boolean']['input'];
  username: Scalars['String']['input'];
};

export type Organisation = {
  __typename?: 'Organisation';
  address?: Maybe<Scalars['String']['output']>;
  billing?: Maybe<OrganisationBilling>;
  club?: Maybe<Club>;
  contracts: Array<Contract>;
  countryId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  financierProfile?: Maybe<OrganisationFinancierProfile>;
  licenseType?: Maybe<LicenseType>;
  name: Scalars['String']['output'];
  organisationId: Scalars['ID']['output'];
  player?: Maybe<Player>;
  playerCalculations: Array<PlayerCalculation>;
  postalCode?: Maybe<Scalars['String']['output']>;
  type: OrganisationType;
  users: Array<OrganisationUser>;
  usersCount?: Maybe<Scalars['Int']['output']>;
};


export type OrganisationContractsArgs = {
  filter?: InputMaybe<FilterContractsParams>;
};

export type OrganisationBilling = {
  __typename?: 'OrganisationBilling';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type OrganisationBillingDetails = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OrganisationDetails = {
  address?: InputMaybe<Scalars['String']['input']>;
  billing?: InputMaybe<OrganisationBillingDetails>;
  licenseType?: InputMaybe<LicenseType>;
  name: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  type: OrganisationType;
};

export type OrganisationFinancierCriteria = {
  __typename?: 'OrganisationFinancierCriteria';
  groups: Array<OrganisationFinancierCriteriaGroup>;
};

export type OrganisationFinancierCriteriaClub = {
  __typename?: 'OrganisationFinancierCriteriaClub';
  blacklistedClubIds?: Maybe<Array<Scalars['String']['output']>>;
  competition?: Maybe<Array<Scalars['String']['output']>>;
  competitionInclude?: Maybe<Scalars['Boolean']['output']>;
  country?: Maybe<Array<Scalars['String']['output']>>;
  countryInclude?: Maybe<Scalars['Boolean']['output']>;
  debtorRiskCountry?: Maybe<Array<Scalars['String']['output']>>;
  debtorRiskCountryInclude?: Maybe<Scalars['Boolean']['output']>;
};

export type OrganisationFinancierCriteriaClubInput = {
  blacklistedClubIds?: InputMaybe<Array<Scalars['String']['input']>>;
  competition?: InputMaybe<Array<Scalars['String']['input']>>;
  competitionInclude?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Array<Scalars['String']['input']>>;
  countryInclude?: InputMaybe<Scalars['Boolean']['input']>;
  debtorRiskCountry?: InputMaybe<Array<Scalars['String']['input']>>;
  debtorRiskCountryInclude?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganisationFinancierCriteriaGroup = {
  __typename?: 'OrganisationFinancierCriteriaGroup';
  financingType?: Maybe<Array<FinancingType>>;
  loanTerm?: Maybe<Array<Scalars['String']['output']>>;
  loanTermInclude?: Maybe<Scalars['Boolean']['output']>;
  organisationCountry?: Maybe<Array<Scalars['String']['output']>>;
  organisationCountryInclude?: Maybe<Scalars['Boolean']['output']>;
  organisationType?: Maybe<OrganisationFinancierCriteriaOrganisationType>;
  totalLoanAmount?: Maybe<OrganisationFinancierCriteriaLoanAmount>;
};

export type OrganisationFinancierCriteriaGroupInput = {
  financingType?: InputMaybe<Array<FinancingType>>;
  loanTerm?: InputMaybe<Array<Scalars['String']['input']>>;
  loanTermInclude?: InputMaybe<Scalars['Boolean']['input']>;
  organisationCountry?: InputMaybe<Array<Scalars['String']['input']>>;
  organisationCountryInclude?: InputMaybe<Scalars['Boolean']['input']>;
  organisationType?: InputMaybe<OrganisationFinancierCriteriaOrganisationTypeInput>;
  totalLoanAmount?: InputMaybe<OrganisationFinancierCriteriaLoanAmountInput>;
};

export type OrganisationFinancierCriteriaInput = {
  groups: Array<OrganisationFinancierCriteriaGroupInput>;
};

export type OrganisationFinancierCriteriaLoanAmount = {
  __typename?: 'OrganisationFinancierCriteriaLoanAmount';
  calculationCurrency?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Array<Scalars['String']['output']>>;
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
};

export type OrganisationFinancierCriteriaLoanAmountInput = {
  calculationCurrency?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Array<Scalars['String']['input']>>;
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganisationFinancierCriteriaOrganisationType = {
  __typename?: 'OrganisationFinancierCriteriaOrganisationType';
  club?: Maybe<OrganisationFinancierCriteriaClub>;
  gpe?: Maybe<Scalars['Boolean']['output']>;
};

export type OrganisationFinancierCriteriaOrganisationTypeInput = {
  club?: InputMaybe<OrganisationFinancierCriteriaClubInput>;
  gpe: Scalars['Boolean']['input'];
};

export type OrganisationFinancierProfile = {
  __typename?: 'OrganisationFinancierProfile';
  allowedFinancingTypes?: Maybe<Array<FinancingType>>;
  criteria?: Maybe<OrganisationFinancierCriteria>;
  financierType?: Maybe<FinancierType>;
  financingTypes?: Maybe<Array<FinancingType>>;
  organisationId: Scalars['ID']['output'];
  privacyPolicyUrl?: Maybe<Scalars['String']['output']>;
  ticketSize?: Maybe<Scalars['Int']['output']>;
};

export type OrganisationFinancierProfileDetails = {
  allowedFinancingTypes?: InputMaybe<Array<FinancingType>>;
  criteria?: InputMaybe<OrganisationFinancierCriteriaInput>;
  financierType?: InputMaybe<FinancierType>;
  financingTypes?: InputMaybe<Array<FinancingType>>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  ticketSize?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganisationProfileDetails = {
  address?: InputMaybe<Scalars['String']['input']>;
  billing?: InputMaybe<OrganisationBillingDetails>;
  countryId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

export enum OrganisationType {
  Club = 'CLUB',
  Financier = 'FINANCIER',
  GeneralPrivateEntity = 'GENERAL_PRIVATE_ENTITY',
  Player = 'PLAYER'
}

export type OrganisationUser = {
  __typename?: 'OrganisationUser';
  createdAt?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  isEmailVerified: Scalars['Boolean']['output'];
  lastLoginAt?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['JSON']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  role: OrganisationUserRole;
  userId: Scalars['ID']['output'];
  userType?: Maybe<UserType>;
  username: Scalars['String']['output'];
};

export enum OrganisationUserRole {
  AccountOwner = 'ACCOUNT_OWNER',
  RegularUser = 'REGULAR_USER'
}

export type OrganisationsSearchDetails = {
  financingTypes?: InputMaybe<Array<FinancingType>>;
  types?: InputMaybe<Array<OrganisationType>>;
};

export type PaginatedFinancingApplicationRequests = {
  __typename?: 'PaginatedFinancingApplicationRequests';
  items: Array<FinancingApplicationRequestSummary>;
  pagination: PaginatedMeta;
};

export type PaginatedFinancingApplications = {
  __typename?: 'PaginatedFinancingApplications';
  items: Array<FinancingApplicationSummary>;
  pagination: PaginatedMeta;
};

export type PaginatedInvites = {
  __typename?: 'PaginatedInvites';
  items: Array<Invite>;
  pagination: PaginatedMeta;
};

export type PaginatedMeta = {
  __typename?: 'PaginatedMeta';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type PaginatedOrganisations = {
  __typename?: 'PaginatedOrganisations';
  items: Array<Organisation>;
  pagination: PaginatedMeta;
};

export type PaginatedUsers = {
  __typename?: 'PaginatedUsers';
  items: Array<User>;
  pagination: PaginatedMeta;
};

export type PaginationDetails = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PaginationInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export enum ParticipantTeamType {
  Club = 'CLUB',
  Mixed = 'MIXED',
  National = 'NATIONAL'
}

export enum PersonActivityStatus {
  Active = 'ACTIVE',
  Deceased = 'DECEASED',
  Inactive = 'INACTIVE',
  Retired = 'RETIRED'
}

export type Player = {
  __typename?: 'Player';
  club?: Maybe<PlayerClub>;
  firstName: Scalars['String']['output'];
  foot?: Maybe<PlayerFoot>;
  gender?: Maybe<Gender>;
  heightCm?: Maybe<Scalars['Int']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  organisation?: Maybe<PlayerOrganisation>;
  playerId: Scalars['ID']['output'];
  role?: Maybe<PlayerRole>;
  shortName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PersonActivityStatus>;
  teams?: Maybe<PlayerTeam>;
  weightKg?: Maybe<Scalars['Int']['output']>;
};

export type PlayerCalculation = {
  __typename?: 'PlayerCalculation';
  arguments: Scalars['JSON']['output'];
  createdByOrganisationId: Scalars['Int']['output'];
  createdByUserId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  playerCalculationId: Scalars['ID']['output'];
  playerId: Scalars['Int']['output'];
  type: PlayerCalculationType;
};

export type PlayerCalculationDetails = {
  arguments: Scalars['JSON']['input'];
  createdByOrganisationId: Scalars['Int']['input'];
  createdByUserId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  playerId: Scalars['Int']['input'];
  type: PlayerCalculationType;
};

export enum PlayerCalculationType {
  Discount = 'DISCOUNT',
  Gross = 'GROSS'
}

export type PlayerClub = {
  __typename?: 'PlayerClub';
  city: Scalars['String']['output'];
  clubId: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  officialName: Scalars['String']['output'];
  organisation?: Maybe<ClubOrganisation>;
};

export type PlayerContractInvite = {
  __typename?: 'PlayerContractInvite';
  contract: PlayerContractSummary;
  inviteId: Scalars['Int']['output'];
  status: InviteStatus;
  token: Scalars['String']['output'];
  type: InviteType;
};

export type PlayerContractSummary = {
  __typename?: 'PlayerContractSummary';
  contractId: Scalars['ID']['output'];
  createdByOrganisationId: Scalars['Int']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  editableByOrganisationId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  playerName?: Maybe<Scalars['String']['output']>;
  sentToOrganisationId?: Maybe<Scalars['Int']['output']>;
  signOnFee?: Maybe<Scalars['Float']['output']>;
  status: ContractStatus;
  type: ContractType;
};

export enum PlayerFoot {
  Both = 'BOTH',
  Left = 'LEFT',
  Right = 'RIGHT'
}

export type PlayerOrganisation = {
  __typename?: 'PlayerOrganisation';
  address?: Maybe<Scalars['String']['output']>;
  billing?: Maybe<OrganisationBilling>;
  contracts: Array<Contract>;
  name: Scalars['String']['output'];
  organisationId: Scalars['ID']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  type?: Maybe<OrganisationType>;
  users: Array<OrganisationUser>;
};


export type PlayerOrganisationContractsArgs = {
  filter?: InputMaybe<FilterContractsParams>;
};

export enum PlayerRole {
  Defender = 'DEFENDER',
  Forward = 'FORWARD',
  Goalkeeper = 'GOALKEEPER',
  Midfielder = 'MIDFIELDER'
}

export type PlayerTeam = {
  __typename?: 'PlayerTeam';
  officialName: Scalars['String']['output'];
  teamId: Scalars['ID']['output'];
};

export type PlayerTransferContractInvite = {
  __typename?: 'PlayerTransferContractInvite';
  contract: PlayerTransferContractSummary;
  inviteId: Scalars['Int']['output'];
  status: InviteStatus;
  token: Scalars['String']['output'];
  type: InviteType;
};

export type PlayerTransferContractSummary = {
  __typename?: 'PlayerTransferContractSummary';
  acquisitionOffer?: Maybe<Scalars['Float']['output']>;
  contractId: Scalars['ID']['output'];
  createdByOrganisationId: Scalars['Int']['output'];
  deposit?: Maybe<Scalars['Float']['output']>;
  editableByOrganisationId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  playerName?: Maybe<Scalars['String']['output']>;
  sentToOrganisationId?: Maybe<Scalars['Int']['output']>;
  status: ContractStatus;
  transferType?: Maybe<Scalars['String']['output']>;
  type: ContractType;
};

export type PlayersSearchDetails = {
  clubId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ProvisionalInviteDetails = {
  contactEmail: Scalars['String']['input'];
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  nameOfContact: Scalars['String']['input'];
  organisationName: Scalars['String']['input'];
  organisationType: OrganisationType;
  playerId?: InputMaybe<Scalars['Int']['input']>;
  type: InviteType;
};

export type Query = {
  __typename?: 'Query';
  areasGetAll: Array<Area>;
  areasGetAllByName: Array<Area>;
  areasGetById?: Maybe<Area>;
  clubsGetAllByName: Array<ClubSummary>;
  clubsGetAllByOrganisationId: Array<ClubSummary>;
  clubsGetById?: Maybe<Club>;
  competitionsGetAll: Array<Competition>;
  competitionsGetAllByName: Array<CompetitionSummary>;
  competitionsGetById?: Maybe<Competition>;
  contractsGetById?: Maybe<Contract>;
  financingApplicationGetByContractId?: Maybe<Application>;
  financingApplicationRequestFurtherDetailsGetAllByApplicationId: Array<ApplicationRequestFurtherDetail>;
  financingApplicationRequestFurtherDetailsGetAllByApplicationRequestId: Array<ApplicationRequestFurtherDetail>;
  financingApplicationRequestFurtherDetailsGetById?: Maybe<ApplicationRequestFurtherDetail>;
  financingApplicationRequestsForResubmissionGetAllByApplicationId: Array<FinancingApplicationRequestSummaryLite>;
  financingApplicationRequestsGetAllByApplicationId: Array<FinancingApplicationRequestSummaryLite>;
  financingApplicationRequestsGetAllByOrganisationId: Array<FinancingApplicationRequestSummary>;
  financingApplicationRequestsGetAllByOrganisationIdPaginated: PaginatedFinancingApplicationRequests;
  financingApplicationRequestsGetById: FinancingApplicationRequest;
  financingApplicationsGetAll: Array<FinancingApplicationSummary>;
  financingApplicationsGetAllByOrganisationId: Array<FinancingApplicationSummary>;
  financingApplicationsGetAllEligableLendersByCriteria: Array<OrganisationFinancierProfile>;
  financingApplicationsGetById: Application;
  financingApplicationsGetByOrganisationIdPaginated: PaginatedFinancingApplications;
  financingApplicationsGetOutsideMandatePaginated: PaginatedFinancingApplications;
  financingApplicationsGetPaginated: PaginatedFinancingApplications;
  financingContractInviteGetByOrganisationUser: FinancingContractInvite;
  financingContractsGetAllByApplicationId: Array<FinancingContractOrRequestSummary>;
  financingContractsGetAllByOrganisationId: Array<FinancingContractSummary>;
  financingTypeExclusivity: Array<FinancingTypeExclusivity>;
  financingTypeExclusivityGetAll: Array<FinancingTypeExclusivityRule>;
  financingTypeExclusivityGetExclusiveOrganisationIds: Array<Scalars['ID']['output']>;
  financingTypeExclusivityGetGroupedByType: Array<FinancingTypeExclusivity>;
  financingTypeExclusivityHasExclusivity: Scalars['Boolean']['output'];
  financingTypeExclusivityIsOrganisationExclusive: Scalars['Boolean']['output'];
  invitesGetAll: Array<Invite>;
  invitesGetByToken: Invite;
  invitesGetPaginated: PaginatedInvites;
  leagueRulesById?: Maybe<LeagueRules>;
  leagueRulesGetAll: Array<LeagueRules>;
  organisationsGetAllByQuery: Array<Organisation>;
  organisationsGetByCurrentUser: Array<UserOrganisation>;
  organisationsGetById?: Maybe<Organisation>;
  organisationsGetFinancierProfile?: Maybe<OrganisationFinancierProfile>;
  organisationsGetPaginated: PaginatedOrganisations;
  playerCalculationsGetById?: Maybe<PlayerCalculation>;
  playerContractInvitesGetAllByOrganisationId: Array<PlayerContractInvite>;
  playerContractsGetAllByOrganisationId: Array<PlayerContractSummary>;
  playerTransferContractInvitesGetAllByOrganisationId: Array<PlayerTransferContractInvite>;
  playerTransferContractsGetAllByOrganisationId: Array<PlayerTransferContractSummary>;
  playersGetAllByClubId: Array<Player>;
  playersGetAllByName: Array<Player>;
  playersGetAllByQuery: Array<Player>;
  playersGetAllByTeamId: Array<Player>;
  playersGetById?: Maybe<Player>;
  scopedUsageGetByFilter: Array<ScopedUsage>;
  sessionsGetCurrent: Session;
  teamsGetById?: Maybe<Team>;
  transferDealsGetAllByOrganisationId: Array<Maybe<TransferDeal>>;
  transferDealsGetById?: Maybe<TransferDeal>;
  uploadsGetById: Upload;
  uploadsGetPresignedDownloadUrl?: Maybe<Scalars['String']['output']>;
  usersGetAll: Array<User>;
  usersGetById?: Maybe<User>;
  usersGetByOrganisationId?: Maybe<Array<OrganisationUser>>;
  usersGetPaginated: PaginatedUsers;
  usersVerifyOTP: StatusResponse;
};


export type QueryAreasGetAllArgs = {
  filter?: InputMaybe<AreasFilter>;
};


export type QueryAreasGetAllByNameArgs = {
  name: Scalars['String']['input'];
  paginationDetails: PaginationDetails;
};


export type QueryAreasGetByIdArgs = {
  areaId: Scalars['ID']['input'];
};


export type QueryClubsGetAllByNameArgs = {
  name: Scalars['String']['input'];
  paginationDetails: PaginationDetails;
};


export type QueryClubsGetAllByOrganisationIdArgs = {
  organisationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryClubsGetByIdArgs = {
  clubId: Scalars['ID']['input'];
};


export type QueryCompetitionsGetAllByNameArgs = {
  name: Scalars['String']['input'];
  paginationDetails: PaginationDetails;
};


export type QueryCompetitionsGetByIdArgs = {
  competitionId: Scalars['ID']['input'];
};


export type QueryContractsGetByIdArgs = {
  contractId: Scalars['ID']['input'];
};


export type QueryFinancingApplicationGetByContractIdArgs = {
  contractId: Scalars['ID']['input'];
};


export type QueryFinancingApplicationRequestFurtherDetailsGetAllByApplicationIdArgs = {
  applicationId: Scalars['Int']['input'];
};


export type QueryFinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdArgs = {
  applicationRequestId: Scalars['Int']['input'];
};


export type QueryFinancingApplicationRequestFurtherDetailsGetByIdArgs = {
  applicationRequestFurtherDetailId: Scalars['Int']['input'];
};


export type QueryFinancingApplicationRequestsForResubmissionGetAllByApplicationIdArgs = {
  applicationId: Scalars['ID']['input'];
};


export type QueryFinancingApplicationRequestsGetAllByApplicationIdArgs = {
  applicationId: Scalars['ID']['input'];
};


export type QueryFinancingApplicationRequestsGetAllByOrganisationIdArgs = {
  filter?: InputMaybe<FinancingApplicationRequestFilter>;
  organisationId: Scalars['ID']['input'];
};


export type QueryFinancingApplicationRequestsGetAllByOrganisationIdPaginatedArgs = {
  filters?: InputMaybe<Array<FilterInput>>;
  organisationId: Scalars['ID']['input'];
  pagination: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
  sorting?: InputMaybe<SortInput>;
};


export type QueryFinancingApplicationRequestsGetByIdArgs = {
  applicationRequestId: Scalars['ID']['input'];
};


export type QueryFinancingApplicationsGetAllArgs = {
  filter?: InputMaybe<FinancingApplicationFilter>;
};


export type QueryFinancingApplicationsGetAllByOrganisationIdArgs = {
  filter?: InputMaybe<FinancingApplicationFilter>;
  organisationId: Scalars['ID']['input'];
};


export type QueryFinancingApplicationsGetAllEligableLendersByCriteriaArgs = {
  applicationId: Scalars['ID']['input'];
  organisationId: Scalars['ID']['input'];
};


export type QueryFinancingApplicationsGetByIdArgs = {
  applicationId: Scalars['ID']['input'];
};


export type QueryFinancingApplicationsGetByOrganisationIdPaginatedArgs = {
  filters?: InputMaybe<Array<FilterInput>>;
  organisationId: Scalars['ID']['input'];
  pagination: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
  sorting?: InputMaybe<SortInput>;
};


export type QueryFinancingApplicationsGetOutsideMandatePaginatedArgs = {
  filters?: InputMaybe<Array<FilterInput>>;
  includeLeagueName?: InputMaybe<Scalars['Boolean']['input']>;
  pagination: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
  sorting?: InputMaybe<SortInput>;
};


export type QueryFinancingApplicationsGetPaginatedArgs = {
  filters?: InputMaybe<Array<FilterInput>>;
  includeLeagueName?: InputMaybe<Scalars['Boolean']['input']>;
  pagination: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
  sorting?: InputMaybe<SortInput>;
};


export type QueryFinancingContractInviteGetByOrganisationUserArgs = {
  filter?: InputMaybe<FilterInvitesParams>;
};


export type QueryFinancingContractsGetAllByApplicationIdArgs = {
  applicationId: Scalars['ID']['input'];
  filter?: InputMaybe<ContractStatusFilterInput>;
};


export type QueryFinancingContractsGetAllByOrganisationIdArgs = {
  filter?: InputMaybe<FilterContractsInput>;
};


export type QueryFinancingTypeExclusivityArgs = {
  financingType?: InputMaybe<FinancingType>;
};


export type QueryFinancingTypeExclusivityGetExclusiveOrganisationIdsArgs = {
  financingType: FinancingType;
};


export type QueryFinancingTypeExclusivityHasExclusivityArgs = {
  financingType: FinancingType;
};


export type QueryFinancingTypeExclusivityIsOrganisationExclusiveArgs = {
  financingType: FinancingType;
  organisationId: Scalars['ID']['input'];
};


export type QueryInvitesGetAllArgs = {
  filter?: InputMaybe<FilterInvitesParams>;
};


export type QueryInvitesGetByTokenArgs = {
  inviteToken: Scalars['String']['input'];
};


export type QueryInvitesGetPaginatedArgs = {
  filters?: InputMaybe<Array<FilterInput>>;
  pagination: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
  sorting?: InputMaybe<SortInput>;
};


export type QueryLeagueRulesByIdArgs = {
  leagueRuleId: Scalars['ID']['input'];
};


export type QueryOrganisationsGetAllByQueryArgs = {
  paginationDetails: PaginationDetails;
  searchDetails?: InputMaybe<OrganisationsSearchDetails>;
};


export type QueryOrganisationsGetByIdArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryOrganisationsGetFinancierProfileArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryOrganisationsGetPaginatedArgs = {
  filters?: InputMaybe<Array<FilterInput>>;
  pagination: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
  sorting?: InputMaybe<SortInput>;
};


export type QueryPlayerCalculationsGetByIdArgs = {
  playerCalculationId: Scalars['ID']['input'];
};


export type QueryPlayerContractInvitesGetAllByOrganisationIdArgs = {
  filter?: InputMaybe<FilterInvitesParams>;
};


export type QueryPlayerContractsGetAllByOrganisationIdArgs = {
  filter?: InputMaybe<FilterContractsInput>;
};


export type QueryPlayerTransferContractInvitesGetAllByOrganisationIdArgs = {
  filter?: InputMaybe<FilterInvitesParams>;
};


export type QueryPlayerTransferContractsGetAllByOrganisationIdArgs = {
  filter?: InputMaybe<FilterContractsInput>;
};


export type QueryPlayersGetAllByClubIdArgs = {
  clubId: Scalars['ID']['input'];
};


export type QueryPlayersGetAllByNameArgs = {
  name: Scalars['String']['input'];
  paginationDetails: PaginationDetails;
};


export type QueryPlayersGetAllByQueryArgs = {
  paginationDetails: PaginationDetails;
  searchDetails: PlayersSearchDetails;
};


export type QueryPlayersGetAllByTeamIdArgs = {
  teamId: Scalars['ID']['input'];
};


export type QueryPlayersGetByIdArgs = {
  playerId: Scalars['ID']['input'];
};


export type QueryScopedUsageGetByFilterArgs = {
  filter: ScopedUsageFilter;
};


export type QueryTeamsGetByIdArgs = {
  teamId: Scalars['ID']['input'];
};


export type QueryTransferDealsGetByIdArgs = {
  transferDealId: Scalars['ID']['input'];
};


export type QueryUploadsGetByIdArgs = {
  uploadId: Scalars['Int']['input'];
};


export type QueryUploadsGetPresignedDownloadUrlArgs = {
  uploadId: Scalars['Int']['input'];
};


export type QueryUsersGetByIdArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryUsersGetByOrganisationIdArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryUsersGetPaginatedArgs = {
  filters?: InputMaybe<Array<FilterInput>>;
  pagination: PaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
  sorting?: InputMaybe<SortInput>;
};

export type ScopedUsage = {
  __typename?: 'ScopedUsage';
  organisationId?: Maybe<Scalars['Int']['output']>;
  parentId: Scalars['Int']['output'];
  parentType: Scalars['String']['output'];
  quota?: Maybe<Scalars['Int']['output']>;
  quotaUsed: Scalars['Int']['output'];
  resourceType: Scalars['String']['output'];
};

export type ScopedUsageFilter = {
  organisationId?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  parentType?: InputMaybe<Scalars['String']['input']>;
  resourceType?: InputMaybe<Scalars['String']['input']>;
};

export enum SeasonFrequency {
  Annual = 'ANNUAL',
  Biennial = 'BIENNIAL',
  Quadrennial = 'QUADRENNIAL',
  Seasonal = 'SEASONAL'
}

export type Session = {
  __typename?: 'Session';
  invite?: Maybe<Invite>;
  isAuthenticated: Scalars['Boolean']['output'];
  organisation?: Maybe<SessionOrganisation>;
  user?: Maybe<SessionUser>;
};

export type SessionOrganisation = {
  __typename?: 'SessionOrganisation';
  address?: Maybe<Scalars['String']['output']>;
  billing?: Maybe<OrganisationBilling>;
  club?: Maybe<Club>;
  contracts: Array<Contract>;
  countryId?: Maybe<Scalars['Int']['output']>;
  licenseType?: Maybe<LicenseType>;
  name: Scalars['String']['output'];
  organisationId: Scalars['ID']['output'];
  permissions?: Maybe<Scalars['JSON']['output']>;
  player?: Maybe<Player>;
  postalCode?: Maybe<Scalars['String']['output']>;
  role: OrganisationUserRole;
  type: OrganisationType;
  users: Array<OrganisationUser>;
};

export type SessionUser = {
  __typename?: 'SessionUser';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  isEmailVerified: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
  userType?: Maybe<UserType>;
  username: Scalars['String']['output'];
};

export type SetupTransferDealInput = {
  executionDueDate: Scalars['DateTime']['input'];
  playerContractDueDate: Scalars['DateTime']['input'];
  playerContractId?: InputMaybe<Scalars['Int']['input']>;
  playerCounterPartyDetails?: InputMaybe<CounterPartyDetailsInput>;
  playerId: Scalars['Int']['input'];
  playerOrganisationId?: InputMaybe<Scalars['Int']['input']>;
  playerTransferContractDueDate: Scalars['DateTime']['input'];
  playerTransferContractId?: InputMaybe<Scalars['Int']['input']>;
  sellingClubCounterPartyDetails?: InputMaybe<CounterPartyDetailsInput>;
  sellingClubOrganisationId?: InputMaybe<Scalars['Int']['input']>;
};

export type SortInput = {
  field: Scalars['String']['input'];
  order: SortOrder;
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StatusResponse = {
  __typename?: 'StatusResponse';
  success: Scalars['Boolean']['output'];
};

export type SubmitApplicationRequestFurtherDetailInput = {
  applicationRequestFurtherDetailId: Scalars['Int']['input'];
  submissionData: ApplicationRequestFurtherDetailSubmissionDataInput;
};

export type Team = {
  __typename?: 'Team';
  clubId?: Maybe<Scalars['Int']['output']>;
  commonName: Scalars['String']['output'];
  gender?: Maybe<Gender>;
  isYouth?: Maybe<Scalars['Boolean']['output']>;
  officialName: Scalars['String']['output'];
  players: Array<ClubPlayer>;
  teamId: Scalars['ID']['output'];
  type?: Maybe<TeamType>;
};

export enum TeamType {
  Club = 'CLUB',
  National = 'NATIONAL'
}

export type TransferDeal = {
  __typename?: 'TransferDeal';
  buyingClubOrganisation?: Maybe<Organisation>;
  buyingClubOrganisationId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  documents: Array<TransferDealDocument>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  executionCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  executionDueDate: Scalars['DateTime']['output'];
  playerContract?: Maybe<Contract>;
  playerContractDueDate: Scalars['DateTime']['output'];
  playerContractId?: Maybe<Scalars['Int']['output']>;
  playerOrganisation?: Maybe<Organisation>;
  playerOrganisationId?: Maybe<Scalars['Int']['output']>;
  playerTransferContract?: Maybe<Contract>;
  playerTransferContractDueDate: Scalars['DateTime']['output'];
  playerTransferContractId?: Maybe<Scalars['Int']['output']>;
  sellingClubOrganisation?: Maybe<Organisation>;
  sellingClubOrganisationId?: Maybe<Scalars['Int']['output']>;
  status: TransferDealStatus;
  transferDealId: Scalars['ID']['output'];
};

export type TransferDealDocument = {
  __typename?: 'TransferDealDocument';
  buyingClubOrganisationAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  buyingClubOrganisationViewedAt?: Maybe<Scalars['DateTime']['output']>;
  documentType: DocumentType;
  fileName: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  playerOrganisationAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  playerOrganisationViewedAt?: Maybe<Scalars['DateTime']['output']>;
  sellingClubOrganisationAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  sellingClubOrganisationViewedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadId: Scalars['Int']['output'];
  uploadedByOrganisationId: Scalars['Int']['output'];
  uploadedByUserId: Scalars['Int']['output'];
};

export enum TransferDealStatus {
  Executed = 'EXECUTED',
  InExecution = 'IN_EXECUTION',
  InNegotiations = 'IN_NEGOTIATIONS',
  Void = 'VOID'
}

export type UpdateApplicationRequestFurtherDetailInput = {
  applicationRequestFurtherDetailId: Scalars['Int']['input'];
  fieldsData: ApplicationRequestFurtherDetailFieldsDataInput;
};

export type Upload = {
  __typename?: 'Upload';
  fileName: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  uploadId: Scalars['Int']['output'];
};

export type User = {
  __typename?: 'User';
  createdAt?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastLoginAt?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  organisations?: Maybe<Array<UserOrganisation>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
  userType?: Maybe<UserType>;
  username: Scalars['String']['output'];
};

export type UserDetails = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type UserOrganisation = {
  __typename?: 'UserOrganisation';
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organisationId: Scalars['ID']['output'];
  permissions?: Maybe<Scalars['JSON']['output']>;
  role: OrganisationUserRole;
  type: OrganisationType;
};

export type UserProfileDetails = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum UserType {
  Admin = 'ADMIN',
  ClubOrganisation = 'CLUB_ORGANISATION',
  FinancierOrganisation = 'FINANCIER_ORGANISATION',
  GeneralPrivateEntityOrganisation = 'GENERAL_PRIVATE_ENTITY_ORGANISATION',
  PlayerOrganisation = 'PLAYER_ORGANISATION'
}

export type ApplicationsCreateMutationVariables = Exact<{
  details: ApplicationDetails;
}>;


export type ApplicationsCreateMutation = { __typename?: 'Mutation', applicationsCreate: { __typename?: 'Application', applicationId: string, createdByOrganisationId: number, createdByUserId: number, type: ApplicationType, name: string, status: ApplicationStatus, clauses: Array<{ __typename?: 'ApplicationClause', data?: any | null, label: string }> } };

export type ApplicationsDeleteMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
}>;


export type ApplicationsDeleteMutation = { __typename?: 'Mutation', applicationsDelete: { __typename?: 'StatusResponse', success: boolean } };

export type ApplicationsUpdateClausesMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  details: ApplicationClausesDetails;
}>;


export type ApplicationsUpdateClausesMutation = { __typename?: 'Mutation', applicationsUpdateClauses: { __typename?: 'StatusResponse', success: boolean } };

export type ApplicationsSubmitMutationVariables = Exact<{
  details?: InputMaybe<ApplicationSubmitDetails>;
}>;


export type ApplicationsSubmitMutation = { __typename?: 'Mutation', applicationsSubmit: { __typename?: 'StatusResponse', success: boolean } };

export type ApplicationsUpdateMetadataMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  details: ApplicationMetadataDetails;
}>;


export type ApplicationsUpdateMetadataMutation = { __typename?: 'Mutation', applicationsUpdateMetadata: { __typename?: 'StatusResponse', success: boolean } };

export type ApplicationsResubmitMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
}>;


export type ApplicationsResubmitMutation = { __typename?: 'Mutation', applicationsResubmit: { __typename?: 'Application', applicationId: string, createdByOrganisationId: number, createdByUserId: number, type: ApplicationType, name: string, status: ApplicationStatus, clauses: Array<{ __typename?: 'ApplicationClause', data?: any | null, label: string }> } };

export type AreasGetByIdQueryVariables = Exact<{
  areaId: Scalars['ID']['input'];
}>;


export type AreasGetByIdQuery = { __typename?: 'Query', areasGetById?: { __typename?: 'Area', areaId: string, name: string, alpha2Code: string, alpha3Code: string } | null };

export type AreasGetAllQueryVariables = Exact<{
  filter?: InputMaybe<AreasFilter>;
}>;


export type AreasGetAllQuery = { __typename?: 'Query', areasGetAll: Array<{ __typename?: 'Area', areaId: string, name: string, alpha2Code: string, alpha3Code: string }> };

export type AreasGetAllByNameQueryVariables = Exact<{
  name: Scalars['String']['input'];
  paginationDetails: PaginationDetails;
}>;


export type AreasGetAllByNameQuery = { __typename?: 'Query', areasGetAllByName: Array<{ __typename?: 'Area', areaId: string, name: string, alpha2Code: string, alpha3Code: string }> };

export type ClubsGetByIdQueryVariables = Exact<{
  clubId: Scalars['ID']['input'];
}>;


export type ClubsGetByIdQuery = { __typename?: 'Query', clubsGetById?: { __typename?: 'Club', clubId: string, officialName: string, imageUrl?: string | null, teams: Array<{ __typename?: 'ClubTeam', teamId: string, officialName: string, type?: TeamType | null }>, players: Array<{ __typename?: 'ClubPlayer', playerId: string, firstName: string, middleName?: string | null, lastName: string, role?: PlayerRole | null, imageUrl?: string | null, teams: Array<{ __typename?: 'ClubPlayerTeam', teamId: string, type?: TeamType | null }> }> } | null };

export type ClubsGetAllByOrganisationIdQueryVariables = Exact<{
  organisationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ClubsGetAllByOrganisationIdQuery = { __typename?: 'Query', clubsGetAllByOrganisationId: Array<{ __typename?: 'ClubSummary', officialName: string, clubId: string }> };

export type ClubsGetAllByNameQueryVariables = Exact<{
  name: Scalars['String']['input'];
  paginationDetails: PaginationDetails;
}>;


export type ClubsGetAllByNameQuery = { __typename?: 'Query', clubsGetAllByName: Array<{ __typename?: 'ClubSummary', clubId: string, officialName: string, imageUrl: string }> };

export type CompetitionsGetAllByNameQueryVariables = Exact<{
  name: Scalars['String']['input'];
  paginationDetails: PaginationDetails;
}>;


export type CompetitionsGetAllByNameQuery = { __typename?: 'Query', competitionsGetAllByName: Array<{ __typename?: 'CompetitionSummary', competitionId?: string | null, name?: string | null, gender?: Gender | null, format?: CompetitionFormat | null, areaName?: string | null }> };

export type CompetitionsGetByIdQueryVariables = Exact<{
  competitionId: Scalars['ID']['input'];
}>;


export type CompetitionsGetByIdQuery = { __typename?: 'Query', competitionsGetById?: { __typename?: 'Competition', competitionId: string, name: string, gender: Gender, format: CompetitionFormat, areaName?: string | null } | null };

export type CompetitionsGetAllQueryVariables = Exact<{ [key: string]: never; }>;


export type CompetitionsGetAllQuery = { __typename?: 'Query', competitionsGetAll: Array<{ __typename?: 'Competition', competitionId: string, name: string, gender: Gender, format: CompetitionFormat, areaName?: string | null }> };

export type ContractsCreateMutationVariables = Exact<{
  details: ContractDetails;
}>;


export type ContractsCreateMutation = { __typename?: 'Mutation', contractsCreate: { __typename?: 'Contract', contractId: string, createdByOrganisationId: number, sentToOrganisationId?: number | null, type: ContractType, name: string, status: ContractStatus } };

export type ContractsGetByIdQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
  skipClauses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ContractsGetByIdQuery = { __typename?: 'Query', contractsGetById?: { __typename?: 'Contract', contractId: string, createdByOrganisationId: number, sentToOrganisationId?: number | null, editableByOrganisationId?: number | null, type: ContractType, name: string, status: ContractStatus, rejectionReason?: string | null, rejectionReasonOption?: string | null, shareRejectionReason?: boolean | null, clauses?: Array<{ __typename?: 'ContractClause', label: string, isAccepted: boolean, isModified: boolean, versions?: { __typename?: 'ContractClauseVersionMap', DRAFT?: { __typename?: 'DraftContractClauseVersion', data?: any | null } | null, PROPOSED?: { __typename?: 'ContractClauseVersion', data?: any | null, createdAt: any, createdByOrganisationId: number } | null, ACCEPTED?: { __typename?: 'ContractClauseVersion', data?: any | null, createdAt: any, createdByOrganisationId: number } | null, REJECTED: Array<{ __typename?: 'ContractClauseVersion', data?: any | null, createdAt: any, createdByOrganisationId: number }> } | null }> } | null };

export type ContractsUpdateClausesMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  details: ContractClausesDetails;
}>;


export type ContractsUpdateClausesMutation = { __typename?: 'Mutation', contractsUpdateClauses: { __typename?: 'StatusResponse', success: boolean } };

export type PlayerTransferContractsGetAllByOrganisationIdQueryVariables = Exact<{
  filter?: InputMaybe<FilterContractsInput>;
}>;


export type PlayerTransferContractsGetAllByOrganisationIdQuery = { __typename?: 'Query', playerTransferContractsGetAllByOrganisationId: Array<{ __typename?: 'PlayerTransferContractSummary', contractId: string, createdByOrganisationId: number, sentToOrganisationId?: number | null, editableByOrganisationId?: number | null, type: ContractType, name: string, status: ContractStatus, playerName?: string | null, transferType?: string | null, acquisitionOffer?: number | null, deposit?: number | null }> };

export type PlayerContractsGetAllByOrganisationIdQueryVariables = Exact<{
  filter?: InputMaybe<FilterContractsInput>;
}>;


export type PlayerContractsGetAllByOrganisationIdQuery = { __typename?: 'Query', playerContractsGetAllByOrganisationId: Array<{ __typename?: 'PlayerContractSummary', contractId: string, createdByOrganisationId: number, sentToOrganisationId?: number | null, editableByOrganisationId?: number | null, type: ContractType, name: string, status: ContractStatus, currency?: string | null, playerName?: string | null, signOnFee?: number | null }> };

export type ContractsSendMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  details: ContractSendDetails;
}>;


export type ContractsSendMutation = { __typename?: 'Mutation', contractsSend: { __typename?: 'StatusResponse', success: boolean } };

export type EnterContractMutationVariables = Exact<{
  inviteToken: Scalars['String']['input'];
}>;


export type EnterContractMutation = { __typename?: 'Mutation', enterContract: { __typename?: 'EnterContractResponse', contract: { __typename?: 'Contract', contractId: string, name: string, createdByOrganisationId: number, sentToOrganisationId?: number | null, status: ContractStatus, type: ContractType } } };

export type ContractsAcceptClauseMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  clauseLabel: Scalars['String']['input'];
}>;


export type ContractsAcceptClauseMutation = { __typename?: 'Mutation', contractsAcceptClause: { __typename?: 'StatusResponse', success: boolean } };

export type ContractsRejectMutationVariables = Exact<{
  contractId: Scalars['ID']['input'];
  rejectionReason: Scalars['String']['input'];
  rejectionReasonOption: Scalars['String']['input'];
  shareRejectionReason?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ContractsRejectMutation = { __typename?: 'Mutation', contractsReject: { __typename?: 'StatusResponse', success: boolean } };

export type PlayerCalculationsCreateMutationVariables = Exact<{
  playerCalculationDetails: PlayerCalculationDetails;
}>;


export type PlayerCalculationsCreateMutation = { __typename?: 'Mutation', playerCalculationsCreate: { __typename?: 'PlayerCalculation', playerCalculationId: string, playerId: number, createdByOrganisationId: number, createdByUserId: number, type: PlayerCalculationType, name: string, arguments: any } };

export type PlayerCalculationsUpdateMutationVariables = Exact<{
  playerCalculationId: Scalars['ID']['input'];
  calculationParams: Scalars['JSON']['input'];
}>;


export type PlayerCalculationsUpdateMutation = { __typename?: 'Mutation', playerCalculationsUpdate: { __typename?: 'PlayerCalculation', playerCalculationId: string, arguments: any } };

export type PlayerCalculationsGetByIdQueryVariables = Exact<{
  playerCalculationId: Scalars['ID']['input'];
}>;


export type PlayerCalculationsGetByIdQuery = { __typename?: 'Query', playerCalculationsGetById?: { __typename?: 'PlayerCalculation', playerCalculationId: string, playerId: number, createdByOrganisationId: number, createdByUserId: number, type: PlayerCalculationType, name: string, arguments: any } | null };

export type GetPlayerCalculationsByOrganisationIdQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type GetPlayerCalculationsByOrganisationIdQuery = { __typename?: 'Query', organisationsGetById?: { __typename?: 'Organisation', playerCalculations: Array<{ __typename?: 'PlayerCalculation', playerCalculationId: string, playerId: number, createdByOrganisationId: number, createdByUserId: number, name: string, type: PlayerCalculationType, arguments: any }> } | null };

export type FinancingApplicationsGetByIdQueryVariables = Exact<{
  applicationId: Scalars['ID']['input'];
}>;


export type FinancingApplicationsGetByIdQuery = { __typename?: 'Query', financingApplicationsGetById: { __typename?: 'Application', applicationId: string, createdByOrganisationId: number, createdByUserId: number, type: ApplicationType, name: string, status: ApplicationStatus, clauses: Array<{ __typename?: 'ApplicationClause', label: string, data?: any | null }> } };

export type FinancingApplicationGetByContractIdQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
}>;


export type FinancingApplicationGetByContractIdQuery = { __typename?: 'Query', financingApplicationGetByContractId?: { __typename?: 'Application', applicationId: string, createdByOrganisationId: number, createdByUserId: number, type: ApplicationType, name: string, status: ApplicationStatus, clauses: Array<{ __typename?: 'ApplicationClause', label: string, data?: any | null }> } | null };

export type FinancingApplicationsGetAllByOrganisationIdQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  filter?: InputMaybe<FinancingApplicationFilter>;
}>;


export type FinancingApplicationsGetAllByOrganisationIdQuery = { __typename?: 'Query', financingApplicationsGetAllByOrganisationId: Array<{ __typename?: 'FinancingApplicationSummary', applicationId: string, createdByOrganisationId: number, createdByUserId: number, type: ApplicationType, name: string, status: ApplicationStatus, createdAt?: any | null, updatedAt?: any | null, dealName?: string | null, grossAmount?: number | null, currency?: string | null, term?: string | null }> };

export type FinancingApplicationsGetAllQueryVariables = Exact<{
  filter?: InputMaybe<FinancingApplicationFilter>;
}>;


export type FinancingApplicationsGetAllQuery = { __typename?: 'Query', financingApplicationsGetAll: Array<{ __typename?: 'FinancingApplicationSummary', applicationId: string, createdByOrganisationId: number, createdByUserId: number, type: ApplicationType, name: string, status: ApplicationStatus, createdAt?: any | null, updatedAt?: any | null, dealName?: string | null, grossAmount?: number | null, currency?: string | null, term?: string | null, organisationName?: string | null }> };

export type FinancingApplicationsGetPaginatedQueryVariables = Exact<{
  pagination: PaginationInput;
  sorting?: InputMaybe<SortInput>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  includeLeagueName?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FinancingApplicationsGetPaginatedQuery = { __typename?: 'Query', financingApplicationsGetPaginated: { __typename?: 'PaginatedFinancingApplications', items: Array<{ __typename?: 'FinancingApplicationSummary', applicationId: string, createdByOrganisationId: number, createdByUserId: number, type: ApplicationType, name: string, status: ApplicationStatus, createdAt?: any | null, updatedAt?: any | null, dealName?: string | null, grossAmount?: number | null, currency?: string | null, term?: string | null, organisationName?: string | null, organisationType?: OrganisationType | null, leagueName?: string | null }>, pagination: { __typename?: 'PaginatedMeta', totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type FinancingApplicationsGetOutsideMandatePaginatedQueryVariables = Exact<{
  pagination: PaginationInput;
  sorting?: InputMaybe<SortInput>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  includeLeagueName?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FinancingApplicationsGetOutsideMandatePaginatedQuery = { __typename?: 'Query', financingApplicationsGetOutsideMandatePaginated: { __typename?: 'PaginatedFinancingApplications', items: Array<{ __typename?: 'FinancingApplicationSummary', applicationId: string, createdByOrganisationId: number, createdByUserId: number, type: ApplicationType, name: string, status: ApplicationStatus, createdAt?: any | null, updatedAt?: any | null, dealName?: string | null, grossAmount?: number | null, currency?: string | null, term?: string | null, organisationName?: string | null, organisationType?: OrganisationType | null, leagueName?: string | null }>, pagination: { __typename?: 'PaginatedMeta', totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type FinancingApplicationsGetByOrganisationIdPaginatedQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  pagination: PaginationInput;
  sorting?: InputMaybe<SortInput>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type FinancingApplicationsGetByOrganisationIdPaginatedQuery = { __typename?: 'Query', financingApplicationsGetByOrganisationIdPaginated: { __typename?: 'PaginatedFinancingApplications', items: Array<{ __typename?: 'FinancingApplicationSummary', applicationId: string, createdByOrganisationId: number, createdByUserId: number, type: ApplicationType, name: string, status: ApplicationStatus, createdAt?: any | null, updatedAt?: any | null, dealName?: string | null, grossAmount?: number | null, currency?: string | null, term?: string | null, organisationName?: string | null }>, pagination: { __typename?: 'PaginatedMeta', totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type FinancingApplicationsGetAllEligableLendersByCriteriaQueryVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  organisationId: Scalars['ID']['input'];
}>;


export type FinancingApplicationsGetAllEligableLendersByCriteriaQuery = { __typename?: 'Query', financingApplicationsGetAllEligableLendersByCriteria: Array<{ __typename?: 'OrganisationFinancierProfile', organisationId: string, privacyPolicyUrl?: string | null }> };

export type FinancingApplicationRequestsGetByIdQueryVariables = Exact<{
  applicationRequestId: Scalars['ID']['input'];
}>;


export type FinancingApplicationRequestsGetByIdQuery = { __typename?: 'Query', financingApplicationRequestsGetById: { __typename?: 'FinancingApplicationRequest', applicationRequestId: string, organisationId: number, applicationId: number, type: ApplicationRequestType, status: ApplicationRequestStatus, isExplicit: boolean, isOutsideRisk: boolean, createdAt?: any | null, updatedAt?: any | null, rejectionReason?: string | null, rejectionReasonOption?: string | null, shareRejectionReason?: boolean | null, application: { __typename?: 'Application', applicationId: string, createdByOrganisationId: number, createdByUserId: number, type: ApplicationType, name: string, status: ApplicationStatus, clauses: Array<{ __typename?: 'ApplicationClause', label: string, data?: any | null }> } } };

export type FinancingApplicationRequestsGetAllByOrganisationIdQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  filter?: InputMaybe<FinancingApplicationRequestFilter>;
}>;


export type FinancingApplicationRequestsGetAllByOrganisationIdQuery = { __typename?: 'Query', financingApplicationRequestsGetAllByOrganisationId: Array<{ __typename?: 'FinancingApplicationRequestSummary', applicationRequestId: string, organisationId: number, applicationId: number, type: ApplicationRequestType, status: ApplicationRequestStatus, isExplicit: boolean, isOutsideRisk: boolean, createdAt?: any | null, updatedAt?: any | null, application: { __typename?: 'FinancingApplicationSummary', applicationId: string, createdByOrganisationId: number, createdByUserId: number, type: ApplicationType, name: string, status: ApplicationStatus, createdAt?: any | null, updatedAt?: any | null, dealName?: string | null, grossAmount?: number | null, currency?: string | null, term?: string | null }, contract?: { __typename?: 'FinancingContractSummary', contractId: string, type: ContractType, name: string, status: ContractStatus, lenderName?: string | null, currency?: string | null, timeToClose?: string | null, netValue?: number | null, allInRate?: number | null, totalCosts?: number | null, legalCost?: number | null } | null }> };

export type FinancingApplicationRequestsGetAllByOrganisationIdPaginatedQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  pagination: PaginationInput;
  sorting?: InputMaybe<SortInput>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type FinancingApplicationRequestsGetAllByOrganisationIdPaginatedQuery = { __typename?: 'Query', financingApplicationRequestsGetAllByOrganisationIdPaginated: { __typename?: 'PaginatedFinancingApplicationRequests', items: Array<{ __typename?: 'FinancingApplicationRequestSummary', applicationRequestId: string, organisationId: number, applicationId: number, type: ApplicationRequestType, status: ApplicationRequestStatus, isExplicit: boolean, isOutsideRisk: boolean, createdAt?: any | null, updatedAt?: any | null, application: { __typename?: 'FinancingApplicationSummary', applicationId: string, createdByOrganisationId: number, createdByUserId: number, type: ApplicationType, name: string, status: ApplicationStatus, createdAt?: any | null, updatedAt?: any | null, dealName?: string | null, grossAmount?: number | null, currency?: string | null, term?: string | null, leagueName?: string | null, organisationType?: OrganisationType | null }, contract?: { __typename?: 'FinancingContractSummary', contractId: string, type: ContractType, name: string, status: ContractStatus, lenderName?: string | null, currency?: string | null, timeToClose?: string | null, netValue?: number | null, allInRate?: number | null, totalCosts?: number | null, legalCost?: number | null } | null }>, pagination: { __typename?: 'PaginatedMeta', totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type FinancingApplicationRequestsForResubmissionGetAllByApplicationIdQueryVariables = Exact<{
  applicationId: Scalars['ID']['input'];
}>;


export type FinancingApplicationRequestsForResubmissionGetAllByApplicationIdQuery = { __typename?: 'Query', financingApplicationRequestsForResubmissionGetAllByApplicationId: Array<{ __typename?: 'FinancingApplicationRequestSummaryLite', applicationRequestId: string, organisationId: number, applicationId: number, type: ApplicationRequestType, status: ApplicationRequestStatus, isExplicit: boolean, isOutsideRisk: boolean, createdAt?: any | null, updatedAt?: any | null }> };

export type FinancingApplicationRequestsAcceptMutationVariables = Exact<{
  applicationRequestId: Scalars['ID']['input'];
}>;


export type FinancingApplicationRequestsAcceptMutation = { __typename?: 'Mutation', financingApplicationRequestsAccept: { __typename?: 'AcceptFinancingApplicationResponse', contractId?: number | null, success: boolean } };

export type FinancingApplicationRequestsRejectMutationVariables = Exact<{
  applicationRequestId: Scalars['ID']['input'];
  rejectionReason: Scalars['String']['input'];
  rejectionReasonOption: Scalars['String']['input'];
  shareRejectionReason: Scalars['Boolean']['input'];
}>;


export type FinancingApplicationRequestsRejectMutation = { __typename?: 'Mutation', financingApplicationRequestsReject: { __typename?: 'StatusResponse', success: boolean } };

export type FinancingApplicationRequestsCreateMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
}>;


export type FinancingApplicationRequestsCreateMutation = { __typename?: 'Mutation', financingApplicationRequestsCreate: { __typename?: 'FinancingApplicationRequest', applicationRequestId: string, organisationId: number, applicationId: number, type: ApplicationRequestType, status: ApplicationRequestStatus, isExplicit: boolean, isOutsideRisk: boolean, createdAt?: any | null, updatedAt?: any | null, application: { __typename?: 'Application', applicationId: string, createdByOrganisationId: number, createdByUserId: number, type: ApplicationType, name: string, status: ApplicationStatus } } };

export type FinancingContractsGetAllByOrganisationIdQueryVariables = Exact<{
  filter?: InputMaybe<FilterContractsInput>;
}>;


export type FinancingContractsGetAllByOrganisationIdQuery = { __typename?: 'Query', financingContractsGetAllByOrganisationId: Array<{ __typename?: 'FinancingContractSummary', contractId: string, createdByOrganisationId: number, sentToOrganisationId?: number | null, editableByOrganisationId?: number | null, type: ContractType, name: string, status: ContractStatus, currency?: string | null, timeToClose?: string | null, netValue?: number | null, allInRate?: number | null, totalCosts?: number | null, legalCost?: number | null }> };

export type FinancingContractsGetAllByApplicationIdQueryVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  filter?: InputMaybe<ContractStatusFilterInput>;
}>;


export type FinancingContractsGetAllByApplicationIdQuery = { __typename?: 'Query', financingContractsGetAllByApplicationId: Array<{ __typename?: 'FinancingContractOrRequestSummary', id: string, sourceType: string, contractId?: string | null, applicationRequestId?: string | null, status: string, lenderName: string, currency?: string | null, timeToClose?: string | null, netValue?: number | null, allInRate?: number | null, totalCosts?: number | null, isExplicitInvite?: boolean | null }> };

export type FinancingApplicationRequestFurtherDetailsGetByIdQueryVariables = Exact<{
  applicationRequestFurtherDetailId: Scalars['Int']['input'];
}>;


export type FinancingApplicationRequestFurtherDetailsGetByIdQuery = { __typename?: 'Query', financingApplicationRequestFurtherDetailsGetById?: { __typename?: 'ApplicationRequestFurtherDetail', applicationRequestFurtherDetailId: number, applicationRequestId: number, status: ApplicationRequestFurtherDetailStatus, createdByOrganisationId: number, createdByUserId: number, sentAt?: string | null, submittedByOrganisationId?: number | null, submittedByUserId?: number | null, submittedAt?: string | null, receivedByUserId?: number | null, receivedAt?: string | null, createdAt: string, fieldsData?: { __typename?: 'ApplicationRequestFurtherDetailFieldsData', fields?: Array<{ __typename?: 'ApplicationRequestFurtherDetailField', id?: string | null, type?: string | null, label?: string | null, description?: string | null, isRequired?: boolean | null }> | null } | null, submissionData?: { __typename?: 'ApplicationRequestFurtherDetailSubmissionData', partialSubmissionReason?: string | null, submissions?: Array<{ __typename?: 'ApplicationRequestFurtherDetailSubmission', fieldId?: string | null, value?: string | null, uploadIds?: Array<number> | null }> | null } | null } | null };

export type FinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdQueryVariables = Exact<{
  applicationRequestId: Scalars['Int']['input'];
}>;


export type FinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdQuery = { __typename?: 'Query', financingApplicationRequestFurtherDetailsGetAllByApplicationRequestId: Array<{ __typename?: 'ApplicationRequestFurtherDetail', applicationRequestFurtherDetailId: number, applicationRequestId: number, status: ApplicationRequestFurtherDetailStatus, createdByOrganisationId: number, createdByUserId: number, sentAt?: string | null, submittedByOrganisationId?: number | null, submittedByUserId?: number | null, submittedAt?: string | null, receivedByUserId?: number | null, receivedAt?: string | null, createdAt: string }> };

export type FinancingApplicationRequestFurtherDetailsGetAllByApplicationIdQueryVariables = Exact<{
  applicationId: Scalars['Int']['input'];
}>;


export type FinancingApplicationRequestFurtherDetailsGetAllByApplicationIdQuery = { __typename?: 'Query', financingApplicationRequestFurtherDetailsGetAllByApplicationId: Array<{ __typename?: 'ApplicationRequestFurtherDetail', applicationRequestFurtherDetailId: number, applicationRequestId: number, status: ApplicationRequestFurtherDetailStatus, createdByOrganisationId: number, createdByUserId: number, sentAt?: string | null, submittedByOrganisationId?: number | null, submittedByUserId?: number | null, submittedAt?: string | null, receivedByUserId?: number | null, receivedAt?: string | null, createdAt: string }> };

export type FinancingApplicationRequestFurtherDetailCreateMutationVariables = Exact<{
  applicationRequestId: Scalars['Int']['input'];
}>;


export type FinancingApplicationRequestFurtherDetailCreateMutation = { __typename?: 'Mutation', financingApplicationRequestFurtherDetailCreate: { __typename?: 'ApplicationRequestFurtherDetail', applicationRequestFurtherDetailId: number, applicationRequestId: number, status: ApplicationRequestFurtherDetailStatus, createdByOrganisationId: number, createdByUserId: number, createdAt: string } };

export type FinancingApplicationRequestFurtherDetailDeleteMutationVariables = Exact<{
  applicationRequestFurtherDetailId: Scalars['Int']['input'];
}>;


export type FinancingApplicationRequestFurtherDetailDeleteMutation = { __typename?: 'Mutation', financingApplicationRequestFurtherDetailDelete: { __typename?: 'StatusResponse', success: boolean } };

export type FinancingApplicationRequestFurtherDetailSendMutationVariables = Exact<{
  applicationRequestFurtherDetailId: Scalars['Int']['input'];
}>;


export type FinancingApplicationRequestFurtherDetailSendMutation = { __typename?: 'Mutation', financingApplicationRequestFurtherDetailSend: { __typename?: 'StatusResponse', success: boolean } };

export type FinancingApplicationRequestFurtherDetailUpdateMutationVariables = Exact<{
  input: UpdateApplicationRequestFurtherDetailInput;
}>;


export type FinancingApplicationRequestFurtherDetailUpdateMutation = { __typename?: 'Mutation', financingApplicationRequestFurtherDetailUpdate: { __typename?: 'StatusResponse', success: boolean } };

export type FinancingApplicationRequestFurtherDetailSubmitMutationVariables = Exact<{
  input: SubmitApplicationRequestFurtherDetailInput;
}>;


export type FinancingApplicationRequestFurtherDetailSubmitMutation = { __typename?: 'Mutation', financingApplicationRequestFurtherDetailSubmit: { __typename?: 'StatusResponse', success: boolean } };

export type FinancingApplicationRequestFurtherDetailConfirmReceiptMutationVariables = Exact<{
  input: ConfirmApplicationRequestFurtherDetailReceiptInput;
}>;


export type FinancingApplicationRequestFurtherDetailConfirmReceiptMutation = { __typename?: 'Mutation', financingApplicationRequestFurtherDetailConfirmReceipt: { __typename?: 'StatusResponse', success: boolean } };

export type GetInviteByTokenQueryVariables = Exact<{
  inviteToken: Scalars['String']['input'];
}>;


export type GetInviteByTokenQuery = { __typename?: 'Query', invitesGetByToken: { __typename?: 'Invite', inviteId: number, token: string, type: InviteType, status: InviteStatus, contract?: any | null, transferDeal?: any | null, user: { __typename?: 'InviteUser', userId?: number | null, email?: string | null, phoneNumber?: string | null, firstName?: string | null, middleName?: string | null, lastName?: string | null }, organisation: { __typename?: 'InviteOrganisation', organisationId?: number | null, type?: OrganisationType | null, licenseType?: LicenseType | null, name?: string | null, address?: string | null, postalCode?: string | null, allowedFinancingTypes?: Array<FinancingType | null> | null, financierType?: FinancierType | null, billing?: { __typename?: 'OrganisationBilling', email?: string | null, phoneNumber?: string | null, firstName?: string | null, lastName?: string | null } | null }, organisationUser?: { __typename?: 'InviteOrganisationUser', role: OrganisationUserRole, permissions?: any | null } | null, club?: { __typename?: 'Club', clubId: string, imageUrl?: string | null, officialName: string } | null, player?: { __typename?: 'Player', playerId: string, firstName: string, lastName: string, middleName?: string | null, imageUrl?: string | null } | null } };

export type InvitesGetAllQueryVariables = Exact<{
  filter?: InputMaybe<FilterInvitesParams>;
}>;


export type InvitesGetAllQuery = { __typename?: 'Query', invitesGetAll: Array<{ __typename?: 'Invite', inviteId: number, token: string, type: InviteType, status: InviteStatus, createdAt?: any | null, lastSent?: any | null, user: { __typename?: 'InviteUser', userId?: number | null, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null }, organisation: { __typename?: 'InviteOrganisation', organisationId?: number | null, type?: OrganisationType | null, licenseType?: LicenseType | null, name?: string | null }, organisationUser?: { __typename?: 'InviteOrganisationUser', role: OrganisationUserRole, permissions?: any | null } | null, requestedBy?: { __typename?: 'InviteRequestedBy', userId?: number | null, organisationId?: number | null } | null }> };

export type InvitesGetPaginatedQueryVariables = Exact<{
  pagination: PaginationInput;
  sorting?: InputMaybe<SortInput>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type InvitesGetPaginatedQuery = { __typename?: 'Query', invitesGetPaginated: { __typename?: 'PaginatedInvites', items: Array<{ __typename?: 'Invite', inviteId: number, token: string, type: InviteType, status: InviteStatus, createdAt?: any | null, user: { __typename?: 'InviteUser', userId?: number | null, email?: string | null, firstName?: string | null, middleName?: string | null, lastName?: string | null, phoneNumber?: string | null }, organisation: { __typename?: 'InviteOrganisation', organisationId?: number | null, type?: OrganisationType | null, licenseType?: LicenseType | null, name?: string | null }, organisationUser?: { __typename?: 'InviteOrganisationUser', role: OrganisationUserRole, permissions?: any | null } | null, requestedBy?: { __typename?: 'InviteRequestedBy', userId?: number | null, organisationId?: number | null } | null, player?: { __typename?: 'Player', playerId: string } | null }>, pagination: { __typename?: 'PaginatedMeta', totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type PlayerTransferContractInvitesGetAllByOrganisationIdQueryVariables = Exact<{
  filter?: InputMaybe<FilterInvitesParams>;
}>;


export type PlayerTransferContractInvitesGetAllByOrganisationIdQuery = { __typename?: 'Query', playerTransferContractInvitesGetAllByOrganisationId: Array<{ __typename?: 'PlayerTransferContractInvite', inviteId: number, type: InviteType, token: string, status: InviteStatus, contract: { __typename?: 'PlayerTransferContractSummary', contractId: string, createdByOrganisationId: number, sentToOrganisationId?: number | null, editableByOrganisationId?: number | null, type: ContractType, name: string, status: ContractStatus, playerName?: string | null, transferType?: string | null, acquisitionOffer?: number | null, deposit?: number | null } }> };

export type PlayerContractInvitesGetAllByOrganisationIdQueryVariables = Exact<{
  filter?: InputMaybe<FilterInvitesParams>;
}>;


export type PlayerContractInvitesGetAllByOrganisationIdQuery = { __typename?: 'Query', playerContractInvitesGetAllByOrganisationId: Array<{ __typename?: 'PlayerContractInvite', inviteId: number, type: InviteType, token: string, status: InviteStatus, contract: { __typename?: 'PlayerContractSummary', contractId: string, createdByOrganisationId: number, sentToOrganisationId?: number | null, editableByOrganisationId?: number | null, type: ContractType, name: string, status: ContractStatus, currency?: string | null, playerName?: string | null, signOnFee?: number | null } }> };

export type FinancingContractInviteGetByOrganisationUserQueryVariables = Exact<{
  filter?: InputMaybe<FilterInvitesParams>;
}>;


export type FinancingContractInviteGetByOrganisationUserQuery = { __typename?: 'Query', financingContractInviteGetByOrganisationUser: { __typename?: 'FinancingContractInvite', inviteId: number, type: InviteType, token: string, status: InviteStatus, contract: { __typename?: 'FinancingContractSummary', contractId: string, createdByOrganisationId: number, sentToOrganisationId?: number | null, editableByOrganisationId?: number | null, type: ContractType, name: string, status: ContractStatus, lenderName?: string | null, currency?: string | null, timeToClose?: string | null, netValue?: number | null, allInRate?: number | null, totalCosts?: number | null } } };

export type InvitesCreateMutationVariables = Exact<{
  inviteId?: InputMaybe<Scalars['Int']['input']>;
  inviteDetails: InviteDetails;
}>;


export type InvitesCreateMutation = { __typename?: 'Mutation', invitesCreate: { __typename?: 'StatusResponse', success: boolean } };

export type InvitesCreateProvisionalMutationVariables = Exact<{
  provisionalInviteDetails: ProvisionalInviteDetails;
}>;


export type InvitesCreateProvisionalMutation = { __typename?: 'Mutation', invitesCreateProvisional: { __typename?: 'StatusResponse', success: boolean } };

export type InvitesResendMutationVariables = Exact<{
  inviteId: Scalars['Int']['input'];
}>;


export type InvitesResendMutation = { __typename?: 'Mutation', invitesResend: { __typename?: 'StatusResponse', success: boolean } };

export type LeagueRulesByIdQueryVariables = Exact<{
  leagueRuleId: Scalars['ID']['input'];
}>;


export type LeagueRulesByIdQuery = { __typename?: 'Query', leagueRulesById?: { __typename?: 'LeagueRules', leagueRuleId: string, financierTypes: Array<FinancierType>, financingTypes: Array<FinancingType>, competitionIds: Array<number>, createdAt?: any | null, updatedAt?: any | null } | null };

export type LeagueRulesGetAllQueryVariables = Exact<{ [key: string]: never; }>;


export type LeagueRulesGetAllQuery = { __typename?: 'Query', leagueRulesGetAll: Array<{ __typename?: 'LeagueRules', leagueRuleId: string, financierTypes: Array<FinancierType>, financingTypes: Array<FinancingType>, competitionIds: Array<number>, createdAt?: any | null, updatedAt?: any | null }> };

export type LeagueRulesCreateMutationVariables = Exact<{
  leagueRules: LeagueRulesInput;
}>;


export type LeagueRulesCreateMutation = { __typename?: 'Mutation', leagueRulesCreate: { __typename?: 'LeagueRules', leagueRuleId: string, financierTypes: Array<FinancierType>, financingTypes: Array<FinancingType>, competitionIds: Array<number>, createdAt?: any | null, updatedAt?: any | null } };

export type LeagueRulesUpdateMutationVariables = Exact<{
  leagueRuleId: Scalars['ID']['input'];
  input: LeagueRulesInput;
}>;


export type LeagueRulesUpdateMutation = { __typename?: 'Mutation', leagueRulesUpdate: { __typename?: 'LeagueRules', leagueRuleId: string, financierTypes: Array<FinancierType>, financingTypes: Array<FinancingType>, competitionIds: Array<number>, createdAt?: any | null, updatedAt?: any | null } };

export type LeagueRulesDeleteMutationVariables = Exact<{
  leagueRuleId: Scalars['ID']['input'];
}>;


export type LeagueRulesDeleteMutation = { __typename?: 'Mutation', leagueRulesDelete: boolean };

export type OnboardUserMutationVariables = Exact<{
  inviteToken: Scalars['String']['input'];
  userDetails: OnboardingUserDetails;
}>;


export type OnboardUserMutation = { __typename?: 'Mutation', onboardUser: { __typename?: 'OnboardUserResponse', accessToken: string, user: { __typename?: 'User', userId: string, username: string, email: string, phoneNumber?: string | null, firstName: string, middleName?: string | null, lastName: string, userType?: UserType | null } } };

export type OnboardOrganisationMutationVariables = Exact<{
  inviteToken: Scalars['String']['input'];
  organisationDetails: OnboardingOrganisationDetails;
}>;


export type OnboardOrganisationMutation = { __typename?: 'Mutation', onboardOrganisation: { __typename?: 'OnboardOrganisationResponse', accessToken: string, organisation: { __typename?: 'Organisation', organisationId: string, type: OrganisationType, licenseType?: LicenseType | null, name: string, address?: string | null, postalCode?: string | null, billing?: { __typename?: 'OrganisationBilling', firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null } | null, club?: { __typename?: 'Club', clubId: string, officialName: string } | null, player?: { __typename?: 'Player', playerId: string, status?: PersonActivityStatus | null, firstName: string, middleName?: string | null, lastName: string, shortName?: string | null } | null } } };

export type EnterOrganisationMutationVariables = Exact<{
  inviteToken: Scalars['String']['input'];
}>;


export type EnterOrganisationMutation = { __typename?: 'Mutation', enterOrganisation: boolean };

export type UsersGetByOrganisationIdQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type UsersGetByOrganisationIdQuery = { __typename?: 'Query', usersGetByOrganisationId?: Array<{ __typename?: 'OrganisationUser', userId: string, username: string, email: string, phoneNumber?: string | null, firstName: string, middleName?: string | null, lastName: string, isEmailVerified: boolean, userType?: UserType | null, createdAt?: string | null, lastLoginAt?: string | null, role: OrganisationUserRole, permissions?: any | null }> | null };

export type OrganisationsUpdateProfileMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  organisationProfileDetails?: InputMaybe<OrganisationProfileDetails>;
}>;


export type OrganisationsUpdateProfileMutation = { __typename?: 'Mutation', organisationsUpdateProfile: { __typename?: 'StatusResponse', success: boolean } };

export type OrganisationsGetAllByQueryQueryVariables = Exact<{
  searchDetails?: InputMaybe<OrganisationsSearchDetails>;
  paginationDetails: PaginationDetails;
}>;


export type OrganisationsGetAllByQueryQuery = { __typename?: 'Query', organisationsGetAllByQuery: Array<{ __typename?: 'Organisation', organisationId: string, name: string, type: OrganisationType, address?: string | null, postalCode?: string | null, countryId?: number | null, createdAt?: string | null, usersCount?: number | null, club?: { __typename?: 'Club', officialName: string } | null }> };

export type OrganisationsUpdateFinancierProfileMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  organisationFinancierProfileDetails?: InputMaybe<OrganisationFinancierProfileDetails>;
}>;


export type OrganisationsUpdateFinancierProfileMutation = { __typename?: 'Mutation', organisationsUpdateFinancierProfile: { __typename?: 'StatusResponse', success: boolean } };

export type OrganisationsGetAllFinanciersQueryVariables = Exact<{
  paginationDetails: PaginationDetails;
}>;


export type OrganisationsGetAllFinanciersQuery = { __typename?: 'Query', organisationsGetAllByQuery: Array<{ __typename?: 'Organisation', organisationId: string, name: string, type: OrganisationType, financierProfile?: { __typename?: 'OrganisationFinancierProfile', financingTypes?: Array<FinancingType> | null, allowedFinancingTypes?: Array<FinancingType> | null, privacyPolicyUrl?: string | null } | null }> };

export type OrganisationsGetFinancierProfileQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type OrganisationsGetFinancierProfileQuery = { __typename?: 'Query', organisationsGetFinancierProfile?: { __typename?: 'OrganisationFinancierProfile', financingTypes?: Array<FinancingType> | null, allowedFinancingTypes?: Array<FinancingType> | null, financierType?: FinancierType | null, privacyPolicyUrl?: string | null, ticketSize?: number | null, criteria?: { __typename?: 'OrganisationFinancierCriteria', groups: Array<{ __typename?: 'OrganisationFinancierCriteriaGroup', financingType?: Array<FinancingType> | null, organisationCountry?: Array<string> | null, organisationCountryInclude?: boolean | null, loanTerm?: Array<string> | null, loanTermInclude?: boolean | null, totalLoanAmount?: { __typename?: 'OrganisationFinancierCriteriaLoanAmount', min?: number | null, max?: number | null, calculationCurrency?: string | null, currency?: Array<string> | null } | null, organisationType?: { __typename?: 'OrganisationFinancierCriteriaOrganisationType', gpe?: boolean | null, club?: { __typename?: 'OrganisationFinancierCriteriaClub', competition?: Array<string> | null, competitionInclude?: boolean | null, country?: Array<string> | null, countryInclude?: boolean | null, debtorRiskCountry?: Array<string> | null, debtorRiskCountryInclude?: boolean | null, blacklistedClubIds?: Array<string> | null } | null } | null }> } | null } | null };

export type OrganisationsGetByCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganisationsGetByCurrentUserQuery = { __typename?: 'Query', organisationsGetByCurrentUser: Array<{ __typename?: 'UserOrganisation', organisationId: string, type: OrganisationType, name: string, role: OrganisationUserRole, permissions?: any | null, isDefault: boolean }> };

export type OrganisationsGetByIdQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type OrganisationsGetByIdQuery = { __typename?: 'Query', organisationsGetById?: { __typename?: 'Organisation', organisationId: string, type: OrganisationType, name: string } | null };

export type FinancingTypeExclusivityQueryVariables = Exact<{
  financingType?: InputMaybe<FinancingType>;
}>;


export type FinancingTypeExclusivityQuery = { __typename?: 'Query', financingTypeExclusivity: Array<{ __typename?: 'FinancingTypeExclusivity', financingType: FinancingType, organisationIds: Array<string> }> };

export type OrganisationsGetPaginatedQueryVariables = Exact<{
  pagination: PaginationInput;
  sorting?: InputMaybe<SortInput>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganisationsGetPaginatedQuery = { __typename?: 'Query', organisationsGetPaginated: { __typename?: 'PaginatedOrganisations', items: Array<{ __typename?: 'Organisation', organisationId: string, name: string, type: OrganisationType, address?: string | null, postalCode?: string | null, countryId?: number | null, createdAt?: string | null, usersCount?: number | null, club?: { __typename?: 'Club', officialName: string } | null }>, pagination: { __typename?: 'PaginatedMeta', totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type FinancingTypeExclusivityGetQueryVariables = Exact<{
  financingType?: InputMaybe<FinancingType>;
}>;


export type FinancingTypeExclusivityGetQuery = { __typename?: 'Query', financingTypeExclusivity: Array<{ __typename?: 'FinancingTypeExclusivity', financingType: FinancingType, organisationIds: Array<string> }> };

export type FinancingTypeExclusivityHasExclusivityQueryVariables = Exact<{
  financingType: FinancingType;
}>;


export type FinancingTypeExclusivityHasExclusivityQuery = { __typename?: 'Query', financingTypeExclusivityHasExclusivity: boolean };

export type FinancingTypeExclusivityGetExclusiveOrganisationIdsQueryVariables = Exact<{
  financingType: FinancingType;
}>;


export type FinancingTypeExclusivityGetExclusiveOrganisationIdsQuery = { __typename?: 'Query', financingTypeExclusivityGetExclusiveOrganisationIds: Array<string> };

export type FinancingTypeExclusivityIsOrganisationExclusiveQueryVariables = Exact<{
  financingType: FinancingType;
  organisationId: Scalars['ID']['input'];
}>;


export type FinancingTypeExclusivityIsOrganisationExclusiveQuery = { __typename?: 'Query', financingTypeExclusivityIsOrganisationExclusive: boolean };

export type FinancingTypeExclusivityGetAllQueryVariables = Exact<{ [key: string]: never; }>;


export type FinancingTypeExclusivityGetAllQuery = { __typename?: 'Query', financingTypeExclusivityGetAll: Array<{ __typename?: 'FinancingTypeExclusivityRule', financingTypeExclusivityId: string, financingType: FinancingType, organisationId: string, isActive: boolean, createdAt: string, updatedAt: string }> };

export type FinancingTypeExclusivityGetGroupedByTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type FinancingTypeExclusivityGetGroupedByTypeQuery = { __typename?: 'Query', financingTypeExclusivityGetGroupedByType: Array<{ __typename?: 'FinancingTypeExclusivity', financingType: FinancingType, organisationIds: Array<string> }> };

export type OrganisationsUpdateFinancingTypeExclusivityMutationVariables = Exact<{
  financingTypes: Array<FinancingType> | FinancingType;
  exclusivityAction: ExclusivityAction;
  organisationIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type OrganisationsUpdateFinancingTypeExclusivityMutation = { __typename?: 'Mutation', organisationsUpdateFinancingTypeExclusivity: { __typename?: 'StatusResponse', success: boolean } };

export type OrganisationsRemoveUserMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type OrganisationsRemoveUserMutation = { __typename?: 'Mutation', organisationsRemoveUser: { __typename?: 'StatusResponse', success: boolean } };

export type PlayersGetAllByNameQueryVariables = Exact<{
  name: Scalars['String']['input'];
  paginationDetails: PaginationDetails;
}>;


export type PlayersGetAllByNameQuery = { __typename?: 'Query', playersGetAllByName: Array<{ __typename?: 'Player', playerId: string, firstName: string, middleName?: string | null, lastName: string, imageUrl?: string | null }> };

export type PlayersGetByIdQueryVariables = Exact<{
  playerId: Scalars['ID']['input'];
}>;


export type PlayersGetByIdQuery = { __typename?: 'Query', playersGetById?: { __typename?: 'Player', playerId: string, firstName: string, middleName?: string | null, lastName: string, imageUrl?: string | null } | null };

export type PlayersWithClubGetByIdQueryVariables = Exact<{
  playerId: Scalars['ID']['input'];
}>;


export type PlayersWithClubGetByIdQuery = { __typename?: 'Query', playersGetById?: { __typename?: 'Player', playerId: string, firstName: string, middleName?: string | null, lastName: string, imageUrl?: string | null, club?: { __typename?: 'PlayerClub', clubId: string, officialName: string, imageUrl?: string | null } | null } | null };

export type PlayersWithDetailsGetByIdQueryVariables = Exact<{
  playerId: Scalars['ID']['input'];
  filter?: InputMaybe<FilterContractsParams>;
  contractsFilter2?: InputMaybe<FilterContractsParams>;
}>;


export type PlayersWithDetailsGetByIdQuery = { __typename?: 'Query', playersGetById?: { __typename?: 'Player', playerId: string, firstName: string, middleName?: string | null, lastName: string, imageUrl?: string | null, organisation?: { __typename?: 'PlayerOrganisation', organisationId: string, type?: OrganisationType | null, name: string, contracts: Array<{ __typename?: 'Contract', contractId: string, createdByOrganisationId: number, sentToOrganisationId?: number | null, type: ContractType, status: ContractStatus }>, users: Array<{ __typename?: 'OrganisationUser', userId: string, email: string, phoneNumber?: string | null, firstName: string, middleName?: string | null, lastName: string, role: OrganisationUserRole }> } | null, club?: { __typename?: 'PlayerClub', clubId: string, officialName: string, imageUrl?: string | null, organisation?: { __typename?: 'ClubOrganisation', organisationId: string, type?: OrganisationType | null, name: string, contracts: Array<{ __typename?: 'Contract', contractId: string, createdByOrganisationId: number, sentToOrganisationId?: number | null, type: ContractType, status: ContractStatus }>, users: Array<{ __typename?: 'OrganisationUser', userId: string, email: string, phoneNumber?: string | null, firstName: string, middleName?: string | null, lastName: string, role: OrganisationUserRole }> } | null } | null } | null };

export type ScopedUsageGetByFilterQueryVariables = Exact<{
  filter: ScopedUsageFilter;
}>;


export type ScopedUsageGetByFilterQuery = { __typename?: 'Query', scopedUsageGetByFilter: Array<{ __typename?: 'ScopedUsage', organisationId?: number | null, parentType: string, parentId: number, resourceType: string, quotaUsed: number, quota?: number | null }> };

export type SessionsGetCurrentQueryVariables = Exact<{ [key: string]: never; }>;


export type SessionsGetCurrentQuery = { __typename?: 'Query', sessionsGetCurrent: { __typename?: 'Session', isAuthenticated: boolean, invite?: { __typename?: 'Invite', inviteId: number, token: string, status: InviteStatus, contract?: any | null, transferDeal?: any | null } | null, user?: { __typename?: 'SessionUser', userId: string, username: string, email: string, phoneNumber?: string | null, firstName: string, middleName?: string | null, lastName: string, isEmailVerified: boolean, userType?: UserType | null } | null, organisation?: { __typename?: 'SessionOrganisation', organisationId: string, type: OrganisationType, licenseType?: LicenseType | null, name: string, countryId?: number | null, address?: string | null, postalCode?: string | null, role: OrganisationUserRole, permissions?: any | null, billing?: { __typename?: 'OrganisationBilling', firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null } | null, club?: { __typename?: 'Club', clubId: string, officialName: string, imageUrl?: string | null } | null } | null } };

export type TransferDealsGetByIdQueryVariables = Exact<{
  transferDealId: Scalars['ID']['input'];
}>;


export type TransferDealsGetByIdQuery = { __typename?: 'Query', transferDealsGetById?: { __typename?: 'TransferDeal', transferDealId: string, buyingClubOrganisationId: number, sellingClubOrganisationId?: number | null, playerOrganisationId?: number | null, playerTransferContractId?: number | null, playerContractId?: number | null, playerTransferContractDueDate: any, playerContractDueDate: any, executionDueDate: any, status: TransferDealStatus, executionCreatedAt?: any | null, executedAt?: any | null, createdAt: any, buyingClubOrganisation?: { __typename?: 'Organisation', users: Array<{ __typename?: 'OrganisationUser', firstName: string, lastName: string, middleName?: string | null, role: OrganisationUserRole }>, club?: { __typename?: 'Club', imageUrl?: string | null } | null } | null, sellingClubOrganisation?: { __typename?: 'Organisation', users: Array<{ __typename?: 'OrganisationUser', firstName: string, lastName: string, middleName?: string | null, role: OrganisationUserRole }>, club?: { __typename?: 'Club', imageUrl?: string | null } | null } | null, playerOrganisation?: { __typename?: 'Organisation', users: Array<{ __typename?: 'OrganisationUser', firstName: string, lastName: string, middleName?: string | null, role: OrganisationUserRole }>, player?: { __typename?: 'Player', imageUrl?: string | null } | null } | null, documents: Array<{ __typename?: 'TransferDealDocument', buyingClubOrganisationAcceptedAt?: any | null, playerOrganisationAcceptedAt?: any | null, sellingClubOrganisationAcceptedAt?: any | null, uploadedByOrganisationId: number }>, playerContract?: { __typename?: 'Contract', contractId: string, createdByOrganisationId: number, sentToOrganisationId?: number | null, type: ContractType, name: string, status: ContractStatus, clauses: Array<{ __typename?: 'ContractClause', label: string, isAccepted: boolean, isModified: boolean, versions?: { __typename?: 'ContractClauseVersionMap', DRAFT?: { __typename?: 'DraftContractClauseVersion', data?: any | null } | null, PROPOSED?: { __typename?: 'ContractClauseVersion', data?: any | null, createdAt: any } | null, ACCEPTED?: { __typename?: 'ContractClauseVersion', data?: any | null, createdAt: any } | null, REJECTED: Array<{ __typename?: 'ContractClauseVersion', data?: any | null, createdAt: any }> } | null }> } | null, playerTransferContract?: { __typename?: 'Contract', contractId: string, createdByOrganisationId: number, sentToOrganisationId?: number | null, type: ContractType, name: string, status: ContractStatus, clauses: Array<{ __typename?: 'ContractClause', label: string, isAccepted: boolean, isModified: boolean, versions?: { __typename?: 'ContractClauseVersionMap', DRAFT?: { __typename?: 'DraftContractClauseVersion', data?: any | null } | null, PROPOSED?: { __typename?: 'ContractClauseVersion', data?: any | null, createdAt: any } | null, ACCEPTED?: { __typename?: 'ContractClauseVersion', data?: any | null, createdAt: any } | null, REJECTED: Array<{ __typename?: 'ContractClauseVersion', data?: any | null, createdAt: any }> } | null }> } | null } | null };

export type TransferDealsEnterExecutionMutationVariables = Exact<{
  transferDealId: Scalars['ID']['input'];
}>;


export type TransferDealsEnterExecutionMutation = { __typename?: 'Mutation', transferDealsEnterExecution: { __typename?: 'TransferDeal', status: TransferDealStatus, executionCreatedAt?: any | null, executedAt?: any | null, createdAt: any } };

export type TransferDealsLinkDocumentMutationVariables = Exact<{
  transferDealId: Scalars['ID']['input'];
  fileDetails: FileDetailsInput;
}>;


export type TransferDealsLinkDocumentMutation = { __typename?: 'Mutation', transferDealsLinkDocument: { __typename?: 'TransferDealDocument', uploadId: number, buyingClubOrganisationAcceptedAt?: any | null, sellingClubOrganisationAcceptedAt?: any | null, playerOrganisationAcceptedAt?: any | null, buyingClubOrganisationViewedAt?: any | null, sellingClubOrganisationViewedAt?: any | null, playerOrganisationViewedAt?: any | null, documentType: DocumentType } };

export type TransferDealsAcceptDocumentMutationVariables = Exact<{
  details: AcceptTransferDealInput;
}>;


export type TransferDealsAcceptDocumentMutation = { __typename?: 'Mutation', transferDealsAcceptDocument: { __typename?: 'StatusResponse', success: boolean } };

export type EnterTransferDealMutationVariables = Exact<{
  inviteToken: Scalars['String']['input'];
}>;


export type EnterTransferDealMutation = { __typename?: 'Mutation', enterTransferDeal: { __typename?: 'EnterTransferDealResponse', transferDeal: { __typename?: 'TransferDeal', transferDealId: string, status: TransferDealStatus } } };

export type TransferDealsSetupMutationVariables = Exact<{
  details: SetupTransferDealInput;
}>;


export type TransferDealsSetupMutation = { __typename?: 'Mutation', transferDealsSetup: { __typename?: 'TransferDeal', transferDealId: string, status: TransferDealStatus } };

export type TransferDealsGetAllByOrganisationIdQueryVariables = Exact<{ [key: string]: never; }>;


export type TransferDealsGetAllByOrganisationIdQuery = { __typename?: 'Query', transferDealsGetAllByOrganisationId: Array<{ __typename?: 'TransferDeal', playerContractId?: number | null, playerTransferContractId?: number | null, transferDealId: string, status: TransferDealStatus, createdAt: any, buyingClubOrganisation?: { __typename?: 'Organisation', name: string } | null, sellingClubOrganisation?: { __typename?: 'Organisation', name: string } | null, playerOrganisation?: { __typename?: 'Organisation', name: string } | null } | null> };

export type TransferDealsGetExecuteQueryVariables = Exact<{
  transferDealId: Scalars['ID']['input'];
}>;


export type TransferDealsGetExecuteQuery = { __typename?: 'Query', transferDealsGetById?: { __typename?: 'TransferDeal', status: TransferDealStatus, buyingClubOrganisation?: { __typename?: 'Organisation', users: Array<{ __typename?: 'OrganisationUser', email: string, firstName: string, lastName: string, middleName?: string | null, phoneNumber?: string | null, role: OrganisationUserRole }> } | null, sellingClubOrganisation?: { __typename?: 'Organisation', users: Array<{ __typename?: 'OrganisationUser', email: string, firstName: string, lastName: string, middleName?: string | null, phoneNumber?: string | null, role: OrganisationUserRole }> } | null, playerOrganisation?: { __typename?: 'Organisation', users: Array<{ __typename?: 'OrganisationUser', firstName: string, lastName: string, middleName?: string | null, phoneNumber?: string | null, role: OrganisationUserRole, email: string }> } | null, documents: Array<{ __typename?: 'TransferDealDocument', mimeType: string, fileName: string, documentType: DocumentType, buyingClubOrganisationViewedAt?: any | null, buyingClubOrganisationAcceptedAt?: any | null, playerOrganisationAcceptedAt?: any | null, playerOrganisationViewedAt?: any | null, sellingClubOrganisationAcceptedAt?: any | null, sellingClubOrganisationViewedAt?: any | null, uploadId: number, uploadedByOrganisationId: number, uploadedByUserId: number }> } | null };

export type TransferDealsExecuteDealMutationVariables = Exact<{
  transferDealId: Scalars['ID']['input'];
}>;


export type TransferDealsExecuteDealMutation = { __typename?: 'Mutation', transferDealsExecuteDeal: { __typename?: 'TransferDeal', status: TransferDealStatus } };

export type UploadsGetPresignedDownloadUrlQueryVariables = Exact<{
  uploadId: Scalars['Int']['input'];
}>;


export type UploadsGetPresignedDownloadUrlQuery = { __typename?: 'Query', uploadsGetPresignedDownloadUrl?: string | null };

export type UploadsCreateMutationVariables = Exact<{
  details: FileDetailsInput;
}>;


export type UploadsCreateMutation = { __typename?: 'Mutation', uploadsCreate: { __typename?: 'Upload', uploadId: number, s3Key: string, fileName: string, mimeType: string } };

export type UploadsGetByIdQueryVariables = Exact<{
  uploadId: Scalars['Int']['input'];
}>;


export type UploadsGetByIdQuery = { __typename?: 'Query', uploadsGetById: { __typename?: 'Upload', uploadId: number, s3Key: string, fileName: string, mimeType: string } };

export type UploadsDeleteMutationVariables = Exact<{
  uploadId: Scalars['Int']['input'];
}>;


export type UploadsDeleteMutation = { __typename?: 'Mutation', uploadsDelete: boolean };

export type UsersGetByIdQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UsersGetByIdQuery = { __typename?: 'Query', usersGetById?: { __typename?: 'User', userId: string, username: string, email: string, phoneNumber?: string | null, firstName: string, middleName?: string | null, lastName: string, userType?: UserType | null, createdAt?: string | null } | null };

export type UsersUpdateProfileMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  userProfileDetails?: InputMaybe<UserProfileDetails>;
}>;


export type UsersUpdateProfileMutation = { __typename?: 'Mutation', usersUpdateProfile: { __typename?: 'StatusResponse', success: boolean } };

export type UsersSetDefaultOrganisationMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type UsersSetDefaultOrganisationMutation = { __typename?: 'Mutation', usersSetDefaultOrganisation: { __typename?: 'StatusResponse', success: boolean } };

export type UsersUpdateLastLoginMutationVariables = Exact<{ [key: string]: never; }>;


export type UsersUpdateLastLoginMutation = { __typename?: 'Mutation', usersUpdateLastLogin: { __typename?: 'StatusResponse', success: boolean } };

export type UsersGetAllQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersGetAllQuery = { __typename?: 'Query', usersGetAll: Array<{ __typename?: 'User', userId: string, username: string, email: string, phoneNumber?: string | null, firstName: string, middleName?: string | null, lastName: string, userType?: UserType | null, createdAt?: string | null, lastLoginAt?: string | null, organisations?: Array<{ __typename?: 'UserOrganisation', organisationId: string, name: string, type: OrganisationType, role: OrganisationUserRole }> | null }> };

export type UsersGetPaginatedQueryVariables = Exact<{
  pagination: PaginationInput;
  sorting?: InputMaybe<SortInput>;
  filters?: InputMaybe<Array<FilterInput> | FilterInput>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type UsersGetPaginatedQuery = { __typename?: 'Query', usersGetPaginated: { __typename?: 'PaginatedUsers', items: Array<{ __typename?: 'User', userId: string, username: string, email: string, phoneNumber?: string | null, firstName: string, middleName?: string | null, lastName: string, userType?: UserType | null, createdAt?: string | null, lastLoginAt?: string | null, organisations?: Array<{ __typename?: 'UserOrganisation', organisationId: string, name: string, type: OrganisationType, role: OrganisationUserRole }> | null }>, pagination: { __typename?: 'PaginatedMeta', totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type UsersVerifyOtpQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersVerifyOtpQuery = { __typename?: 'Query', usersVerifyOTP: { __typename?: 'StatusResponse', success: boolean } };

export type UsersSendPasswordResetEmailMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UsersSendPasswordResetEmailMutation = { __typename?: 'Mutation', usersSendPasswordResetEmail: { __typename?: 'StatusResponse', success: boolean } };


export const ApplicationsCreateDocument = gql`
    mutation ApplicationsCreate($details: ApplicationDetails!) {
  applicationsCreate(details: $details) {
    applicationId
    createdByOrganisationId
    createdByUserId
    type
    name
    status
    clauses {
      data
      label
    }
  }
}
    `;
export type ApplicationsCreateMutationFn = Apollo.MutationFunction<ApplicationsCreateMutation, ApplicationsCreateMutationVariables>;

/**
 * __useApplicationsCreateMutation__
 *
 * To run a mutation, you first call `useApplicationsCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicationsCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicationsCreateMutation, { data, loading, error }] = useApplicationsCreateMutation({
 *   variables: {
 *      details: // value for 'details'
 *   },
 * });
 */
export function useApplicationsCreateMutation(baseOptions?: Apollo.MutationHookOptions<ApplicationsCreateMutation, ApplicationsCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplicationsCreateMutation, ApplicationsCreateMutationVariables>(ApplicationsCreateDocument, options);
      }
export type ApplicationsCreateMutationHookResult = ReturnType<typeof useApplicationsCreateMutation>;
export type ApplicationsCreateMutationResult = Apollo.MutationResult<ApplicationsCreateMutation>;
export type ApplicationsCreateMutationOptions = Apollo.BaseMutationOptions<ApplicationsCreateMutation, ApplicationsCreateMutationVariables>;
export const ApplicationsDeleteDocument = gql`
    mutation ApplicationsDelete($applicationId: ID!) {
  applicationsDelete(applicationId: $applicationId) {
    success
  }
}
    `;
export type ApplicationsDeleteMutationFn = Apollo.MutationFunction<ApplicationsDeleteMutation, ApplicationsDeleteMutationVariables>;

/**
 * __useApplicationsDeleteMutation__
 *
 * To run a mutation, you first call `useApplicationsDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicationsDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicationsDeleteMutation, { data, loading, error }] = useApplicationsDeleteMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useApplicationsDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ApplicationsDeleteMutation, ApplicationsDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplicationsDeleteMutation, ApplicationsDeleteMutationVariables>(ApplicationsDeleteDocument, options);
      }
export type ApplicationsDeleteMutationHookResult = ReturnType<typeof useApplicationsDeleteMutation>;
export type ApplicationsDeleteMutationResult = Apollo.MutationResult<ApplicationsDeleteMutation>;
export type ApplicationsDeleteMutationOptions = Apollo.BaseMutationOptions<ApplicationsDeleteMutation, ApplicationsDeleteMutationVariables>;
export const ApplicationsUpdateClausesDocument = gql`
    mutation ApplicationsUpdateClauses($applicationId: ID!, $details: ApplicationClausesDetails!) {
  applicationsUpdateClauses(applicationId: $applicationId, details: $details) {
    success
  }
}
    `;
export type ApplicationsUpdateClausesMutationFn = Apollo.MutationFunction<ApplicationsUpdateClausesMutation, ApplicationsUpdateClausesMutationVariables>;

/**
 * __useApplicationsUpdateClausesMutation__
 *
 * To run a mutation, you first call `useApplicationsUpdateClausesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicationsUpdateClausesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicationsUpdateClausesMutation, { data, loading, error }] = useApplicationsUpdateClausesMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      details: // value for 'details'
 *   },
 * });
 */
export function useApplicationsUpdateClausesMutation(baseOptions?: Apollo.MutationHookOptions<ApplicationsUpdateClausesMutation, ApplicationsUpdateClausesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplicationsUpdateClausesMutation, ApplicationsUpdateClausesMutationVariables>(ApplicationsUpdateClausesDocument, options);
      }
export type ApplicationsUpdateClausesMutationHookResult = ReturnType<typeof useApplicationsUpdateClausesMutation>;
export type ApplicationsUpdateClausesMutationResult = Apollo.MutationResult<ApplicationsUpdateClausesMutation>;
export type ApplicationsUpdateClausesMutationOptions = Apollo.BaseMutationOptions<ApplicationsUpdateClausesMutation, ApplicationsUpdateClausesMutationVariables>;
export const ApplicationsSubmitDocument = gql`
    mutation ApplicationsSubmit($details: ApplicationSubmitDetails) {
  applicationsSubmit(details: $details) {
    success
  }
}
    `;
export type ApplicationsSubmitMutationFn = Apollo.MutationFunction<ApplicationsSubmitMutation, ApplicationsSubmitMutationVariables>;

/**
 * __useApplicationsSubmitMutation__
 *
 * To run a mutation, you first call `useApplicationsSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicationsSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicationsSubmitMutation, { data, loading, error }] = useApplicationsSubmitMutation({
 *   variables: {
 *      details: // value for 'details'
 *   },
 * });
 */
export function useApplicationsSubmitMutation(baseOptions?: Apollo.MutationHookOptions<ApplicationsSubmitMutation, ApplicationsSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplicationsSubmitMutation, ApplicationsSubmitMutationVariables>(ApplicationsSubmitDocument, options);
      }
export type ApplicationsSubmitMutationHookResult = ReturnType<typeof useApplicationsSubmitMutation>;
export type ApplicationsSubmitMutationResult = Apollo.MutationResult<ApplicationsSubmitMutation>;
export type ApplicationsSubmitMutationOptions = Apollo.BaseMutationOptions<ApplicationsSubmitMutation, ApplicationsSubmitMutationVariables>;
export const ApplicationsUpdateMetadataDocument = gql`
    mutation ApplicationsUpdateMetadata($applicationId: ID!, $details: ApplicationMetadataDetails!) {
  applicationsUpdateMetadata(applicationId: $applicationId, details: $details) {
    success
  }
}
    `;
export type ApplicationsUpdateMetadataMutationFn = Apollo.MutationFunction<ApplicationsUpdateMetadataMutation, ApplicationsUpdateMetadataMutationVariables>;

/**
 * __useApplicationsUpdateMetadataMutation__
 *
 * To run a mutation, you first call `useApplicationsUpdateMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicationsUpdateMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicationsUpdateMetadataMutation, { data, loading, error }] = useApplicationsUpdateMetadataMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      details: // value for 'details'
 *   },
 * });
 */
export function useApplicationsUpdateMetadataMutation(baseOptions?: Apollo.MutationHookOptions<ApplicationsUpdateMetadataMutation, ApplicationsUpdateMetadataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplicationsUpdateMetadataMutation, ApplicationsUpdateMetadataMutationVariables>(ApplicationsUpdateMetadataDocument, options);
      }
export type ApplicationsUpdateMetadataMutationHookResult = ReturnType<typeof useApplicationsUpdateMetadataMutation>;
export type ApplicationsUpdateMetadataMutationResult = Apollo.MutationResult<ApplicationsUpdateMetadataMutation>;
export type ApplicationsUpdateMetadataMutationOptions = Apollo.BaseMutationOptions<ApplicationsUpdateMetadataMutation, ApplicationsUpdateMetadataMutationVariables>;
export const ApplicationsResubmitDocument = gql`
    mutation ApplicationsResubmit($applicationId: ID!) {
  applicationsResubmit(applicationId: $applicationId) {
    applicationId
    createdByOrganisationId
    createdByUserId
    type
    name
    status
    clauses {
      data
      label
    }
  }
}
    `;
export type ApplicationsResubmitMutationFn = Apollo.MutationFunction<ApplicationsResubmitMutation, ApplicationsResubmitMutationVariables>;

/**
 * __useApplicationsResubmitMutation__
 *
 * To run a mutation, you first call `useApplicationsResubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicationsResubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicationsResubmitMutation, { data, loading, error }] = useApplicationsResubmitMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useApplicationsResubmitMutation(baseOptions?: Apollo.MutationHookOptions<ApplicationsResubmitMutation, ApplicationsResubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplicationsResubmitMutation, ApplicationsResubmitMutationVariables>(ApplicationsResubmitDocument, options);
      }
export type ApplicationsResubmitMutationHookResult = ReturnType<typeof useApplicationsResubmitMutation>;
export type ApplicationsResubmitMutationResult = Apollo.MutationResult<ApplicationsResubmitMutation>;
export type ApplicationsResubmitMutationOptions = Apollo.BaseMutationOptions<ApplicationsResubmitMutation, ApplicationsResubmitMutationVariables>;
export const AreasGetByIdDocument = gql`
    query AreasGetById($areaId: ID!) {
  areasGetById(areaId: $areaId) {
    areaId
    name
    alpha2Code
    alpha3Code
  }
}
    `;

/**
 * __useAreasGetByIdQuery__
 *
 * To run a query within a React component, call `useAreasGetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAreasGetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAreasGetByIdQuery({
 *   variables: {
 *      areaId: // value for 'areaId'
 *   },
 * });
 */
export function useAreasGetByIdQuery(baseOptions: Apollo.QueryHookOptions<AreasGetByIdQuery, AreasGetByIdQueryVariables> & ({ variables: AreasGetByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AreasGetByIdQuery, AreasGetByIdQueryVariables>(AreasGetByIdDocument, options);
      }
export function useAreasGetByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AreasGetByIdQuery, AreasGetByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AreasGetByIdQuery, AreasGetByIdQueryVariables>(AreasGetByIdDocument, options);
        }
export function useAreasGetByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AreasGetByIdQuery, AreasGetByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AreasGetByIdQuery, AreasGetByIdQueryVariables>(AreasGetByIdDocument, options);
        }
export type AreasGetByIdQueryHookResult = ReturnType<typeof useAreasGetByIdQuery>;
export type AreasGetByIdLazyQueryHookResult = ReturnType<typeof useAreasGetByIdLazyQuery>;
export type AreasGetByIdSuspenseQueryHookResult = ReturnType<typeof useAreasGetByIdSuspenseQuery>;
export type AreasGetByIdQueryResult = Apollo.QueryResult<AreasGetByIdQuery, AreasGetByIdQueryVariables>;
export const AreasGetAllDocument = gql`
    query AreasGetAll($filter: AreasFilter) {
  areasGetAll(filter: $filter) {
    areaId
    name
    alpha2Code
    alpha3Code
  }
}
    `;

/**
 * __useAreasGetAllQuery__
 *
 * To run a query within a React component, call `useAreasGetAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useAreasGetAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAreasGetAllQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAreasGetAllQuery(baseOptions?: Apollo.QueryHookOptions<AreasGetAllQuery, AreasGetAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AreasGetAllQuery, AreasGetAllQueryVariables>(AreasGetAllDocument, options);
      }
export function useAreasGetAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AreasGetAllQuery, AreasGetAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AreasGetAllQuery, AreasGetAllQueryVariables>(AreasGetAllDocument, options);
        }
export function useAreasGetAllSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AreasGetAllQuery, AreasGetAllQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AreasGetAllQuery, AreasGetAllQueryVariables>(AreasGetAllDocument, options);
        }
export type AreasGetAllQueryHookResult = ReturnType<typeof useAreasGetAllQuery>;
export type AreasGetAllLazyQueryHookResult = ReturnType<typeof useAreasGetAllLazyQuery>;
export type AreasGetAllSuspenseQueryHookResult = ReturnType<typeof useAreasGetAllSuspenseQuery>;
export type AreasGetAllQueryResult = Apollo.QueryResult<AreasGetAllQuery, AreasGetAllQueryVariables>;
export const AreasGetAllByNameDocument = gql`
    query AreasGetAllByName($name: String!, $paginationDetails: PaginationDetails!) {
  areasGetAllByName(name: $name, paginationDetails: $paginationDetails) {
    areaId
    name
    alpha2Code
    alpha3Code
  }
}
    `;

/**
 * __useAreasGetAllByNameQuery__
 *
 * To run a query within a React component, call `useAreasGetAllByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useAreasGetAllByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAreasGetAllByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *      paginationDetails: // value for 'paginationDetails'
 *   },
 * });
 */
export function useAreasGetAllByNameQuery(baseOptions: Apollo.QueryHookOptions<AreasGetAllByNameQuery, AreasGetAllByNameQueryVariables> & ({ variables: AreasGetAllByNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AreasGetAllByNameQuery, AreasGetAllByNameQueryVariables>(AreasGetAllByNameDocument, options);
      }
export function useAreasGetAllByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AreasGetAllByNameQuery, AreasGetAllByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AreasGetAllByNameQuery, AreasGetAllByNameQueryVariables>(AreasGetAllByNameDocument, options);
        }
export function useAreasGetAllByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AreasGetAllByNameQuery, AreasGetAllByNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AreasGetAllByNameQuery, AreasGetAllByNameQueryVariables>(AreasGetAllByNameDocument, options);
        }
export type AreasGetAllByNameQueryHookResult = ReturnType<typeof useAreasGetAllByNameQuery>;
export type AreasGetAllByNameLazyQueryHookResult = ReturnType<typeof useAreasGetAllByNameLazyQuery>;
export type AreasGetAllByNameSuspenseQueryHookResult = ReturnType<typeof useAreasGetAllByNameSuspenseQuery>;
export type AreasGetAllByNameQueryResult = Apollo.QueryResult<AreasGetAllByNameQuery, AreasGetAllByNameQueryVariables>;
export const ClubsGetByIdDocument = gql`
    query ClubsGetById($clubId: ID!) {
  clubsGetById(clubId: $clubId) {
    clubId
    officialName
    imageUrl
    teams {
      teamId
      officialName
      type
    }
    players {
      playerId
      firstName
      middleName
      lastName
      role
      imageUrl
      teams {
        teamId
        type
      }
    }
  }
}
    `;

/**
 * __useClubsGetByIdQuery__
 *
 * To run a query within a React component, call `useClubsGetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useClubsGetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClubsGetByIdQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useClubsGetByIdQuery(baseOptions: Apollo.QueryHookOptions<ClubsGetByIdQuery, ClubsGetByIdQueryVariables> & ({ variables: ClubsGetByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClubsGetByIdQuery, ClubsGetByIdQueryVariables>(ClubsGetByIdDocument, options);
      }
export function useClubsGetByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClubsGetByIdQuery, ClubsGetByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClubsGetByIdQuery, ClubsGetByIdQueryVariables>(ClubsGetByIdDocument, options);
        }
export function useClubsGetByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClubsGetByIdQuery, ClubsGetByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClubsGetByIdQuery, ClubsGetByIdQueryVariables>(ClubsGetByIdDocument, options);
        }
export type ClubsGetByIdQueryHookResult = ReturnType<typeof useClubsGetByIdQuery>;
export type ClubsGetByIdLazyQueryHookResult = ReturnType<typeof useClubsGetByIdLazyQuery>;
export type ClubsGetByIdSuspenseQueryHookResult = ReturnType<typeof useClubsGetByIdSuspenseQuery>;
export type ClubsGetByIdQueryResult = Apollo.QueryResult<ClubsGetByIdQuery, ClubsGetByIdQueryVariables>;
export const ClubsGetAllByOrganisationIdDocument = gql`
    query ClubsGetAllByOrganisationId($organisationId: ID) {
  clubsGetAllByOrganisationId(organisationId: $organisationId) {
    officialName
    clubId
  }
}
    `;

/**
 * __useClubsGetAllByOrganisationIdQuery__
 *
 * To run a query within a React component, call `useClubsGetAllByOrganisationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useClubsGetAllByOrganisationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClubsGetAllByOrganisationIdQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useClubsGetAllByOrganisationIdQuery(baseOptions?: Apollo.QueryHookOptions<ClubsGetAllByOrganisationIdQuery, ClubsGetAllByOrganisationIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClubsGetAllByOrganisationIdQuery, ClubsGetAllByOrganisationIdQueryVariables>(ClubsGetAllByOrganisationIdDocument, options);
      }
export function useClubsGetAllByOrganisationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClubsGetAllByOrganisationIdQuery, ClubsGetAllByOrganisationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClubsGetAllByOrganisationIdQuery, ClubsGetAllByOrganisationIdQueryVariables>(ClubsGetAllByOrganisationIdDocument, options);
        }
export function useClubsGetAllByOrganisationIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClubsGetAllByOrganisationIdQuery, ClubsGetAllByOrganisationIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClubsGetAllByOrganisationIdQuery, ClubsGetAllByOrganisationIdQueryVariables>(ClubsGetAllByOrganisationIdDocument, options);
        }
export type ClubsGetAllByOrganisationIdQueryHookResult = ReturnType<typeof useClubsGetAllByOrganisationIdQuery>;
export type ClubsGetAllByOrganisationIdLazyQueryHookResult = ReturnType<typeof useClubsGetAllByOrganisationIdLazyQuery>;
export type ClubsGetAllByOrganisationIdSuspenseQueryHookResult = ReturnType<typeof useClubsGetAllByOrganisationIdSuspenseQuery>;
export type ClubsGetAllByOrganisationIdQueryResult = Apollo.QueryResult<ClubsGetAllByOrganisationIdQuery, ClubsGetAllByOrganisationIdQueryVariables>;
export const ClubsGetAllByNameDocument = gql`
    query ClubsGetAllByName($name: String!, $paginationDetails: PaginationDetails!) {
  clubsGetAllByName(name: $name, paginationDetails: $paginationDetails) {
    clubId
    officialName
    imageUrl
  }
}
    `;

/**
 * __useClubsGetAllByNameQuery__
 *
 * To run a query within a React component, call `useClubsGetAllByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useClubsGetAllByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClubsGetAllByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *      paginationDetails: // value for 'paginationDetails'
 *   },
 * });
 */
export function useClubsGetAllByNameQuery(baseOptions: Apollo.QueryHookOptions<ClubsGetAllByNameQuery, ClubsGetAllByNameQueryVariables> & ({ variables: ClubsGetAllByNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClubsGetAllByNameQuery, ClubsGetAllByNameQueryVariables>(ClubsGetAllByNameDocument, options);
      }
export function useClubsGetAllByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClubsGetAllByNameQuery, ClubsGetAllByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClubsGetAllByNameQuery, ClubsGetAllByNameQueryVariables>(ClubsGetAllByNameDocument, options);
        }
export function useClubsGetAllByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClubsGetAllByNameQuery, ClubsGetAllByNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClubsGetAllByNameQuery, ClubsGetAllByNameQueryVariables>(ClubsGetAllByNameDocument, options);
        }
export type ClubsGetAllByNameQueryHookResult = ReturnType<typeof useClubsGetAllByNameQuery>;
export type ClubsGetAllByNameLazyQueryHookResult = ReturnType<typeof useClubsGetAllByNameLazyQuery>;
export type ClubsGetAllByNameSuspenseQueryHookResult = ReturnType<typeof useClubsGetAllByNameSuspenseQuery>;
export type ClubsGetAllByNameQueryResult = Apollo.QueryResult<ClubsGetAllByNameQuery, ClubsGetAllByNameQueryVariables>;
export const CompetitionsGetAllByNameDocument = gql`
    query CompetitionsGetAllByName($name: String!, $paginationDetails: PaginationDetails!) {
  competitionsGetAllByName(name: $name, paginationDetails: $paginationDetails) {
    competitionId
    name
    gender
    format
    areaName
  }
}
    `;

/**
 * __useCompetitionsGetAllByNameQuery__
 *
 * To run a query within a React component, call `useCompetitionsGetAllByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompetitionsGetAllByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompetitionsGetAllByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *      paginationDetails: // value for 'paginationDetails'
 *   },
 * });
 */
export function useCompetitionsGetAllByNameQuery(baseOptions: Apollo.QueryHookOptions<CompetitionsGetAllByNameQuery, CompetitionsGetAllByNameQueryVariables> & ({ variables: CompetitionsGetAllByNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompetitionsGetAllByNameQuery, CompetitionsGetAllByNameQueryVariables>(CompetitionsGetAllByNameDocument, options);
      }
export function useCompetitionsGetAllByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompetitionsGetAllByNameQuery, CompetitionsGetAllByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompetitionsGetAllByNameQuery, CompetitionsGetAllByNameQueryVariables>(CompetitionsGetAllByNameDocument, options);
        }
export function useCompetitionsGetAllByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompetitionsGetAllByNameQuery, CompetitionsGetAllByNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompetitionsGetAllByNameQuery, CompetitionsGetAllByNameQueryVariables>(CompetitionsGetAllByNameDocument, options);
        }
export type CompetitionsGetAllByNameQueryHookResult = ReturnType<typeof useCompetitionsGetAllByNameQuery>;
export type CompetitionsGetAllByNameLazyQueryHookResult = ReturnType<typeof useCompetitionsGetAllByNameLazyQuery>;
export type CompetitionsGetAllByNameSuspenseQueryHookResult = ReturnType<typeof useCompetitionsGetAllByNameSuspenseQuery>;
export type CompetitionsGetAllByNameQueryResult = Apollo.QueryResult<CompetitionsGetAllByNameQuery, CompetitionsGetAllByNameQueryVariables>;
export const CompetitionsGetByIdDocument = gql`
    query CompetitionsGetById($competitionId: ID!) {
  competitionsGetById(competitionId: $competitionId) {
    competitionId
    name
    gender
    format
    areaName
  }
}
    `;

/**
 * __useCompetitionsGetByIdQuery__
 *
 * To run a query within a React component, call `useCompetitionsGetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompetitionsGetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompetitionsGetByIdQuery({
 *   variables: {
 *      competitionId: // value for 'competitionId'
 *   },
 * });
 */
export function useCompetitionsGetByIdQuery(baseOptions: Apollo.QueryHookOptions<CompetitionsGetByIdQuery, CompetitionsGetByIdQueryVariables> & ({ variables: CompetitionsGetByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompetitionsGetByIdQuery, CompetitionsGetByIdQueryVariables>(CompetitionsGetByIdDocument, options);
      }
export function useCompetitionsGetByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompetitionsGetByIdQuery, CompetitionsGetByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompetitionsGetByIdQuery, CompetitionsGetByIdQueryVariables>(CompetitionsGetByIdDocument, options);
        }
export function useCompetitionsGetByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompetitionsGetByIdQuery, CompetitionsGetByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompetitionsGetByIdQuery, CompetitionsGetByIdQueryVariables>(CompetitionsGetByIdDocument, options);
        }
export type CompetitionsGetByIdQueryHookResult = ReturnType<typeof useCompetitionsGetByIdQuery>;
export type CompetitionsGetByIdLazyQueryHookResult = ReturnType<typeof useCompetitionsGetByIdLazyQuery>;
export type CompetitionsGetByIdSuspenseQueryHookResult = ReturnType<typeof useCompetitionsGetByIdSuspenseQuery>;
export type CompetitionsGetByIdQueryResult = Apollo.QueryResult<CompetitionsGetByIdQuery, CompetitionsGetByIdQueryVariables>;
export const CompetitionsGetAllDocument = gql`
    query CompetitionsGetALL {
  competitionsGetAll {
    competitionId
    name
    gender
    format
    areaName
  }
}
    `;

/**
 * __useCompetitionsGetAllQuery__
 *
 * To run a query within a React component, call `useCompetitionsGetAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompetitionsGetAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompetitionsGetAllQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompetitionsGetAllQuery(baseOptions?: Apollo.QueryHookOptions<CompetitionsGetAllQuery, CompetitionsGetAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompetitionsGetAllQuery, CompetitionsGetAllQueryVariables>(CompetitionsGetAllDocument, options);
      }
export function useCompetitionsGetAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompetitionsGetAllQuery, CompetitionsGetAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompetitionsGetAllQuery, CompetitionsGetAllQueryVariables>(CompetitionsGetAllDocument, options);
        }
export function useCompetitionsGetAllSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompetitionsGetAllQuery, CompetitionsGetAllQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompetitionsGetAllQuery, CompetitionsGetAllQueryVariables>(CompetitionsGetAllDocument, options);
        }
export type CompetitionsGetAllQueryHookResult = ReturnType<typeof useCompetitionsGetAllQuery>;
export type CompetitionsGetAllLazyQueryHookResult = ReturnType<typeof useCompetitionsGetAllLazyQuery>;
export type CompetitionsGetAllSuspenseQueryHookResult = ReturnType<typeof useCompetitionsGetAllSuspenseQuery>;
export type CompetitionsGetAllQueryResult = Apollo.QueryResult<CompetitionsGetAllQuery, CompetitionsGetAllQueryVariables>;
export const ContractsCreateDocument = gql`
    mutation ContractsCreate($details: ContractDetails!) {
  contractsCreate(details: $details) {
    contractId
    createdByOrganisationId
    sentToOrganisationId
    type
    name
    status
  }
}
    `;
export type ContractsCreateMutationFn = Apollo.MutationFunction<ContractsCreateMutation, ContractsCreateMutationVariables>;

/**
 * __useContractsCreateMutation__
 *
 * To run a mutation, you first call `useContractsCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractsCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractsCreateMutation, { data, loading, error }] = useContractsCreateMutation({
 *   variables: {
 *      details: // value for 'details'
 *   },
 * });
 */
export function useContractsCreateMutation(baseOptions?: Apollo.MutationHookOptions<ContractsCreateMutation, ContractsCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContractsCreateMutation, ContractsCreateMutationVariables>(ContractsCreateDocument, options);
      }
export type ContractsCreateMutationHookResult = ReturnType<typeof useContractsCreateMutation>;
export type ContractsCreateMutationResult = Apollo.MutationResult<ContractsCreateMutation>;
export type ContractsCreateMutationOptions = Apollo.BaseMutationOptions<ContractsCreateMutation, ContractsCreateMutationVariables>;
export const ContractsGetByIdDocument = gql`
    query ContractsGetById($contractId: ID!, $skipClauses: Boolean = false) {
  contractsGetById(contractId: $contractId) {
    contractId
    createdByOrganisationId
    sentToOrganisationId
    editableByOrganisationId
    type
    name
    status
    rejectionReason
    rejectionReasonOption
    shareRejectionReason
    clauses @skip(if: $skipClauses) {
      label
      isAccepted
      isModified
      versions {
        DRAFT {
          data
        }
        PROPOSED {
          data
          createdAt
          createdByOrganisationId
        }
        ACCEPTED {
          data
          createdAt
          createdByOrganisationId
        }
        REJECTED {
          data
          createdAt
          createdByOrganisationId
        }
      }
    }
  }
}
    `;

/**
 * __useContractsGetByIdQuery__
 *
 * To run a query within a React component, call `useContractsGetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractsGetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractsGetByIdQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      skipClauses: // value for 'skipClauses'
 *   },
 * });
 */
export function useContractsGetByIdQuery(baseOptions: Apollo.QueryHookOptions<ContractsGetByIdQuery, ContractsGetByIdQueryVariables> & ({ variables: ContractsGetByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractsGetByIdQuery, ContractsGetByIdQueryVariables>(ContractsGetByIdDocument, options);
      }
export function useContractsGetByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractsGetByIdQuery, ContractsGetByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractsGetByIdQuery, ContractsGetByIdQueryVariables>(ContractsGetByIdDocument, options);
        }
export function useContractsGetByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContractsGetByIdQuery, ContractsGetByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContractsGetByIdQuery, ContractsGetByIdQueryVariables>(ContractsGetByIdDocument, options);
        }
export type ContractsGetByIdQueryHookResult = ReturnType<typeof useContractsGetByIdQuery>;
export type ContractsGetByIdLazyQueryHookResult = ReturnType<typeof useContractsGetByIdLazyQuery>;
export type ContractsGetByIdSuspenseQueryHookResult = ReturnType<typeof useContractsGetByIdSuspenseQuery>;
export type ContractsGetByIdQueryResult = Apollo.QueryResult<ContractsGetByIdQuery, ContractsGetByIdQueryVariables>;
export const ContractsUpdateClausesDocument = gql`
    mutation ContractsUpdateClauses($contractId: ID!, $details: ContractClausesDetails!) {
  contractsUpdateClauses(contractId: $contractId, details: $details) {
    success
  }
}
    `;
export type ContractsUpdateClausesMutationFn = Apollo.MutationFunction<ContractsUpdateClausesMutation, ContractsUpdateClausesMutationVariables>;

/**
 * __useContractsUpdateClausesMutation__
 *
 * To run a mutation, you first call `useContractsUpdateClausesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractsUpdateClausesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractsUpdateClausesMutation, { data, loading, error }] = useContractsUpdateClausesMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      details: // value for 'details'
 *   },
 * });
 */
export function useContractsUpdateClausesMutation(baseOptions?: Apollo.MutationHookOptions<ContractsUpdateClausesMutation, ContractsUpdateClausesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContractsUpdateClausesMutation, ContractsUpdateClausesMutationVariables>(ContractsUpdateClausesDocument, options);
      }
export type ContractsUpdateClausesMutationHookResult = ReturnType<typeof useContractsUpdateClausesMutation>;
export type ContractsUpdateClausesMutationResult = Apollo.MutationResult<ContractsUpdateClausesMutation>;
export type ContractsUpdateClausesMutationOptions = Apollo.BaseMutationOptions<ContractsUpdateClausesMutation, ContractsUpdateClausesMutationVariables>;
export const PlayerTransferContractsGetAllByOrganisationIdDocument = gql`
    query PlayerTransferContractsGetAllByOrganisationId($filter: FilterContractsInput) {
  playerTransferContractsGetAllByOrganisationId(filter: $filter) {
    contractId
    createdByOrganisationId
    sentToOrganisationId
    editableByOrganisationId
    type
    name
    status
    playerName
    transferType
    acquisitionOffer
    deposit
  }
}
    `;

/**
 * __usePlayerTransferContractsGetAllByOrganisationIdQuery__
 *
 * To run a query within a React component, call `usePlayerTransferContractsGetAllByOrganisationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerTransferContractsGetAllByOrganisationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerTransferContractsGetAllByOrganisationIdQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePlayerTransferContractsGetAllByOrganisationIdQuery(baseOptions?: Apollo.QueryHookOptions<PlayerTransferContractsGetAllByOrganisationIdQuery, PlayerTransferContractsGetAllByOrganisationIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerTransferContractsGetAllByOrganisationIdQuery, PlayerTransferContractsGetAllByOrganisationIdQueryVariables>(PlayerTransferContractsGetAllByOrganisationIdDocument, options);
      }
export function usePlayerTransferContractsGetAllByOrganisationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerTransferContractsGetAllByOrganisationIdQuery, PlayerTransferContractsGetAllByOrganisationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerTransferContractsGetAllByOrganisationIdQuery, PlayerTransferContractsGetAllByOrganisationIdQueryVariables>(PlayerTransferContractsGetAllByOrganisationIdDocument, options);
        }
export function usePlayerTransferContractsGetAllByOrganisationIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerTransferContractsGetAllByOrganisationIdQuery, PlayerTransferContractsGetAllByOrganisationIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayerTransferContractsGetAllByOrganisationIdQuery, PlayerTransferContractsGetAllByOrganisationIdQueryVariables>(PlayerTransferContractsGetAllByOrganisationIdDocument, options);
        }
export type PlayerTransferContractsGetAllByOrganisationIdQueryHookResult = ReturnType<typeof usePlayerTransferContractsGetAllByOrganisationIdQuery>;
export type PlayerTransferContractsGetAllByOrganisationIdLazyQueryHookResult = ReturnType<typeof usePlayerTransferContractsGetAllByOrganisationIdLazyQuery>;
export type PlayerTransferContractsGetAllByOrganisationIdSuspenseQueryHookResult = ReturnType<typeof usePlayerTransferContractsGetAllByOrganisationIdSuspenseQuery>;
export type PlayerTransferContractsGetAllByOrganisationIdQueryResult = Apollo.QueryResult<PlayerTransferContractsGetAllByOrganisationIdQuery, PlayerTransferContractsGetAllByOrganisationIdQueryVariables>;
export const PlayerContractsGetAllByOrganisationIdDocument = gql`
    query PlayerContractsGetAllByOrganisationId($filter: FilterContractsInput) {
  playerContractsGetAllByOrganisationId(filter: $filter) {
    contractId
    createdByOrganisationId
    sentToOrganisationId
    editableByOrganisationId
    type
    name
    status
    currency
    playerName
    signOnFee
  }
}
    `;

/**
 * __usePlayerContractsGetAllByOrganisationIdQuery__
 *
 * To run a query within a React component, call `usePlayerContractsGetAllByOrganisationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerContractsGetAllByOrganisationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerContractsGetAllByOrganisationIdQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePlayerContractsGetAllByOrganisationIdQuery(baseOptions?: Apollo.QueryHookOptions<PlayerContractsGetAllByOrganisationIdQuery, PlayerContractsGetAllByOrganisationIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerContractsGetAllByOrganisationIdQuery, PlayerContractsGetAllByOrganisationIdQueryVariables>(PlayerContractsGetAllByOrganisationIdDocument, options);
      }
export function usePlayerContractsGetAllByOrganisationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerContractsGetAllByOrganisationIdQuery, PlayerContractsGetAllByOrganisationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerContractsGetAllByOrganisationIdQuery, PlayerContractsGetAllByOrganisationIdQueryVariables>(PlayerContractsGetAllByOrganisationIdDocument, options);
        }
export function usePlayerContractsGetAllByOrganisationIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerContractsGetAllByOrganisationIdQuery, PlayerContractsGetAllByOrganisationIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayerContractsGetAllByOrganisationIdQuery, PlayerContractsGetAllByOrganisationIdQueryVariables>(PlayerContractsGetAllByOrganisationIdDocument, options);
        }
export type PlayerContractsGetAllByOrganisationIdQueryHookResult = ReturnType<typeof usePlayerContractsGetAllByOrganisationIdQuery>;
export type PlayerContractsGetAllByOrganisationIdLazyQueryHookResult = ReturnType<typeof usePlayerContractsGetAllByOrganisationIdLazyQuery>;
export type PlayerContractsGetAllByOrganisationIdSuspenseQueryHookResult = ReturnType<typeof usePlayerContractsGetAllByOrganisationIdSuspenseQuery>;
export type PlayerContractsGetAllByOrganisationIdQueryResult = Apollo.QueryResult<PlayerContractsGetAllByOrganisationIdQuery, PlayerContractsGetAllByOrganisationIdQueryVariables>;
export const ContractsSendDocument = gql`
    mutation ContractsSend($contractId: ID!, $details: ContractSendDetails!) {
  contractsSend(contractId: $contractId, details: $details) {
    success
  }
}
    `;
export type ContractsSendMutationFn = Apollo.MutationFunction<ContractsSendMutation, ContractsSendMutationVariables>;

/**
 * __useContractsSendMutation__
 *
 * To run a mutation, you first call `useContractsSendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractsSendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractsSendMutation, { data, loading, error }] = useContractsSendMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      details: // value for 'details'
 *   },
 * });
 */
export function useContractsSendMutation(baseOptions?: Apollo.MutationHookOptions<ContractsSendMutation, ContractsSendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContractsSendMutation, ContractsSendMutationVariables>(ContractsSendDocument, options);
      }
export type ContractsSendMutationHookResult = ReturnType<typeof useContractsSendMutation>;
export type ContractsSendMutationResult = Apollo.MutationResult<ContractsSendMutation>;
export type ContractsSendMutationOptions = Apollo.BaseMutationOptions<ContractsSendMutation, ContractsSendMutationVariables>;
export const EnterContractDocument = gql`
    mutation EnterContract($inviteToken: String!) {
  enterContract(inviteToken: $inviteToken) {
    contract {
      contractId
      name
      createdByOrganisationId
      sentToOrganisationId
      status
      type
    }
  }
}
    `;
export type EnterContractMutationFn = Apollo.MutationFunction<EnterContractMutation, EnterContractMutationVariables>;

/**
 * __useEnterContractMutation__
 *
 * To run a mutation, you first call `useEnterContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnterContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enterContractMutation, { data, loading, error }] = useEnterContractMutation({
 *   variables: {
 *      inviteToken: // value for 'inviteToken'
 *   },
 * });
 */
export function useEnterContractMutation(baseOptions?: Apollo.MutationHookOptions<EnterContractMutation, EnterContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnterContractMutation, EnterContractMutationVariables>(EnterContractDocument, options);
      }
export type EnterContractMutationHookResult = ReturnType<typeof useEnterContractMutation>;
export type EnterContractMutationResult = Apollo.MutationResult<EnterContractMutation>;
export type EnterContractMutationOptions = Apollo.BaseMutationOptions<EnterContractMutation, EnterContractMutationVariables>;
export const ContractsAcceptClauseDocument = gql`
    mutation ContractsAcceptClause($contractId: ID!, $clauseLabel: String!) {
  contractsAcceptClause(contractId: $contractId, clauseLabel: $clauseLabel) {
    success
  }
}
    `;
export type ContractsAcceptClauseMutationFn = Apollo.MutationFunction<ContractsAcceptClauseMutation, ContractsAcceptClauseMutationVariables>;

/**
 * __useContractsAcceptClauseMutation__
 *
 * To run a mutation, you first call `useContractsAcceptClauseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractsAcceptClauseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractsAcceptClauseMutation, { data, loading, error }] = useContractsAcceptClauseMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      clauseLabel: // value for 'clauseLabel'
 *   },
 * });
 */
export function useContractsAcceptClauseMutation(baseOptions?: Apollo.MutationHookOptions<ContractsAcceptClauseMutation, ContractsAcceptClauseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContractsAcceptClauseMutation, ContractsAcceptClauseMutationVariables>(ContractsAcceptClauseDocument, options);
      }
export type ContractsAcceptClauseMutationHookResult = ReturnType<typeof useContractsAcceptClauseMutation>;
export type ContractsAcceptClauseMutationResult = Apollo.MutationResult<ContractsAcceptClauseMutation>;
export type ContractsAcceptClauseMutationOptions = Apollo.BaseMutationOptions<ContractsAcceptClauseMutation, ContractsAcceptClauseMutationVariables>;
export const ContractsRejectDocument = gql`
    mutation ContractsReject($contractId: ID!, $rejectionReason: String!, $rejectionReasonOption: String!, $shareRejectionReason: Boolean) {
  contractsReject(
    contractId: $contractId
    rejectionReason: $rejectionReason
    rejectionReasonOption: $rejectionReasonOption
    shareRejectionReason: $shareRejectionReason
  ) {
    success
  }
}
    `;
export type ContractsRejectMutationFn = Apollo.MutationFunction<ContractsRejectMutation, ContractsRejectMutationVariables>;

/**
 * __useContractsRejectMutation__
 *
 * To run a mutation, you first call `useContractsRejectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractsRejectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractsRejectMutation, { data, loading, error }] = useContractsRejectMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      rejectionReason: // value for 'rejectionReason'
 *      rejectionReasonOption: // value for 'rejectionReasonOption'
 *      shareRejectionReason: // value for 'shareRejectionReason'
 *   },
 * });
 */
export function useContractsRejectMutation(baseOptions?: Apollo.MutationHookOptions<ContractsRejectMutation, ContractsRejectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContractsRejectMutation, ContractsRejectMutationVariables>(ContractsRejectDocument, options);
      }
export type ContractsRejectMutationHookResult = ReturnType<typeof useContractsRejectMutation>;
export type ContractsRejectMutationResult = Apollo.MutationResult<ContractsRejectMutation>;
export type ContractsRejectMutationOptions = Apollo.BaseMutationOptions<ContractsRejectMutation, ContractsRejectMutationVariables>;
export const PlayerCalculationsCreateDocument = gql`
    mutation playerCalculationsCreate($playerCalculationDetails: PlayerCalculationDetails!) {
  playerCalculationsCreate(playerCalculationDetails: $playerCalculationDetails) {
    playerCalculationId
    playerId
    createdByOrganisationId
    createdByUserId
    type
    name
    arguments
  }
}
    `;
export type PlayerCalculationsCreateMutationFn = Apollo.MutationFunction<PlayerCalculationsCreateMutation, PlayerCalculationsCreateMutationVariables>;

/**
 * __usePlayerCalculationsCreateMutation__
 *
 * To run a mutation, you first call `usePlayerCalculationsCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlayerCalculationsCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [playerCalculationsCreateMutation, { data, loading, error }] = usePlayerCalculationsCreateMutation({
 *   variables: {
 *      playerCalculationDetails: // value for 'playerCalculationDetails'
 *   },
 * });
 */
export function usePlayerCalculationsCreateMutation(baseOptions?: Apollo.MutationHookOptions<PlayerCalculationsCreateMutation, PlayerCalculationsCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlayerCalculationsCreateMutation, PlayerCalculationsCreateMutationVariables>(PlayerCalculationsCreateDocument, options);
      }
export type PlayerCalculationsCreateMutationHookResult = ReturnType<typeof usePlayerCalculationsCreateMutation>;
export type PlayerCalculationsCreateMutationResult = Apollo.MutationResult<PlayerCalculationsCreateMutation>;
export type PlayerCalculationsCreateMutationOptions = Apollo.BaseMutationOptions<PlayerCalculationsCreateMutation, PlayerCalculationsCreateMutationVariables>;
export const PlayerCalculationsUpdateDocument = gql`
    mutation playerCalculationsUpdate($playerCalculationId: ID!, $calculationParams: JSON!) {
  playerCalculationsUpdate(
    playerCalculationId: $playerCalculationId
    calculationParams: $calculationParams
  ) {
    playerCalculationId
    arguments
  }
}
    `;
export type PlayerCalculationsUpdateMutationFn = Apollo.MutationFunction<PlayerCalculationsUpdateMutation, PlayerCalculationsUpdateMutationVariables>;

/**
 * __usePlayerCalculationsUpdateMutation__
 *
 * To run a mutation, you first call `usePlayerCalculationsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlayerCalculationsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [playerCalculationsUpdateMutation, { data, loading, error }] = usePlayerCalculationsUpdateMutation({
 *   variables: {
 *      playerCalculationId: // value for 'playerCalculationId'
 *      calculationParams: // value for 'calculationParams'
 *   },
 * });
 */
export function usePlayerCalculationsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PlayerCalculationsUpdateMutation, PlayerCalculationsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlayerCalculationsUpdateMutation, PlayerCalculationsUpdateMutationVariables>(PlayerCalculationsUpdateDocument, options);
      }
export type PlayerCalculationsUpdateMutationHookResult = ReturnType<typeof usePlayerCalculationsUpdateMutation>;
export type PlayerCalculationsUpdateMutationResult = Apollo.MutationResult<PlayerCalculationsUpdateMutation>;
export type PlayerCalculationsUpdateMutationOptions = Apollo.BaseMutationOptions<PlayerCalculationsUpdateMutation, PlayerCalculationsUpdateMutationVariables>;
export const PlayerCalculationsGetByIdDocument = gql`
    query playerCalculationsGetById($playerCalculationId: ID!) {
  playerCalculationsGetById(playerCalculationId: $playerCalculationId) {
    playerCalculationId
    playerId
    createdByOrganisationId
    createdByUserId
    type
    name
    arguments
  }
}
    `;

/**
 * __usePlayerCalculationsGetByIdQuery__
 *
 * To run a query within a React component, call `usePlayerCalculationsGetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerCalculationsGetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerCalculationsGetByIdQuery({
 *   variables: {
 *      playerCalculationId: // value for 'playerCalculationId'
 *   },
 * });
 */
export function usePlayerCalculationsGetByIdQuery(baseOptions: Apollo.QueryHookOptions<PlayerCalculationsGetByIdQuery, PlayerCalculationsGetByIdQueryVariables> & ({ variables: PlayerCalculationsGetByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerCalculationsGetByIdQuery, PlayerCalculationsGetByIdQueryVariables>(PlayerCalculationsGetByIdDocument, options);
      }
export function usePlayerCalculationsGetByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerCalculationsGetByIdQuery, PlayerCalculationsGetByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerCalculationsGetByIdQuery, PlayerCalculationsGetByIdQueryVariables>(PlayerCalculationsGetByIdDocument, options);
        }
export function usePlayerCalculationsGetByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerCalculationsGetByIdQuery, PlayerCalculationsGetByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayerCalculationsGetByIdQuery, PlayerCalculationsGetByIdQueryVariables>(PlayerCalculationsGetByIdDocument, options);
        }
export type PlayerCalculationsGetByIdQueryHookResult = ReturnType<typeof usePlayerCalculationsGetByIdQuery>;
export type PlayerCalculationsGetByIdLazyQueryHookResult = ReturnType<typeof usePlayerCalculationsGetByIdLazyQuery>;
export type PlayerCalculationsGetByIdSuspenseQueryHookResult = ReturnType<typeof usePlayerCalculationsGetByIdSuspenseQuery>;
export type PlayerCalculationsGetByIdQueryResult = Apollo.QueryResult<PlayerCalculationsGetByIdQuery, PlayerCalculationsGetByIdQueryVariables>;
export const GetPlayerCalculationsByOrganisationIdDocument = gql`
    query GetPlayerCalculationsByOrganisationId($organisationId: ID!) {
  organisationsGetById(organisationId: $organisationId) {
    playerCalculations {
      playerCalculationId
      playerId
      createdByOrganisationId
      createdByUserId
      name
      type
      arguments
    }
  }
}
    `;

/**
 * __useGetPlayerCalculationsByOrganisationIdQuery__
 *
 * To run a query within a React component, call `useGetPlayerCalculationsByOrganisationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlayerCalculationsByOrganisationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlayerCalculationsByOrganisationIdQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useGetPlayerCalculationsByOrganisationIdQuery(baseOptions: Apollo.QueryHookOptions<GetPlayerCalculationsByOrganisationIdQuery, GetPlayerCalculationsByOrganisationIdQueryVariables> & ({ variables: GetPlayerCalculationsByOrganisationIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlayerCalculationsByOrganisationIdQuery, GetPlayerCalculationsByOrganisationIdQueryVariables>(GetPlayerCalculationsByOrganisationIdDocument, options);
      }
export function useGetPlayerCalculationsByOrganisationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlayerCalculationsByOrganisationIdQuery, GetPlayerCalculationsByOrganisationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlayerCalculationsByOrganisationIdQuery, GetPlayerCalculationsByOrganisationIdQueryVariables>(GetPlayerCalculationsByOrganisationIdDocument, options);
        }
export function useGetPlayerCalculationsByOrganisationIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlayerCalculationsByOrganisationIdQuery, GetPlayerCalculationsByOrganisationIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlayerCalculationsByOrganisationIdQuery, GetPlayerCalculationsByOrganisationIdQueryVariables>(GetPlayerCalculationsByOrganisationIdDocument, options);
        }
export type GetPlayerCalculationsByOrganisationIdQueryHookResult = ReturnType<typeof useGetPlayerCalculationsByOrganisationIdQuery>;
export type GetPlayerCalculationsByOrganisationIdLazyQueryHookResult = ReturnType<typeof useGetPlayerCalculationsByOrganisationIdLazyQuery>;
export type GetPlayerCalculationsByOrganisationIdSuspenseQueryHookResult = ReturnType<typeof useGetPlayerCalculationsByOrganisationIdSuspenseQuery>;
export type GetPlayerCalculationsByOrganisationIdQueryResult = Apollo.QueryResult<GetPlayerCalculationsByOrganisationIdQuery, GetPlayerCalculationsByOrganisationIdQueryVariables>;
export const FinancingApplicationsGetByIdDocument = gql`
    query FinancingApplicationsGetById($applicationId: ID!) {
  financingApplicationsGetById(applicationId: $applicationId) {
    applicationId
    createdByOrganisationId
    createdByUserId
    type
    name
    status
    clauses {
      label
      data
    }
  }
}
    `;

/**
 * __useFinancingApplicationsGetByIdQuery__
 *
 * To run a query within a React component, call `useFinancingApplicationsGetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancingApplicationsGetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancingApplicationsGetByIdQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useFinancingApplicationsGetByIdQuery(baseOptions: Apollo.QueryHookOptions<FinancingApplicationsGetByIdQuery, FinancingApplicationsGetByIdQueryVariables> & ({ variables: FinancingApplicationsGetByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancingApplicationsGetByIdQuery, FinancingApplicationsGetByIdQueryVariables>(FinancingApplicationsGetByIdDocument, options);
      }
export function useFinancingApplicationsGetByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancingApplicationsGetByIdQuery, FinancingApplicationsGetByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancingApplicationsGetByIdQuery, FinancingApplicationsGetByIdQueryVariables>(FinancingApplicationsGetByIdDocument, options);
        }
export function useFinancingApplicationsGetByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinancingApplicationsGetByIdQuery, FinancingApplicationsGetByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinancingApplicationsGetByIdQuery, FinancingApplicationsGetByIdQueryVariables>(FinancingApplicationsGetByIdDocument, options);
        }
export type FinancingApplicationsGetByIdQueryHookResult = ReturnType<typeof useFinancingApplicationsGetByIdQuery>;
export type FinancingApplicationsGetByIdLazyQueryHookResult = ReturnType<typeof useFinancingApplicationsGetByIdLazyQuery>;
export type FinancingApplicationsGetByIdSuspenseQueryHookResult = ReturnType<typeof useFinancingApplicationsGetByIdSuspenseQuery>;
export type FinancingApplicationsGetByIdQueryResult = Apollo.QueryResult<FinancingApplicationsGetByIdQuery, FinancingApplicationsGetByIdQueryVariables>;
export const FinancingApplicationGetByContractIdDocument = gql`
    query FinancingApplicationGetByContractId($contractId: ID!) {
  financingApplicationGetByContractId(contractId: $contractId) {
    applicationId
    createdByOrganisationId
    createdByUserId
    type
    name
    status
    clauses {
      label
      data
    }
  }
}
    `;

/**
 * __useFinancingApplicationGetByContractIdQuery__
 *
 * To run a query within a React component, call `useFinancingApplicationGetByContractIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancingApplicationGetByContractIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancingApplicationGetByContractIdQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useFinancingApplicationGetByContractIdQuery(baseOptions: Apollo.QueryHookOptions<FinancingApplicationGetByContractIdQuery, FinancingApplicationGetByContractIdQueryVariables> & ({ variables: FinancingApplicationGetByContractIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancingApplicationGetByContractIdQuery, FinancingApplicationGetByContractIdQueryVariables>(FinancingApplicationGetByContractIdDocument, options);
      }
export function useFinancingApplicationGetByContractIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancingApplicationGetByContractIdQuery, FinancingApplicationGetByContractIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancingApplicationGetByContractIdQuery, FinancingApplicationGetByContractIdQueryVariables>(FinancingApplicationGetByContractIdDocument, options);
        }
export function useFinancingApplicationGetByContractIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinancingApplicationGetByContractIdQuery, FinancingApplicationGetByContractIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinancingApplicationGetByContractIdQuery, FinancingApplicationGetByContractIdQueryVariables>(FinancingApplicationGetByContractIdDocument, options);
        }
export type FinancingApplicationGetByContractIdQueryHookResult = ReturnType<typeof useFinancingApplicationGetByContractIdQuery>;
export type FinancingApplicationGetByContractIdLazyQueryHookResult = ReturnType<typeof useFinancingApplicationGetByContractIdLazyQuery>;
export type FinancingApplicationGetByContractIdSuspenseQueryHookResult = ReturnType<typeof useFinancingApplicationGetByContractIdSuspenseQuery>;
export type FinancingApplicationGetByContractIdQueryResult = Apollo.QueryResult<FinancingApplicationGetByContractIdQuery, FinancingApplicationGetByContractIdQueryVariables>;
export const FinancingApplicationsGetAllByOrganisationIdDocument = gql`
    query FinancingApplicationsGetAllByOrganisationId($organisationId: ID!, $filter: FinancingApplicationFilter) {
  financingApplicationsGetAllByOrganisationId(
    organisationId: $organisationId
    filter: $filter
  ) {
    applicationId
    createdByOrganisationId
    createdByUserId
    type
    name
    status
    createdAt
    updatedAt
    dealName
    grossAmount
    currency
    term
  }
}
    `;

/**
 * __useFinancingApplicationsGetAllByOrganisationIdQuery__
 *
 * To run a query within a React component, call `useFinancingApplicationsGetAllByOrganisationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancingApplicationsGetAllByOrganisationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancingApplicationsGetAllByOrganisationIdQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFinancingApplicationsGetAllByOrganisationIdQuery(baseOptions: Apollo.QueryHookOptions<FinancingApplicationsGetAllByOrganisationIdQuery, FinancingApplicationsGetAllByOrganisationIdQueryVariables> & ({ variables: FinancingApplicationsGetAllByOrganisationIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancingApplicationsGetAllByOrganisationIdQuery, FinancingApplicationsGetAllByOrganisationIdQueryVariables>(FinancingApplicationsGetAllByOrganisationIdDocument, options);
      }
export function useFinancingApplicationsGetAllByOrganisationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancingApplicationsGetAllByOrganisationIdQuery, FinancingApplicationsGetAllByOrganisationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancingApplicationsGetAllByOrganisationIdQuery, FinancingApplicationsGetAllByOrganisationIdQueryVariables>(FinancingApplicationsGetAllByOrganisationIdDocument, options);
        }
export function useFinancingApplicationsGetAllByOrganisationIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinancingApplicationsGetAllByOrganisationIdQuery, FinancingApplicationsGetAllByOrganisationIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinancingApplicationsGetAllByOrganisationIdQuery, FinancingApplicationsGetAllByOrganisationIdQueryVariables>(FinancingApplicationsGetAllByOrganisationIdDocument, options);
        }
export type FinancingApplicationsGetAllByOrganisationIdQueryHookResult = ReturnType<typeof useFinancingApplicationsGetAllByOrganisationIdQuery>;
export type FinancingApplicationsGetAllByOrganisationIdLazyQueryHookResult = ReturnType<typeof useFinancingApplicationsGetAllByOrganisationIdLazyQuery>;
export type FinancingApplicationsGetAllByOrganisationIdSuspenseQueryHookResult = ReturnType<typeof useFinancingApplicationsGetAllByOrganisationIdSuspenseQuery>;
export type FinancingApplicationsGetAllByOrganisationIdQueryResult = Apollo.QueryResult<FinancingApplicationsGetAllByOrganisationIdQuery, FinancingApplicationsGetAllByOrganisationIdQueryVariables>;
export const FinancingApplicationsGetAllDocument = gql`
    query FinancingApplicationsGetAll($filter: FinancingApplicationFilter) {
  financingApplicationsGetAll(filter: $filter) {
    applicationId
    createdByOrganisationId
    createdByUserId
    type
    name
    status
    createdAt
    updatedAt
    dealName
    grossAmount
    currency
    term
    organisationName
  }
}
    `;

/**
 * __useFinancingApplicationsGetAllQuery__
 *
 * To run a query within a React component, call `useFinancingApplicationsGetAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancingApplicationsGetAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancingApplicationsGetAllQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFinancingApplicationsGetAllQuery(baseOptions?: Apollo.QueryHookOptions<FinancingApplicationsGetAllQuery, FinancingApplicationsGetAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancingApplicationsGetAllQuery, FinancingApplicationsGetAllQueryVariables>(FinancingApplicationsGetAllDocument, options);
      }
export function useFinancingApplicationsGetAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancingApplicationsGetAllQuery, FinancingApplicationsGetAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancingApplicationsGetAllQuery, FinancingApplicationsGetAllQueryVariables>(FinancingApplicationsGetAllDocument, options);
        }
export function useFinancingApplicationsGetAllSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinancingApplicationsGetAllQuery, FinancingApplicationsGetAllQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinancingApplicationsGetAllQuery, FinancingApplicationsGetAllQueryVariables>(FinancingApplicationsGetAllDocument, options);
        }
export type FinancingApplicationsGetAllQueryHookResult = ReturnType<typeof useFinancingApplicationsGetAllQuery>;
export type FinancingApplicationsGetAllLazyQueryHookResult = ReturnType<typeof useFinancingApplicationsGetAllLazyQuery>;
export type FinancingApplicationsGetAllSuspenseQueryHookResult = ReturnType<typeof useFinancingApplicationsGetAllSuspenseQuery>;
export type FinancingApplicationsGetAllQueryResult = Apollo.QueryResult<FinancingApplicationsGetAllQuery, FinancingApplicationsGetAllQueryVariables>;
export const FinancingApplicationsGetPaginatedDocument = gql`
    query FinancingApplicationsGetPaginated($pagination: PaginationInput!, $sorting: SortInput, $filters: [FilterInput!], $search: String, $includeLeagueName: Boolean) {
  financingApplicationsGetPaginated(
    pagination: $pagination
    sorting: $sorting
    filters: $filters
    search: $search
    includeLeagueName: $includeLeagueName
  ) {
    items {
      applicationId
      createdByOrganisationId
      createdByUserId
      type
      name
      status
      createdAt
      updatedAt
      dealName
      grossAmount
      currency
      term
      organisationName
      organisationType
      leagueName
    }
    pagination {
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useFinancingApplicationsGetPaginatedQuery__
 *
 * To run a query within a React component, call `useFinancingApplicationsGetPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancingApplicationsGetPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancingApplicationsGetPaginatedQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sorting: // value for 'sorting'
 *      filters: // value for 'filters'
 *      search: // value for 'search'
 *      includeLeagueName: // value for 'includeLeagueName'
 *   },
 * });
 */
export function useFinancingApplicationsGetPaginatedQuery(baseOptions: Apollo.QueryHookOptions<FinancingApplicationsGetPaginatedQuery, FinancingApplicationsGetPaginatedQueryVariables> & ({ variables: FinancingApplicationsGetPaginatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancingApplicationsGetPaginatedQuery, FinancingApplicationsGetPaginatedQueryVariables>(FinancingApplicationsGetPaginatedDocument, options);
      }
export function useFinancingApplicationsGetPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancingApplicationsGetPaginatedQuery, FinancingApplicationsGetPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancingApplicationsGetPaginatedQuery, FinancingApplicationsGetPaginatedQueryVariables>(FinancingApplicationsGetPaginatedDocument, options);
        }
export function useFinancingApplicationsGetPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinancingApplicationsGetPaginatedQuery, FinancingApplicationsGetPaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinancingApplicationsGetPaginatedQuery, FinancingApplicationsGetPaginatedQueryVariables>(FinancingApplicationsGetPaginatedDocument, options);
        }
export type FinancingApplicationsGetPaginatedQueryHookResult = ReturnType<typeof useFinancingApplicationsGetPaginatedQuery>;
export type FinancingApplicationsGetPaginatedLazyQueryHookResult = ReturnType<typeof useFinancingApplicationsGetPaginatedLazyQuery>;
export type FinancingApplicationsGetPaginatedSuspenseQueryHookResult = ReturnType<typeof useFinancingApplicationsGetPaginatedSuspenseQuery>;
export type FinancingApplicationsGetPaginatedQueryResult = Apollo.QueryResult<FinancingApplicationsGetPaginatedQuery, FinancingApplicationsGetPaginatedQueryVariables>;
export const FinancingApplicationsGetOutsideMandatePaginatedDocument = gql`
    query FinancingApplicationsGetOutsideMandatePaginated($pagination: PaginationInput!, $sorting: SortInput, $filters: [FilterInput!], $search: String, $includeLeagueName: Boolean) {
  financingApplicationsGetOutsideMandatePaginated(
    pagination: $pagination
    sorting: $sorting
    filters: $filters
    search: $search
    includeLeagueName: $includeLeagueName
  ) {
    items {
      applicationId
      createdByOrganisationId
      createdByUserId
      type
      name
      status
      createdAt
      updatedAt
      dealName
      grossAmount
      currency
      term
      organisationName
      organisationType
      leagueName
    }
    pagination {
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useFinancingApplicationsGetOutsideMandatePaginatedQuery__
 *
 * To run a query within a React component, call `useFinancingApplicationsGetOutsideMandatePaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancingApplicationsGetOutsideMandatePaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancingApplicationsGetOutsideMandatePaginatedQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sorting: // value for 'sorting'
 *      filters: // value for 'filters'
 *      search: // value for 'search'
 *      includeLeagueName: // value for 'includeLeagueName'
 *   },
 * });
 */
export function useFinancingApplicationsGetOutsideMandatePaginatedQuery(baseOptions: Apollo.QueryHookOptions<FinancingApplicationsGetOutsideMandatePaginatedQuery, FinancingApplicationsGetOutsideMandatePaginatedQueryVariables> & ({ variables: FinancingApplicationsGetOutsideMandatePaginatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancingApplicationsGetOutsideMandatePaginatedQuery, FinancingApplicationsGetOutsideMandatePaginatedQueryVariables>(FinancingApplicationsGetOutsideMandatePaginatedDocument, options);
      }
export function useFinancingApplicationsGetOutsideMandatePaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancingApplicationsGetOutsideMandatePaginatedQuery, FinancingApplicationsGetOutsideMandatePaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancingApplicationsGetOutsideMandatePaginatedQuery, FinancingApplicationsGetOutsideMandatePaginatedQueryVariables>(FinancingApplicationsGetOutsideMandatePaginatedDocument, options);
        }
export function useFinancingApplicationsGetOutsideMandatePaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinancingApplicationsGetOutsideMandatePaginatedQuery, FinancingApplicationsGetOutsideMandatePaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinancingApplicationsGetOutsideMandatePaginatedQuery, FinancingApplicationsGetOutsideMandatePaginatedQueryVariables>(FinancingApplicationsGetOutsideMandatePaginatedDocument, options);
        }
export type FinancingApplicationsGetOutsideMandatePaginatedQueryHookResult = ReturnType<typeof useFinancingApplicationsGetOutsideMandatePaginatedQuery>;
export type FinancingApplicationsGetOutsideMandatePaginatedLazyQueryHookResult = ReturnType<typeof useFinancingApplicationsGetOutsideMandatePaginatedLazyQuery>;
export type FinancingApplicationsGetOutsideMandatePaginatedSuspenseQueryHookResult = ReturnType<typeof useFinancingApplicationsGetOutsideMandatePaginatedSuspenseQuery>;
export type FinancingApplicationsGetOutsideMandatePaginatedQueryResult = Apollo.QueryResult<FinancingApplicationsGetOutsideMandatePaginatedQuery, FinancingApplicationsGetOutsideMandatePaginatedQueryVariables>;
export const FinancingApplicationsGetByOrganisationIdPaginatedDocument = gql`
    query financingApplicationsGetByOrganisationIdPaginated($organisationId: ID!, $pagination: PaginationInput!, $sorting: SortInput, $filters: [FilterInput!], $search: String) {
  financingApplicationsGetByOrganisationIdPaginated(
    organisationId: $organisationId
    pagination: $pagination
    sorting: $sorting
    filters: $filters
    search: $search
  ) {
    items {
      applicationId
      createdByOrganisationId
      createdByUserId
      type
      name
      status
      createdAt
      updatedAt
      dealName
      grossAmount
      currency
      term
      organisationName
    }
    pagination {
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useFinancingApplicationsGetByOrganisationIdPaginatedQuery__
 *
 * To run a query within a React component, call `useFinancingApplicationsGetByOrganisationIdPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancingApplicationsGetByOrganisationIdPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancingApplicationsGetByOrganisationIdPaginatedQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      pagination: // value for 'pagination'
 *      sorting: // value for 'sorting'
 *      filters: // value for 'filters'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useFinancingApplicationsGetByOrganisationIdPaginatedQuery(baseOptions: Apollo.QueryHookOptions<FinancingApplicationsGetByOrganisationIdPaginatedQuery, FinancingApplicationsGetByOrganisationIdPaginatedQueryVariables> & ({ variables: FinancingApplicationsGetByOrganisationIdPaginatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancingApplicationsGetByOrganisationIdPaginatedQuery, FinancingApplicationsGetByOrganisationIdPaginatedQueryVariables>(FinancingApplicationsGetByOrganisationIdPaginatedDocument, options);
      }
export function useFinancingApplicationsGetByOrganisationIdPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancingApplicationsGetByOrganisationIdPaginatedQuery, FinancingApplicationsGetByOrganisationIdPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancingApplicationsGetByOrganisationIdPaginatedQuery, FinancingApplicationsGetByOrganisationIdPaginatedQueryVariables>(FinancingApplicationsGetByOrganisationIdPaginatedDocument, options);
        }
export function useFinancingApplicationsGetByOrganisationIdPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinancingApplicationsGetByOrganisationIdPaginatedQuery, FinancingApplicationsGetByOrganisationIdPaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinancingApplicationsGetByOrganisationIdPaginatedQuery, FinancingApplicationsGetByOrganisationIdPaginatedQueryVariables>(FinancingApplicationsGetByOrganisationIdPaginatedDocument, options);
        }
export type FinancingApplicationsGetByOrganisationIdPaginatedQueryHookResult = ReturnType<typeof useFinancingApplicationsGetByOrganisationIdPaginatedQuery>;
export type FinancingApplicationsGetByOrganisationIdPaginatedLazyQueryHookResult = ReturnType<typeof useFinancingApplicationsGetByOrganisationIdPaginatedLazyQuery>;
export type FinancingApplicationsGetByOrganisationIdPaginatedSuspenseQueryHookResult = ReturnType<typeof useFinancingApplicationsGetByOrganisationIdPaginatedSuspenseQuery>;
export type FinancingApplicationsGetByOrganisationIdPaginatedQueryResult = Apollo.QueryResult<FinancingApplicationsGetByOrganisationIdPaginatedQuery, FinancingApplicationsGetByOrganisationIdPaginatedQueryVariables>;
export const FinancingApplicationsGetAllEligableLendersByCriteriaDocument = gql`
    query FinancingApplicationsGetAllEligableLendersByCriteria($applicationId: ID!, $organisationId: ID!) {
  financingApplicationsGetAllEligableLendersByCriteria(
    applicationId: $applicationId
    organisationId: $organisationId
  ) {
    organisationId
    privacyPolicyUrl
  }
}
    `;

/**
 * __useFinancingApplicationsGetAllEligableLendersByCriteriaQuery__
 *
 * To run a query within a React component, call `useFinancingApplicationsGetAllEligableLendersByCriteriaQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancingApplicationsGetAllEligableLendersByCriteriaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancingApplicationsGetAllEligableLendersByCriteriaQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useFinancingApplicationsGetAllEligableLendersByCriteriaQuery(baseOptions: Apollo.QueryHookOptions<FinancingApplicationsGetAllEligableLendersByCriteriaQuery, FinancingApplicationsGetAllEligableLendersByCriteriaQueryVariables> & ({ variables: FinancingApplicationsGetAllEligableLendersByCriteriaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancingApplicationsGetAllEligableLendersByCriteriaQuery, FinancingApplicationsGetAllEligableLendersByCriteriaQueryVariables>(FinancingApplicationsGetAllEligableLendersByCriteriaDocument, options);
      }
export function useFinancingApplicationsGetAllEligableLendersByCriteriaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancingApplicationsGetAllEligableLendersByCriteriaQuery, FinancingApplicationsGetAllEligableLendersByCriteriaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancingApplicationsGetAllEligableLendersByCriteriaQuery, FinancingApplicationsGetAllEligableLendersByCriteriaQueryVariables>(FinancingApplicationsGetAllEligableLendersByCriteriaDocument, options);
        }
export function useFinancingApplicationsGetAllEligableLendersByCriteriaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinancingApplicationsGetAllEligableLendersByCriteriaQuery, FinancingApplicationsGetAllEligableLendersByCriteriaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinancingApplicationsGetAllEligableLendersByCriteriaQuery, FinancingApplicationsGetAllEligableLendersByCriteriaQueryVariables>(FinancingApplicationsGetAllEligableLendersByCriteriaDocument, options);
        }
export type FinancingApplicationsGetAllEligableLendersByCriteriaQueryHookResult = ReturnType<typeof useFinancingApplicationsGetAllEligableLendersByCriteriaQuery>;
export type FinancingApplicationsGetAllEligableLendersByCriteriaLazyQueryHookResult = ReturnType<typeof useFinancingApplicationsGetAllEligableLendersByCriteriaLazyQuery>;
export type FinancingApplicationsGetAllEligableLendersByCriteriaSuspenseQueryHookResult = ReturnType<typeof useFinancingApplicationsGetAllEligableLendersByCriteriaSuspenseQuery>;
export type FinancingApplicationsGetAllEligableLendersByCriteriaQueryResult = Apollo.QueryResult<FinancingApplicationsGetAllEligableLendersByCriteriaQuery, FinancingApplicationsGetAllEligableLendersByCriteriaQueryVariables>;
export const FinancingApplicationRequestsGetByIdDocument = gql`
    query FinancingApplicationRequestsGetById($applicationRequestId: ID!) {
  financingApplicationRequestsGetById(applicationRequestId: $applicationRequestId) {
    applicationRequestId
    organisationId
    applicationId
    type
    status
    isExplicit
    isOutsideRisk
    createdAt
    updatedAt
    rejectionReason
    rejectionReasonOption
    shareRejectionReason
    application {
      applicationId
      createdByOrganisationId
      createdByUserId
      type
      name
      status
      clauses {
        label
        data
      }
    }
  }
}
    `;

/**
 * __useFinancingApplicationRequestsGetByIdQuery__
 *
 * To run a query within a React component, call `useFinancingApplicationRequestsGetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancingApplicationRequestsGetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancingApplicationRequestsGetByIdQuery({
 *   variables: {
 *      applicationRequestId: // value for 'applicationRequestId'
 *   },
 * });
 */
export function useFinancingApplicationRequestsGetByIdQuery(baseOptions: Apollo.QueryHookOptions<FinancingApplicationRequestsGetByIdQuery, FinancingApplicationRequestsGetByIdQueryVariables> & ({ variables: FinancingApplicationRequestsGetByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancingApplicationRequestsGetByIdQuery, FinancingApplicationRequestsGetByIdQueryVariables>(FinancingApplicationRequestsGetByIdDocument, options);
      }
export function useFinancingApplicationRequestsGetByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancingApplicationRequestsGetByIdQuery, FinancingApplicationRequestsGetByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancingApplicationRequestsGetByIdQuery, FinancingApplicationRequestsGetByIdQueryVariables>(FinancingApplicationRequestsGetByIdDocument, options);
        }
export function useFinancingApplicationRequestsGetByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinancingApplicationRequestsGetByIdQuery, FinancingApplicationRequestsGetByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinancingApplicationRequestsGetByIdQuery, FinancingApplicationRequestsGetByIdQueryVariables>(FinancingApplicationRequestsGetByIdDocument, options);
        }
export type FinancingApplicationRequestsGetByIdQueryHookResult = ReturnType<typeof useFinancingApplicationRequestsGetByIdQuery>;
export type FinancingApplicationRequestsGetByIdLazyQueryHookResult = ReturnType<typeof useFinancingApplicationRequestsGetByIdLazyQuery>;
export type FinancingApplicationRequestsGetByIdSuspenseQueryHookResult = ReturnType<typeof useFinancingApplicationRequestsGetByIdSuspenseQuery>;
export type FinancingApplicationRequestsGetByIdQueryResult = Apollo.QueryResult<FinancingApplicationRequestsGetByIdQuery, FinancingApplicationRequestsGetByIdQueryVariables>;
export const FinancingApplicationRequestsGetAllByOrganisationIdDocument = gql`
    query FinancingApplicationRequestsGetAllByOrganisationId($organisationId: ID!, $filter: FinancingApplicationRequestFilter) {
  financingApplicationRequestsGetAllByOrganisationId(
    organisationId: $organisationId
    filter: $filter
  ) {
    applicationRequestId
    organisationId
    applicationId
    type
    status
    isExplicit
    isOutsideRisk
    createdAt
    updatedAt
    application {
      applicationId
      createdByOrganisationId
      createdByUserId
      type
      name
      status
      createdAt
      updatedAt
      dealName
      grossAmount
      currency
      term
    }
    contract {
      contractId
      type
      name
      status
      lenderName
      currency
      timeToClose
      netValue
      allInRate
      totalCosts
      legalCost
    }
  }
}
    `;

/**
 * __useFinancingApplicationRequestsGetAllByOrganisationIdQuery__
 *
 * To run a query within a React component, call `useFinancingApplicationRequestsGetAllByOrganisationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancingApplicationRequestsGetAllByOrganisationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancingApplicationRequestsGetAllByOrganisationIdQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFinancingApplicationRequestsGetAllByOrganisationIdQuery(baseOptions: Apollo.QueryHookOptions<FinancingApplicationRequestsGetAllByOrganisationIdQuery, FinancingApplicationRequestsGetAllByOrganisationIdQueryVariables> & ({ variables: FinancingApplicationRequestsGetAllByOrganisationIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancingApplicationRequestsGetAllByOrganisationIdQuery, FinancingApplicationRequestsGetAllByOrganisationIdQueryVariables>(FinancingApplicationRequestsGetAllByOrganisationIdDocument, options);
      }
export function useFinancingApplicationRequestsGetAllByOrganisationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancingApplicationRequestsGetAllByOrganisationIdQuery, FinancingApplicationRequestsGetAllByOrganisationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancingApplicationRequestsGetAllByOrganisationIdQuery, FinancingApplicationRequestsGetAllByOrganisationIdQueryVariables>(FinancingApplicationRequestsGetAllByOrganisationIdDocument, options);
        }
export function useFinancingApplicationRequestsGetAllByOrganisationIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinancingApplicationRequestsGetAllByOrganisationIdQuery, FinancingApplicationRequestsGetAllByOrganisationIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinancingApplicationRequestsGetAllByOrganisationIdQuery, FinancingApplicationRequestsGetAllByOrganisationIdQueryVariables>(FinancingApplicationRequestsGetAllByOrganisationIdDocument, options);
        }
export type FinancingApplicationRequestsGetAllByOrganisationIdQueryHookResult = ReturnType<typeof useFinancingApplicationRequestsGetAllByOrganisationIdQuery>;
export type FinancingApplicationRequestsGetAllByOrganisationIdLazyQueryHookResult = ReturnType<typeof useFinancingApplicationRequestsGetAllByOrganisationIdLazyQuery>;
export type FinancingApplicationRequestsGetAllByOrganisationIdSuspenseQueryHookResult = ReturnType<typeof useFinancingApplicationRequestsGetAllByOrganisationIdSuspenseQuery>;
export type FinancingApplicationRequestsGetAllByOrganisationIdQueryResult = Apollo.QueryResult<FinancingApplicationRequestsGetAllByOrganisationIdQuery, FinancingApplicationRequestsGetAllByOrganisationIdQueryVariables>;
export const FinancingApplicationRequestsGetAllByOrganisationIdPaginatedDocument = gql`
    query FinancingApplicationRequestsGetAllByOrganisationIdPaginated($organisationId: ID!, $pagination: PaginationInput!, $sorting: SortInput, $filters: [FilterInput!], $search: String) {
  financingApplicationRequestsGetAllByOrganisationIdPaginated(
    organisationId: $organisationId
    pagination: $pagination
    sorting: $sorting
    filters: $filters
    search: $search
  ) {
    items {
      applicationRequestId
      organisationId
      applicationId
      type
      status
      isExplicit
      isOutsideRisk
      createdAt
      updatedAt
      application {
        applicationId
        createdByOrganisationId
        createdByUserId
        type
        name
        status
        createdAt
        updatedAt
        dealName
        grossAmount
        currency
        term
        leagueName
        organisationType
      }
      contract {
        contractId
        type
        name
        status
        lenderName
        currency
        timeToClose
        netValue
        allInRate
        totalCosts
        legalCost
      }
    }
    pagination {
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useFinancingApplicationRequestsGetAllByOrganisationIdPaginatedQuery__
 *
 * To run a query within a React component, call `useFinancingApplicationRequestsGetAllByOrganisationIdPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancingApplicationRequestsGetAllByOrganisationIdPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancingApplicationRequestsGetAllByOrganisationIdPaginatedQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      pagination: // value for 'pagination'
 *      sorting: // value for 'sorting'
 *      filters: // value for 'filters'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useFinancingApplicationRequestsGetAllByOrganisationIdPaginatedQuery(baseOptions: Apollo.QueryHookOptions<FinancingApplicationRequestsGetAllByOrganisationIdPaginatedQuery, FinancingApplicationRequestsGetAllByOrganisationIdPaginatedQueryVariables> & ({ variables: FinancingApplicationRequestsGetAllByOrganisationIdPaginatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancingApplicationRequestsGetAllByOrganisationIdPaginatedQuery, FinancingApplicationRequestsGetAllByOrganisationIdPaginatedQueryVariables>(FinancingApplicationRequestsGetAllByOrganisationIdPaginatedDocument, options);
      }
export function useFinancingApplicationRequestsGetAllByOrganisationIdPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancingApplicationRequestsGetAllByOrganisationIdPaginatedQuery, FinancingApplicationRequestsGetAllByOrganisationIdPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancingApplicationRequestsGetAllByOrganisationIdPaginatedQuery, FinancingApplicationRequestsGetAllByOrganisationIdPaginatedQueryVariables>(FinancingApplicationRequestsGetAllByOrganisationIdPaginatedDocument, options);
        }
export function useFinancingApplicationRequestsGetAllByOrganisationIdPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinancingApplicationRequestsGetAllByOrganisationIdPaginatedQuery, FinancingApplicationRequestsGetAllByOrganisationIdPaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinancingApplicationRequestsGetAllByOrganisationIdPaginatedQuery, FinancingApplicationRequestsGetAllByOrganisationIdPaginatedQueryVariables>(FinancingApplicationRequestsGetAllByOrganisationIdPaginatedDocument, options);
        }
export type FinancingApplicationRequestsGetAllByOrganisationIdPaginatedQueryHookResult = ReturnType<typeof useFinancingApplicationRequestsGetAllByOrganisationIdPaginatedQuery>;
export type FinancingApplicationRequestsGetAllByOrganisationIdPaginatedLazyQueryHookResult = ReturnType<typeof useFinancingApplicationRequestsGetAllByOrganisationIdPaginatedLazyQuery>;
export type FinancingApplicationRequestsGetAllByOrganisationIdPaginatedSuspenseQueryHookResult = ReturnType<typeof useFinancingApplicationRequestsGetAllByOrganisationIdPaginatedSuspenseQuery>;
export type FinancingApplicationRequestsGetAllByOrganisationIdPaginatedQueryResult = Apollo.QueryResult<FinancingApplicationRequestsGetAllByOrganisationIdPaginatedQuery, FinancingApplicationRequestsGetAllByOrganisationIdPaginatedQueryVariables>;
export const FinancingApplicationRequestsForResubmissionGetAllByApplicationIdDocument = gql`
    query FinancingApplicationRequestsForResubmissionGetAllByApplicationId($applicationId: ID!) {
  financingApplicationRequestsForResubmissionGetAllByApplicationId(
    applicationId: $applicationId
  ) {
    applicationRequestId
    organisationId
    applicationId
    type
    status
    isExplicit
    isOutsideRisk
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useFinancingApplicationRequestsForResubmissionGetAllByApplicationIdQuery__
 *
 * To run a query within a React component, call `useFinancingApplicationRequestsForResubmissionGetAllByApplicationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancingApplicationRequestsForResubmissionGetAllByApplicationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancingApplicationRequestsForResubmissionGetAllByApplicationIdQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useFinancingApplicationRequestsForResubmissionGetAllByApplicationIdQuery(baseOptions: Apollo.QueryHookOptions<FinancingApplicationRequestsForResubmissionGetAllByApplicationIdQuery, FinancingApplicationRequestsForResubmissionGetAllByApplicationIdQueryVariables> & ({ variables: FinancingApplicationRequestsForResubmissionGetAllByApplicationIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancingApplicationRequestsForResubmissionGetAllByApplicationIdQuery, FinancingApplicationRequestsForResubmissionGetAllByApplicationIdQueryVariables>(FinancingApplicationRequestsForResubmissionGetAllByApplicationIdDocument, options);
      }
export function useFinancingApplicationRequestsForResubmissionGetAllByApplicationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancingApplicationRequestsForResubmissionGetAllByApplicationIdQuery, FinancingApplicationRequestsForResubmissionGetAllByApplicationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancingApplicationRequestsForResubmissionGetAllByApplicationIdQuery, FinancingApplicationRequestsForResubmissionGetAllByApplicationIdQueryVariables>(FinancingApplicationRequestsForResubmissionGetAllByApplicationIdDocument, options);
        }
export function useFinancingApplicationRequestsForResubmissionGetAllByApplicationIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinancingApplicationRequestsForResubmissionGetAllByApplicationIdQuery, FinancingApplicationRequestsForResubmissionGetAllByApplicationIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinancingApplicationRequestsForResubmissionGetAllByApplicationIdQuery, FinancingApplicationRequestsForResubmissionGetAllByApplicationIdQueryVariables>(FinancingApplicationRequestsForResubmissionGetAllByApplicationIdDocument, options);
        }
export type FinancingApplicationRequestsForResubmissionGetAllByApplicationIdQueryHookResult = ReturnType<typeof useFinancingApplicationRequestsForResubmissionGetAllByApplicationIdQuery>;
export type FinancingApplicationRequestsForResubmissionGetAllByApplicationIdLazyQueryHookResult = ReturnType<typeof useFinancingApplicationRequestsForResubmissionGetAllByApplicationIdLazyQuery>;
export type FinancingApplicationRequestsForResubmissionGetAllByApplicationIdSuspenseQueryHookResult = ReturnType<typeof useFinancingApplicationRequestsForResubmissionGetAllByApplicationIdSuspenseQuery>;
export type FinancingApplicationRequestsForResubmissionGetAllByApplicationIdQueryResult = Apollo.QueryResult<FinancingApplicationRequestsForResubmissionGetAllByApplicationIdQuery, FinancingApplicationRequestsForResubmissionGetAllByApplicationIdQueryVariables>;
export const FinancingApplicationRequestsAcceptDocument = gql`
    mutation FinancingApplicationRequestsAccept($applicationRequestId: ID!) {
  financingApplicationRequestsAccept(applicationRequestId: $applicationRequestId) {
    contractId
    success
  }
}
    `;
export type FinancingApplicationRequestsAcceptMutationFn = Apollo.MutationFunction<FinancingApplicationRequestsAcceptMutation, FinancingApplicationRequestsAcceptMutationVariables>;

/**
 * __useFinancingApplicationRequestsAcceptMutation__
 *
 * To run a mutation, you first call `useFinancingApplicationRequestsAcceptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinancingApplicationRequestsAcceptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [financingApplicationRequestsAcceptMutation, { data, loading, error }] = useFinancingApplicationRequestsAcceptMutation({
 *   variables: {
 *      applicationRequestId: // value for 'applicationRequestId'
 *   },
 * });
 */
export function useFinancingApplicationRequestsAcceptMutation(baseOptions?: Apollo.MutationHookOptions<FinancingApplicationRequestsAcceptMutation, FinancingApplicationRequestsAcceptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinancingApplicationRequestsAcceptMutation, FinancingApplicationRequestsAcceptMutationVariables>(FinancingApplicationRequestsAcceptDocument, options);
      }
export type FinancingApplicationRequestsAcceptMutationHookResult = ReturnType<typeof useFinancingApplicationRequestsAcceptMutation>;
export type FinancingApplicationRequestsAcceptMutationResult = Apollo.MutationResult<FinancingApplicationRequestsAcceptMutation>;
export type FinancingApplicationRequestsAcceptMutationOptions = Apollo.BaseMutationOptions<FinancingApplicationRequestsAcceptMutation, FinancingApplicationRequestsAcceptMutationVariables>;
export const FinancingApplicationRequestsRejectDocument = gql`
    mutation FinancingApplicationRequestsReject($applicationRequestId: ID!, $rejectionReason: String!, $rejectionReasonOption: String!, $shareRejectionReason: Boolean!) {
  financingApplicationRequestsReject(
    applicationRequestId: $applicationRequestId
    rejectionReason: $rejectionReason
    rejectionReasonOption: $rejectionReasonOption
    shareRejectionReason: $shareRejectionReason
  ) {
    success
  }
}
    `;
export type FinancingApplicationRequestsRejectMutationFn = Apollo.MutationFunction<FinancingApplicationRequestsRejectMutation, FinancingApplicationRequestsRejectMutationVariables>;

/**
 * __useFinancingApplicationRequestsRejectMutation__
 *
 * To run a mutation, you first call `useFinancingApplicationRequestsRejectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinancingApplicationRequestsRejectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [financingApplicationRequestsRejectMutation, { data, loading, error }] = useFinancingApplicationRequestsRejectMutation({
 *   variables: {
 *      applicationRequestId: // value for 'applicationRequestId'
 *      rejectionReason: // value for 'rejectionReason'
 *      rejectionReasonOption: // value for 'rejectionReasonOption'
 *      shareRejectionReason: // value for 'shareRejectionReason'
 *   },
 * });
 */
export function useFinancingApplicationRequestsRejectMutation(baseOptions?: Apollo.MutationHookOptions<FinancingApplicationRequestsRejectMutation, FinancingApplicationRequestsRejectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinancingApplicationRequestsRejectMutation, FinancingApplicationRequestsRejectMutationVariables>(FinancingApplicationRequestsRejectDocument, options);
      }
export type FinancingApplicationRequestsRejectMutationHookResult = ReturnType<typeof useFinancingApplicationRequestsRejectMutation>;
export type FinancingApplicationRequestsRejectMutationResult = Apollo.MutationResult<FinancingApplicationRequestsRejectMutation>;
export type FinancingApplicationRequestsRejectMutationOptions = Apollo.BaseMutationOptions<FinancingApplicationRequestsRejectMutation, FinancingApplicationRequestsRejectMutationVariables>;
export const FinancingApplicationRequestsCreateDocument = gql`
    mutation FinancingApplicationRequestsCreate($applicationId: ID!) {
  financingApplicationRequestsCreate(applicationId: $applicationId) {
    applicationRequestId
    organisationId
    applicationId
    type
    status
    isExplicit
    isOutsideRisk
    createdAt
    updatedAt
    application {
      applicationId
      createdByOrganisationId
      createdByUserId
      type
      name
      status
    }
  }
}
    `;
export type FinancingApplicationRequestsCreateMutationFn = Apollo.MutationFunction<FinancingApplicationRequestsCreateMutation, FinancingApplicationRequestsCreateMutationVariables>;

/**
 * __useFinancingApplicationRequestsCreateMutation__
 *
 * To run a mutation, you first call `useFinancingApplicationRequestsCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinancingApplicationRequestsCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [financingApplicationRequestsCreateMutation, { data, loading, error }] = useFinancingApplicationRequestsCreateMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useFinancingApplicationRequestsCreateMutation(baseOptions?: Apollo.MutationHookOptions<FinancingApplicationRequestsCreateMutation, FinancingApplicationRequestsCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinancingApplicationRequestsCreateMutation, FinancingApplicationRequestsCreateMutationVariables>(FinancingApplicationRequestsCreateDocument, options);
      }
export type FinancingApplicationRequestsCreateMutationHookResult = ReturnType<typeof useFinancingApplicationRequestsCreateMutation>;
export type FinancingApplicationRequestsCreateMutationResult = Apollo.MutationResult<FinancingApplicationRequestsCreateMutation>;
export type FinancingApplicationRequestsCreateMutationOptions = Apollo.BaseMutationOptions<FinancingApplicationRequestsCreateMutation, FinancingApplicationRequestsCreateMutationVariables>;
export const FinancingContractsGetAllByOrganisationIdDocument = gql`
    query FinancingContractsGetAllByOrganisationId($filter: FilterContractsInput) {
  financingContractsGetAllByOrganisationId(filter: $filter) {
    contractId
    createdByOrganisationId
    sentToOrganisationId
    editableByOrganisationId
    type
    name
    status
    currency
    timeToClose
    netValue
    allInRate
    totalCosts
    legalCost
  }
}
    `;

/**
 * __useFinancingContractsGetAllByOrganisationIdQuery__
 *
 * To run a query within a React component, call `useFinancingContractsGetAllByOrganisationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancingContractsGetAllByOrganisationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancingContractsGetAllByOrganisationIdQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFinancingContractsGetAllByOrganisationIdQuery(baseOptions?: Apollo.QueryHookOptions<FinancingContractsGetAllByOrganisationIdQuery, FinancingContractsGetAllByOrganisationIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancingContractsGetAllByOrganisationIdQuery, FinancingContractsGetAllByOrganisationIdQueryVariables>(FinancingContractsGetAllByOrganisationIdDocument, options);
      }
export function useFinancingContractsGetAllByOrganisationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancingContractsGetAllByOrganisationIdQuery, FinancingContractsGetAllByOrganisationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancingContractsGetAllByOrganisationIdQuery, FinancingContractsGetAllByOrganisationIdQueryVariables>(FinancingContractsGetAllByOrganisationIdDocument, options);
        }
export function useFinancingContractsGetAllByOrganisationIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinancingContractsGetAllByOrganisationIdQuery, FinancingContractsGetAllByOrganisationIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinancingContractsGetAllByOrganisationIdQuery, FinancingContractsGetAllByOrganisationIdQueryVariables>(FinancingContractsGetAllByOrganisationIdDocument, options);
        }
export type FinancingContractsGetAllByOrganisationIdQueryHookResult = ReturnType<typeof useFinancingContractsGetAllByOrganisationIdQuery>;
export type FinancingContractsGetAllByOrganisationIdLazyQueryHookResult = ReturnType<typeof useFinancingContractsGetAllByOrganisationIdLazyQuery>;
export type FinancingContractsGetAllByOrganisationIdSuspenseQueryHookResult = ReturnType<typeof useFinancingContractsGetAllByOrganisationIdSuspenseQuery>;
export type FinancingContractsGetAllByOrganisationIdQueryResult = Apollo.QueryResult<FinancingContractsGetAllByOrganisationIdQuery, FinancingContractsGetAllByOrganisationIdQueryVariables>;
export const FinancingContractsGetAllByApplicationIdDocument = gql`
    query FinancingContractsGetAllByApplicationId($applicationId: ID!, $filter: ContractStatusFilterInput) {
  financingContractsGetAllByApplicationId(
    applicationId: $applicationId
    filter: $filter
  ) {
    id
    sourceType
    contractId
    applicationRequestId
    status
    lenderName
    currency
    timeToClose
    netValue
    allInRate
    totalCosts
    isExplicitInvite
  }
}
    `;

/**
 * __useFinancingContractsGetAllByApplicationIdQuery__
 *
 * To run a query within a React component, call `useFinancingContractsGetAllByApplicationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancingContractsGetAllByApplicationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancingContractsGetAllByApplicationIdQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFinancingContractsGetAllByApplicationIdQuery(baseOptions: Apollo.QueryHookOptions<FinancingContractsGetAllByApplicationIdQuery, FinancingContractsGetAllByApplicationIdQueryVariables> & ({ variables: FinancingContractsGetAllByApplicationIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancingContractsGetAllByApplicationIdQuery, FinancingContractsGetAllByApplicationIdQueryVariables>(FinancingContractsGetAllByApplicationIdDocument, options);
      }
export function useFinancingContractsGetAllByApplicationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancingContractsGetAllByApplicationIdQuery, FinancingContractsGetAllByApplicationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancingContractsGetAllByApplicationIdQuery, FinancingContractsGetAllByApplicationIdQueryVariables>(FinancingContractsGetAllByApplicationIdDocument, options);
        }
export function useFinancingContractsGetAllByApplicationIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinancingContractsGetAllByApplicationIdQuery, FinancingContractsGetAllByApplicationIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinancingContractsGetAllByApplicationIdQuery, FinancingContractsGetAllByApplicationIdQueryVariables>(FinancingContractsGetAllByApplicationIdDocument, options);
        }
export type FinancingContractsGetAllByApplicationIdQueryHookResult = ReturnType<typeof useFinancingContractsGetAllByApplicationIdQuery>;
export type FinancingContractsGetAllByApplicationIdLazyQueryHookResult = ReturnType<typeof useFinancingContractsGetAllByApplicationIdLazyQuery>;
export type FinancingContractsGetAllByApplicationIdSuspenseQueryHookResult = ReturnType<typeof useFinancingContractsGetAllByApplicationIdSuspenseQuery>;
export type FinancingContractsGetAllByApplicationIdQueryResult = Apollo.QueryResult<FinancingContractsGetAllByApplicationIdQuery, FinancingContractsGetAllByApplicationIdQueryVariables>;
export const FinancingApplicationRequestFurtherDetailsGetByIdDocument = gql`
    query FinancingApplicationRequestFurtherDetailsGetById($applicationRequestFurtherDetailId: Int!) {
  financingApplicationRequestFurtherDetailsGetById(
    applicationRequestFurtherDetailId: $applicationRequestFurtherDetailId
  ) {
    applicationRequestFurtherDetailId
    applicationRequestId
    status
    createdByOrganisationId
    createdByUserId
    sentAt
    submittedByOrganisationId
    submittedByUserId
    submittedAt
    receivedByUserId
    receivedAt
    createdAt
    fieldsData {
      fields {
        id
        type
        label
        description
        isRequired
      }
    }
    submissionData {
      partialSubmissionReason
      submissions {
        fieldId
        value
        uploadIds
      }
    }
  }
}
    `;

/**
 * __useFinancingApplicationRequestFurtherDetailsGetByIdQuery__
 *
 * To run a query within a React component, call `useFinancingApplicationRequestFurtherDetailsGetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancingApplicationRequestFurtherDetailsGetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancingApplicationRequestFurtherDetailsGetByIdQuery({
 *   variables: {
 *      applicationRequestFurtherDetailId: // value for 'applicationRequestFurtherDetailId'
 *   },
 * });
 */
export function useFinancingApplicationRequestFurtherDetailsGetByIdQuery(baseOptions: Apollo.QueryHookOptions<FinancingApplicationRequestFurtherDetailsGetByIdQuery, FinancingApplicationRequestFurtherDetailsGetByIdQueryVariables> & ({ variables: FinancingApplicationRequestFurtherDetailsGetByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancingApplicationRequestFurtherDetailsGetByIdQuery, FinancingApplicationRequestFurtherDetailsGetByIdQueryVariables>(FinancingApplicationRequestFurtherDetailsGetByIdDocument, options);
      }
export function useFinancingApplicationRequestFurtherDetailsGetByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancingApplicationRequestFurtherDetailsGetByIdQuery, FinancingApplicationRequestFurtherDetailsGetByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancingApplicationRequestFurtherDetailsGetByIdQuery, FinancingApplicationRequestFurtherDetailsGetByIdQueryVariables>(FinancingApplicationRequestFurtherDetailsGetByIdDocument, options);
        }
export function useFinancingApplicationRequestFurtherDetailsGetByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinancingApplicationRequestFurtherDetailsGetByIdQuery, FinancingApplicationRequestFurtherDetailsGetByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinancingApplicationRequestFurtherDetailsGetByIdQuery, FinancingApplicationRequestFurtherDetailsGetByIdQueryVariables>(FinancingApplicationRequestFurtherDetailsGetByIdDocument, options);
        }
export type FinancingApplicationRequestFurtherDetailsGetByIdQueryHookResult = ReturnType<typeof useFinancingApplicationRequestFurtherDetailsGetByIdQuery>;
export type FinancingApplicationRequestFurtherDetailsGetByIdLazyQueryHookResult = ReturnType<typeof useFinancingApplicationRequestFurtherDetailsGetByIdLazyQuery>;
export type FinancingApplicationRequestFurtherDetailsGetByIdSuspenseQueryHookResult = ReturnType<typeof useFinancingApplicationRequestFurtherDetailsGetByIdSuspenseQuery>;
export type FinancingApplicationRequestFurtherDetailsGetByIdQueryResult = Apollo.QueryResult<FinancingApplicationRequestFurtherDetailsGetByIdQuery, FinancingApplicationRequestFurtherDetailsGetByIdQueryVariables>;
export const FinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdDocument = gql`
    query FinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestId($applicationRequestId: Int!) {
  financingApplicationRequestFurtherDetailsGetAllByApplicationRequestId(
    applicationRequestId: $applicationRequestId
  ) {
    applicationRequestFurtherDetailId
    applicationRequestId
    status
    createdByOrganisationId
    createdByUserId
    sentAt
    submittedByOrganisationId
    submittedByUserId
    submittedAt
    receivedByUserId
    receivedAt
    createdAt
  }
}
    `;

/**
 * __useFinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdQuery__
 *
 * To run a query within a React component, call `useFinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdQuery({
 *   variables: {
 *      applicationRequestId: // value for 'applicationRequestId'
 *   },
 * });
 */
export function useFinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdQuery(baseOptions: Apollo.QueryHookOptions<FinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdQuery, FinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdQueryVariables> & ({ variables: FinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdQuery, FinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdQueryVariables>(FinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdDocument, options);
      }
export function useFinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdQuery, FinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdQuery, FinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdQueryVariables>(FinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdDocument, options);
        }
export function useFinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdQuery, FinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdQuery, FinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdQueryVariables>(FinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdDocument, options);
        }
export type FinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdQueryHookResult = ReturnType<typeof useFinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdQuery>;
export type FinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdLazyQueryHookResult = ReturnType<typeof useFinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdLazyQuery>;
export type FinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdSuspenseQueryHookResult = ReturnType<typeof useFinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdSuspenseQuery>;
export type FinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdQueryResult = Apollo.QueryResult<FinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdQuery, FinancingApplicationRequestFurtherDetailsGetAllByApplicationRequestIdQueryVariables>;
export const FinancingApplicationRequestFurtherDetailsGetAllByApplicationIdDocument = gql`
    query FinancingApplicationRequestFurtherDetailsGetAllByApplicationId($applicationId: Int!) {
  financingApplicationRequestFurtherDetailsGetAllByApplicationId(
    applicationId: $applicationId
  ) {
    applicationRequestFurtherDetailId
    applicationRequestId
    status
    createdByOrganisationId
    createdByUserId
    sentAt
    submittedByOrganisationId
    submittedByUserId
    submittedAt
    receivedByUserId
    receivedAt
    createdAt
  }
}
    `;

/**
 * __useFinancingApplicationRequestFurtherDetailsGetAllByApplicationIdQuery__
 *
 * To run a query within a React component, call `useFinancingApplicationRequestFurtherDetailsGetAllByApplicationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancingApplicationRequestFurtherDetailsGetAllByApplicationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancingApplicationRequestFurtherDetailsGetAllByApplicationIdQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useFinancingApplicationRequestFurtherDetailsGetAllByApplicationIdQuery(baseOptions: Apollo.QueryHookOptions<FinancingApplicationRequestFurtherDetailsGetAllByApplicationIdQuery, FinancingApplicationRequestFurtherDetailsGetAllByApplicationIdQueryVariables> & ({ variables: FinancingApplicationRequestFurtherDetailsGetAllByApplicationIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancingApplicationRequestFurtherDetailsGetAllByApplicationIdQuery, FinancingApplicationRequestFurtherDetailsGetAllByApplicationIdQueryVariables>(FinancingApplicationRequestFurtherDetailsGetAllByApplicationIdDocument, options);
      }
export function useFinancingApplicationRequestFurtherDetailsGetAllByApplicationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancingApplicationRequestFurtherDetailsGetAllByApplicationIdQuery, FinancingApplicationRequestFurtherDetailsGetAllByApplicationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancingApplicationRequestFurtherDetailsGetAllByApplicationIdQuery, FinancingApplicationRequestFurtherDetailsGetAllByApplicationIdQueryVariables>(FinancingApplicationRequestFurtherDetailsGetAllByApplicationIdDocument, options);
        }
export function useFinancingApplicationRequestFurtherDetailsGetAllByApplicationIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinancingApplicationRequestFurtherDetailsGetAllByApplicationIdQuery, FinancingApplicationRequestFurtherDetailsGetAllByApplicationIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinancingApplicationRequestFurtherDetailsGetAllByApplicationIdQuery, FinancingApplicationRequestFurtherDetailsGetAllByApplicationIdQueryVariables>(FinancingApplicationRequestFurtherDetailsGetAllByApplicationIdDocument, options);
        }
export type FinancingApplicationRequestFurtherDetailsGetAllByApplicationIdQueryHookResult = ReturnType<typeof useFinancingApplicationRequestFurtherDetailsGetAllByApplicationIdQuery>;
export type FinancingApplicationRequestFurtherDetailsGetAllByApplicationIdLazyQueryHookResult = ReturnType<typeof useFinancingApplicationRequestFurtherDetailsGetAllByApplicationIdLazyQuery>;
export type FinancingApplicationRequestFurtherDetailsGetAllByApplicationIdSuspenseQueryHookResult = ReturnType<typeof useFinancingApplicationRequestFurtherDetailsGetAllByApplicationIdSuspenseQuery>;
export type FinancingApplicationRequestFurtherDetailsGetAllByApplicationIdQueryResult = Apollo.QueryResult<FinancingApplicationRequestFurtherDetailsGetAllByApplicationIdQuery, FinancingApplicationRequestFurtherDetailsGetAllByApplicationIdQueryVariables>;
export const FinancingApplicationRequestFurtherDetailCreateDocument = gql`
    mutation FinancingApplicationRequestFurtherDetailCreate($applicationRequestId: Int!) {
  financingApplicationRequestFurtherDetailCreate(
    applicationRequestId: $applicationRequestId
  ) {
    applicationRequestFurtherDetailId
    applicationRequestId
    status
    createdByOrganisationId
    createdByUserId
    createdAt
  }
}
    `;
export type FinancingApplicationRequestFurtherDetailCreateMutationFn = Apollo.MutationFunction<FinancingApplicationRequestFurtherDetailCreateMutation, FinancingApplicationRequestFurtherDetailCreateMutationVariables>;

/**
 * __useFinancingApplicationRequestFurtherDetailCreateMutation__
 *
 * To run a mutation, you first call `useFinancingApplicationRequestFurtherDetailCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinancingApplicationRequestFurtherDetailCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [financingApplicationRequestFurtherDetailCreateMutation, { data, loading, error }] = useFinancingApplicationRequestFurtherDetailCreateMutation({
 *   variables: {
 *      applicationRequestId: // value for 'applicationRequestId'
 *   },
 * });
 */
export function useFinancingApplicationRequestFurtherDetailCreateMutation(baseOptions?: Apollo.MutationHookOptions<FinancingApplicationRequestFurtherDetailCreateMutation, FinancingApplicationRequestFurtherDetailCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinancingApplicationRequestFurtherDetailCreateMutation, FinancingApplicationRequestFurtherDetailCreateMutationVariables>(FinancingApplicationRequestFurtherDetailCreateDocument, options);
      }
export type FinancingApplicationRequestFurtherDetailCreateMutationHookResult = ReturnType<typeof useFinancingApplicationRequestFurtherDetailCreateMutation>;
export type FinancingApplicationRequestFurtherDetailCreateMutationResult = Apollo.MutationResult<FinancingApplicationRequestFurtherDetailCreateMutation>;
export type FinancingApplicationRequestFurtherDetailCreateMutationOptions = Apollo.BaseMutationOptions<FinancingApplicationRequestFurtherDetailCreateMutation, FinancingApplicationRequestFurtherDetailCreateMutationVariables>;
export const FinancingApplicationRequestFurtherDetailDeleteDocument = gql`
    mutation FinancingApplicationRequestFurtherDetailDelete($applicationRequestFurtherDetailId: Int!) {
  financingApplicationRequestFurtherDetailDelete(
    applicationRequestFurtherDetailId: $applicationRequestFurtherDetailId
  ) {
    success
  }
}
    `;
export type FinancingApplicationRequestFurtherDetailDeleteMutationFn = Apollo.MutationFunction<FinancingApplicationRequestFurtherDetailDeleteMutation, FinancingApplicationRequestFurtherDetailDeleteMutationVariables>;

/**
 * __useFinancingApplicationRequestFurtherDetailDeleteMutation__
 *
 * To run a mutation, you first call `useFinancingApplicationRequestFurtherDetailDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinancingApplicationRequestFurtherDetailDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [financingApplicationRequestFurtherDetailDeleteMutation, { data, loading, error }] = useFinancingApplicationRequestFurtherDetailDeleteMutation({
 *   variables: {
 *      applicationRequestFurtherDetailId: // value for 'applicationRequestFurtherDetailId'
 *   },
 * });
 */
export function useFinancingApplicationRequestFurtherDetailDeleteMutation(baseOptions?: Apollo.MutationHookOptions<FinancingApplicationRequestFurtherDetailDeleteMutation, FinancingApplicationRequestFurtherDetailDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinancingApplicationRequestFurtherDetailDeleteMutation, FinancingApplicationRequestFurtherDetailDeleteMutationVariables>(FinancingApplicationRequestFurtherDetailDeleteDocument, options);
      }
export type FinancingApplicationRequestFurtherDetailDeleteMutationHookResult = ReturnType<typeof useFinancingApplicationRequestFurtherDetailDeleteMutation>;
export type FinancingApplicationRequestFurtherDetailDeleteMutationResult = Apollo.MutationResult<FinancingApplicationRequestFurtherDetailDeleteMutation>;
export type FinancingApplicationRequestFurtherDetailDeleteMutationOptions = Apollo.BaseMutationOptions<FinancingApplicationRequestFurtherDetailDeleteMutation, FinancingApplicationRequestFurtherDetailDeleteMutationVariables>;
export const FinancingApplicationRequestFurtherDetailSendDocument = gql`
    mutation FinancingApplicationRequestFurtherDetailSend($applicationRequestFurtherDetailId: Int!) {
  financingApplicationRequestFurtherDetailSend(
    applicationRequestFurtherDetailId: $applicationRequestFurtherDetailId
  ) {
    success
  }
}
    `;
export type FinancingApplicationRequestFurtherDetailSendMutationFn = Apollo.MutationFunction<FinancingApplicationRequestFurtherDetailSendMutation, FinancingApplicationRequestFurtherDetailSendMutationVariables>;

/**
 * __useFinancingApplicationRequestFurtherDetailSendMutation__
 *
 * To run a mutation, you first call `useFinancingApplicationRequestFurtherDetailSendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinancingApplicationRequestFurtherDetailSendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [financingApplicationRequestFurtherDetailSendMutation, { data, loading, error }] = useFinancingApplicationRequestFurtherDetailSendMutation({
 *   variables: {
 *      applicationRequestFurtherDetailId: // value for 'applicationRequestFurtherDetailId'
 *   },
 * });
 */
export function useFinancingApplicationRequestFurtherDetailSendMutation(baseOptions?: Apollo.MutationHookOptions<FinancingApplicationRequestFurtherDetailSendMutation, FinancingApplicationRequestFurtherDetailSendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinancingApplicationRequestFurtherDetailSendMutation, FinancingApplicationRequestFurtherDetailSendMutationVariables>(FinancingApplicationRequestFurtherDetailSendDocument, options);
      }
export type FinancingApplicationRequestFurtherDetailSendMutationHookResult = ReturnType<typeof useFinancingApplicationRequestFurtherDetailSendMutation>;
export type FinancingApplicationRequestFurtherDetailSendMutationResult = Apollo.MutationResult<FinancingApplicationRequestFurtherDetailSendMutation>;
export type FinancingApplicationRequestFurtherDetailSendMutationOptions = Apollo.BaseMutationOptions<FinancingApplicationRequestFurtherDetailSendMutation, FinancingApplicationRequestFurtherDetailSendMutationVariables>;
export const FinancingApplicationRequestFurtherDetailUpdateDocument = gql`
    mutation FinancingApplicationRequestFurtherDetailUpdate($input: UpdateApplicationRequestFurtherDetailInput!) {
  financingApplicationRequestFurtherDetailUpdate(input: $input) {
    success
  }
}
    `;
export type FinancingApplicationRequestFurtherDetailUpdateMutationFn = Apollo.MutationFunction<FinancingApplicationRequestFurtherDetailUpdateMutation, FinancingApplicationRequestFurtherDetailUpdateMutationVariables>;

/**
 * __useFinancingApplicationRequestFurtherDetailUpdateMutation__
 *
 * To run a mutation, you first call `useFinancingApplicationRequestFurtherDetailUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinancingApplicationRequestFurtherDetailUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [financingApplicationRequestFurtherDetailUpdateMutation, { data, loading, error }] = useFinancingApplicationRequestFurtherDetailUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFinancingApplicationRequestFurtherDetailUpdateMutation(baseOptions?: Apollo.MutationHookOptions<FinancingApplicationRequestFurtherDetailUpdateMutation, FinancingApplicationRequestFurtherDetailUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinancingApplicationRequestFurtherDetailUpdateMutation, FinancingApplicationRequestFurtherDetailUpdateMutationVariables>(FinancingApplicationRequestFurtherDetailUpdateDocument, options);
      }
export type FinancingApplicationRequestFurtherDetailUpdateMutationHookResult = ReturnType<typeof useFinancingApplicationRequestFurtherDetailUpdateMutation>;
export type FinancingApplicationRequestFurtherDetailUpdateMutationResult = Apollo.MutationResult<FinancingApplicationRequestFurtherDetailUpdateMutation>;
export type FinancingApplicationRequestFurtherDetailUpdateMutationOptions = Apollo.BaseMutationOptions<FinancingApplicationRequestFurtherDetailUpdateMutation, FinancingApplicationRequestFurtherDetailUpdateMutationVariables>;
export const FinancingApplicationRequestFurtherDetailSubmitDocument = gql`
    mutation FinancingApplicationRequestFurtherDetailSubmit($input: SubmitApplicationRequestFurtherDetailInput!) {
  financingApplicationRequestFurtherDetailSubmit(input: $input) {
    success
  }
}
    `;
export type FinancingApplicationRequestFurtherDetailSubmitMutationFn = Apollo.MutationFunction<FinancingApplicationRequestFurtherDetailSubmitMutation, FinancingApplicationRequestFurtherDetailSubmitMutationVariables>;

/**
 * __useFinancingApplicationRequestFurtherDetailSubmitMutation__
 *
 * To run a mutation, you first call `useFinancingApplicationRequestFurtherDetailSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinancingApplicationRequestFurtherDetailSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [financingApplicationRequestFurtherDetailSubmitMutation, { data, loading, error }] = useFinancingApplicationRequestFurtherDetailSubmitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFinancingApplicationRequestFurtherDetailSubmitMutation(baseOptions?: Apollo.MutationHookOptions<FinancingApplicationRequestFurtherDetailSubmitMutation, FinancingApplicationRequestFurtherDetailSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinancingApplicationRequestFurtherDetailSubmitMutation, FinancingApplicationRequestFurtherDetailSubmitMutationVariables>(FinancingApplicationRequestFurtherDetailSubmitDocument, options);
      }
export type FinancingApplicationRequestFurtherDetailSubmitMutationHookResult = ReturnType<typeof useFinancingApplicationRequestFurtherDetailSubmitMutation>;
export type FinancingApplicationRequestFurtherDetailSubmitMutationResult = Apollo.MutationResult<FinancingApplicationRequestFurtherDetailSubmitMutation>;
export type FinancingApplicationRequestFurtherDetailSubmitMutationOptions = Apollo.BaseMutationOptions<FinancingApplicationRequestFurtherDetailSubmitMutation, FinancingApplicationRequestFurtherDetailSubmitMutationVariables>;
export const FinancingApplicationRequestFurtherDetailConfirmReceiptDocument = gql`
    mutation FinancingApplicationRequestFurtherDetailConfirmReceipt($input: ConfirmApplicationRequestFurtherDetailReceiptInput!) {
  financingApplicationRequestFurtherDetailConfirmReceipt(input: $input) {
    success
  }
}
    `;
export type FinancingApplicationRequestFurtherDetailConfirmReceiptMutationFn = Apollo.MutationFunction<FinancingApplicationRequestFurtherDetailConfirmReceiptMutation, FinancingApplicationRequestFurtherDetailConfirmReceiptMutationVariables>;

/**
 * __useFinancingApplicationRequestFurtherDetailConfirmReceiptMutation__
 *
 * To run a mutation, you first call `useFinancingApplicationRequestFurtherDetailConfirmReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinancingApplicationRequestFurtherDetailConfirmReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [financingApplicationRequestFurtherDetailConfirmReceiptMutation, { data, loading, error }] = useFinancingApplicationRequestFurtherDetailConfirmReceiptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFinancingApplicationRequestFurtherDetailConfirmReceiptMutation(baseOptions?: Apollo.MutationHookOptions<FinancingApplicationRequestFurtherDetailConfirmReceiptMutation, FinancingApplicationRequestFurtherDetailConfirmReceiptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinancingApplicationRequestFurtherDetailConfirmReceiptMutation, FinancingApplicationRequestFurtherDetailConfirmReceiptMutationVariables>(FinancingApplicationRequestFurtherDetailConfirmReceiptDocument, options);
      }
export type FinancingApplicationRequestFurtherDetailConfirmReceiptMutationHookResult = ReturnType<typeof useFinancingApplicationRequestFurtherDetailConfirmReceiptMutation>;
export type FinancingApplicationRequestFurtherDetailConfirmReceiptMutationResult = Apollo.MutationResult<FinancingApplicationRequestFurtherDetailConfirmReceiptMutation>;
export type FinancingApplicationRequestFurtherDetailConfirmReceiptMutationOptions = Apollo.BaseMutationOptions<FinancingApplicationRequestFurtherDetailConfirmReceiptMutation, FinancingApplicationRequestFurtherDetailConfirmReceiptMutationVariables>;
export const GetInviteByTokenDocument = gql`
    query GetInviteByToken($inviteToken: String!) {
  invitesGetByToken(inviteToken: $inviteToken) {
    inviteId
    token
    type
    status
    contract
    transferDeal
    user {
      userId
      email
      phoneNumber
      firstName
      middleName
      lastName
    }
    organisation {
      organisationId
      type
      licenseType
      name
      address
      postalCode
      allowedFinancingTypes
      financierType
      billing {
        email
        phoneNumber
        firstName
        lastName
      }
    }
    organisationUser {
      role
      permissions
    }
    club {
      clubId
      imageUrl
      officialName
    }
    player {
      playerId
      firstName
      lastName
      middleName
      imageUrl
    }
  }
}
    `;

/**
 * __useGetInviteByTokenQuery__
 *
 * To run a query within a React component, call `useGetInviteByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInviteByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInviteByTokenQuery({
 *   variables: {
 *      inviteToken: // value for 'inviteToken'
 *   },
 * });
 */
export function useGetInviteByTokenQuery(baseOptions: Apollo.QueryHookOptions<GetInviteByTokenQuery, GetInviteByTokenQueryVariables> & ({ variables: GetInviteByTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInviteByTokenQuery, GetInviteByTokenQueryVariables>(GetInviteByTokenDocument, options);
      }
export function useGetInviteByTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInviteByTokenQuery, GetInviteByTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInviteByTokenQuery, GetInviteByTokenQueryVariables>(GetInviteByTokenDocument, options);
        }
export function useGetInviteByTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInviteByTokenQuery, GetInviteByTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInviteByTokenQuery, GetInviteByTokenQueryVariables>(GetInviteByTokenDocument, options);
        }
export type GetInviteByTokenQueryHookResult = ReturnType<typeof useGetInviteByTokenQuery>;
export type GetInviteByTokenLazyQueryHookResult = ReturnType<typeof useGetInviteByTokenLazyQuery>;
export type GetInviteByTokenSuspenseQueryHookResult = ReturnType<typeof useGetInviteByTokenSuspenseQuery>;
export type GetInviteByTokenQueryResult = Apollo.QueryResult<GetInviteByTokenQuery, GetInviteByTokenQueryVariables>;
export const InvitesGetAllDocument = gql`
    query InvitesGetAll($filter: FilterInvitesParams) {
  invitesGetAll(filter: $filter) {
    inviteId
    token
    type
    status
    createdAt
    lastSent
    user {
      userId
      email
      firstName
      lastName
      phoneNumber
    }
    organisation {
      organisationId
      type
      licenseType
      name
    }
    organisationUser {
      role
      permissions
    }
    requestedBy {
      userId
      organisationId
    }
  }
}
    `;

/**
 * __useInvitesGetAllQuery__
 *
 * To run a query within a React component, call `useInvitesGetAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitesGetAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitesGetAllQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useInvitesGetAllQuery(baseOptions?: Apollo.QueryHookOptions<InvitesGetAllQuery, InvitesGetAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvitesGetAllQuery, InvitesGetAllQueryVariables>(InvitesGetAllDocument, options);
      }
export function useInvitesGetAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvitesGetAllQuery, InvitesGetAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvitesGetAllQuery, InvitesGetAllQueryVariables>(InvitesGetAllDocument, options);
        }
export function useInvitesGetAllSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvitesGetAllQuery, InvitesGetAllQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvitesGetAllQuery, InvitesGetAllQueryVariables>(InvitesGetAllDocument, options);
        }
export type InvitesGetAllQueryHookResult = ReturnType<typeof useInvitesGetAllQuery>;
export type InvitesGetAllLazyQueryHookResult = ReturnType<typeof useInvitesGetAllLazyQuery>;
export type InvitesGetAllSuspenseQueryHookResult = ReturnType<typeof useInvitesGetAllSuspenseQuery>;
export type InvitesGetAllQueryResult = Apollo.QueryResult<InvitesGetAllQuery, InvitesGetAllQueryVariables>;
export const InvitesGetPaginatedDocument = gql`
    query InvitesGetPaginated($pagination: PaginationInput!, $sorting: SortInput, $filters: [FilterInput!], $search: String) {
  invitesGetPaginated(
    pagination: $pagination
    sorting: $sorting
    filters: $filters
    search: $search
  ) {
    items {
      inviteId
      token
      type
      status
      createdAt
      user {
        userId
        email
        firstName
        middleName
        lastName
        phoneNumber
      }
      organisation {
        organisationId
        type
        licenseType
        name
      }
      organisationUser {
        role
        permissions
      }
      requestedBy {
        userId
        organisationId
      }
      player {
        playerId
      }
    }
    pagination {
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useInvitesGetPaginatedQuery__
 *
 * To run a query within a React component, call `useInvitesGetPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitesGetPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitesGetPaginatedQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sorting: // value for 'sorting'
 *      filters: // value for 'filters'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useInvitesGetPaginatedQuery(baseOptions: Apollo.QueryHookOptions<InvitesGetPaginatedQuery, InvitesGetPaginatedQueryVariables> & ({ variables: InvitesGetPaginatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvitesGetPaginatedQuery, InvitesGetPaginatedQueryVariables>(InvitesGetPaginatedDocument, options);
      }
export function useInvitesGetPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvitesGetPaginatedQuery, InvitesGetPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvitesGetPaginatedQuery, InvitesGetPaginatedQueryVariables>(InvitesGetPaginatedDocument, options);
        }
export function useInvitesGetPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvitesGetPaginatedQuery, InvitesGetPaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvitesGetPaginatedQuery, InvitesGetPaginatedQueryVariables>(InvitesGetPaginatedDocument, options);
        }
export type InvitesGetPaginatedQueryHookResult = ReturnType<typeof useInvitesGetPaginatedQuery>;
export type InvitesGetPaginatedLazyQueryHookResult = ReturnType<typeof useInvitesGetPaginatedLazyQuery>;
export type InvitesGetPaginatedSuspenseQueryHookResult = ReturnType<typeof useInvitesGetPaginatedSuspenseQuery>;
export type InvitesGetPaginatedQueryResult = Apollo.QueryResult<InvitesGetPaginatedQuery, InvitesGetPaginatedQueryVariables>;
export const PlayerTransferContractInvitesGetAllByOrganisationIdDocument = gql`
    query PlayerTransferContractInvitesGetAllByOrganisationId($filter: FilterInvitesParams) {
  playerTransferContractInvitesGetAllByOrganisationId(filter: $filter) {
    inviteId
    type
    token
    status
    contract {
      contractId
      createdByOrganisationId
      sentToOrganisationId
      editableByOrganisationId
      type
      name
      status
      playerName
      transferType
      acquisitionOffer
      deposit
    }
  }
}
    `;

/**
 * __usePlayerTransferContractInvitesGetAllByOrganisationIdQuery__
 *
 * To run a query within a React component, call `usePlayerTransferContractInvitesGetAllByOrganisationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerTransferContractInvitesGetAllByOrganisationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerTransferContractInvitesGetAllByOrganisationIdQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePlayerTransferContractInvitesGetAllByOrganisationIdQuery(baseOptions?: Apollo.QueryHookOptions<PlayerTransferContractInvitesGetAllByOrganisationIdQuery, PlayerTransferContractInvitesGetAllByOrganisationIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerTransferContractInvitesGetAllByOrganisationIdQuery, PlayerTransferContractInvitesGetAllByOrganisationIdQueryVariables>(PlayerTransferContractInvitesGetAllByOrganisationIdDocument, options);
      }
export function usePlayerTransferContractInvitesGetAllByOrganisationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerTransferContractInvitesGetAllByOrganisationIdQuery, PlayerTransferContractInvitesGetAllByOrganisationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerTransferContractInvitesGetAllByOrganisationIdQuery, PlayerTransferContractInvitesGetAllByOrganisationIdQueryVariables>(PlayerTransferContractInvitesGetAllByOrganisationIdDocument, options);
        }
export function usePlayerTransferContractInvitesGetAllByOrganisationIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerTransferContractInvitesGetAllByOrganisationIdQuery, PlayerTransferContractInvitesGetAllByOrganisationIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayerTransferContractInvitesGetAllByOrganisationIdQuery, PlayerTransferContractInvitesGetAllByOrganisationIdQueryVariables>(PlayerTransferContractInvitesGetAllByOrganisationIdDocument, options);
        }
export type PlayerTransferContractInvitesGetAllByOrganisationIdQueryHookResult = ReturnType<typeof usePlayerTransferContractInvitesGetAllByOrganisationIdQuery>;
export type PlayerTransferContractInvitesGetAllByOrganisationIdLazyQueryHookResult = ReturnType<typeof usePlayerTransferContractInvitesGetAllByOrganisationIdLazyQuery>;
export type PlayerTransferContractInvitesGetAllByOrganisationIdSuspenseQueryHookResult = ReturnType<typeof usePlayerTransferContractInvitesGetAllByOrganisationIdSuspenseQuery>;
export type PlayerTransferContractInvitesGetAllByOrganisationIdQueryResult = Apollo.QueryResult<PlayerTransferContractInvitesGetAllByOrganisationIdQuery, PlayerTransferContractInvitesGetAllByOrganisationIdQueryVariables>;
export const PlayerContractInvitesGetAllByOrganisationIdDocument = gql`
    query PlayerContractInvitesGetAllByOrganisationId($filter: FilterInvitesParams) {
  playerContractInvitesGetAllByOrganisationId(filter: $filter) {
    inviteId
    type
    token
    status
    contract {
      contractId
      createdByOrganisationId
      sentToOrganisationId
      editableByOrganisationId
      type
      name
      status
      currency
      playerName
      signOnFee
    }
  }
}
    `;

/**
 * __usePlayerContractInvitesGetAllByOrganisationIdQuery__
 *
 * To run a query within a React component, call `usePlayerContractInvitesGetAllByOrganisationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerContractInvitesGetAllByOrganisationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerContractInvitesGetAllByOrganisationIdQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePlayerContractInvitesGetAllByOrganisationIdQuery(baseOptions?: Apollo.QueryHookOptions<PlayerContractInvitesGetAllByOrganisationIdQuery, PlayerContractInvitesGetAllByOrganisationIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerContractInvitesGetAllByOrganisationIdQuery, PlayerContractInvitesGetAllByOrganisationIdQueryVariables>(PlayerContractInvitesGetAllByOrganisationIdDocument, options);
      }
export function usePlayerContractInvitesGetAllByOrganisationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerContractInvitesGetAllByOrganisationIdQuery, PlayerContractInvitesGetAllByOrganisationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerContractInvitesGetAllByOrganisationIdQuery, PlayerContractInvitesGetAllByOrganisationIdQueryVariables>(PlayerContractInvitesGetAllByOrganisationIdDocument, options);
        }
export function usePlayerContractInvitesGetAllByOrganisationIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerContractInvitesGetAllByOrganisationIdQuery, PlayerContractInvitesGetAllByOrganisationIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayerContractInvitesGetAllByOrganisationIdQuery, PlayerContractInvitesGetAllByOrganisationIdQueryVariables>(PlayerContractInvitesGetAllByOrganisationIdDocument, options);
        }
export type PlayerContractInvitesGetAllByOrganisationIdQueryHookResult = ReturnType<typeof usePlayerContractInvitesGetAllByOrganisationIdQuery>;
export type PlayerContractInvitesGetAllByOrganisationIdLazyQueryHookResult = ReturnType<typeof usePlayerContractInvitesGetAllByOrganisationIdLazyQuery>;
export type PlayerContractInvitesGetAllByOrganisationIdSuspenseQueryHookResult = ReturnType<typeof usePlayerContractInvitesGetAllByOrganisationIdSuspenseQuery>;
export type PlayerContractInvitesGetAllByOrganisationIdQueryResult = Apollo.QueryResult<PlayerContractInvitesGetAllByOrganisationIdQuery, PlayerContractInvitesGetAllByOrganisationIdQueryVariables>;
export const FinancingContractInviteGetByOrganisationUserDocument = gql`
    query FinancingContractInviteGetByOrganisationUser($filter: FilterInvitesParams) {
  financingContractInviteGetByOrganisationUser(filter: $filter) {
    inviteId
    type
    token
    status
    contract {
      contractId
      createdByOrganisationId
      sentToOrganisationId
      editableByOrganisationId
      type
      name
      status
      lenderName
      currency
      timeToClose
      netValue
      allInRate
      totalCosts
    }
  }
}
    `;

/**
 * __useFinancingContractInviteGetByOrganisationUserQuery__
 *
 * To run a query within a React component, call `useFinancingContractInviteGetByOrganisationUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancingContractInviteGetByOrganisationUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancingContractInviteGetByOrganisationUserQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFinancingContractInviteGetByOrganisationUserQuery(baseOptions?: Apollo.QueryHookOptions<FinancingContractInviteGetByOrganisationUserQuery, FinancingContractInviteGetByOrganisationUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancingContractInviteGetByOrganisationUserQuery, FinancingContractInviteGetByOrganisationUserQueryVariables>(FinancingContractInviteGetByOrganisationUserDocument, options);
      }
export function useFinancingContractInviteGetByOrganisationUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancingContractInviteGetByOrganisationUserQuery, FinancingContractInviteGetByOrganisationUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancingContractInviteGetByOrganisationUserQuery, FinancingContractInviteGetByOrganisationUserQueryVariables>(FinancingContractInviteGetByOrganisationUserDocument, options);
        }
export function useFinancingContractInviteGetByOrganisationUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinancingContractInviteGetByOrganisationUserQuery, FinancingContractInviteGetByOrganisationUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinancingContractInviteGetByOrganisationUserQuery, FinancingContractInviteGetByOrganisationUserQueryVariables>(FinancingContractInviteGetByOrganisationUserDocument, options);
        }
export type FinancingContractInviteGetByOrganisationUserQueryHookResult = ReturnType<typeof useFinancingContractInviteGetByOrganisationUserQuery>;
export type FinancingContractInviteGetByOrganisationUserLazyQueryHookResult = ReturnType<typeof useFinancingContractInviteGetByOrganisationUserLazyQuery>;
export type FinancingContractInviteGetByOrganisationUserSuspenseQueryHookResult = ReturnType<typeof useFinancingContractInviteGetByOrganisationUserSuspenseQuery>;
export type FinancingContractInviteGetByOrganisationUserQueryResult = Apollo.QueryResult<FinancingContractInviteGetByOrganisationUserQuery, FinancingContractInviteGetByOrganisationUserQueryVariables>;
export const InvitesCreateDocument = gql`
    mutation InvitesCreate($inviteId: Int, $inviteDetails: InviteDetails!) {
  invitesCreate(inviteId: $inviteId, inviteDetails: $inviteDetails) {
    success
  }
}
    `;
export type InvitesCreateMutationFn = Apollo.MutationFunction<InvitesCreateMutation, InvitesCreateMutationVariables>;

/**
 * __useInvitesCreateMutation__
 *
 * To run a mutation, you first call `useInvitesCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvitesCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invitesCreateMutation, { data, loading, error }] = useInvitesCreateMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *      inviteDetails: // value for 'inviteDetails'
 *   },
 * });
 */
export function useInvitesCreateMutation(baseOptions?: Apollo.MutationHookOptions<InvitesCreateMutation, InvitesCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvitesCreateMutation, InvitesCreateMutationVariables>(InvitesCreateDocument, options);
      }
export type InvitesCreateMutationHookResult = ReturnType<typeof useInvitesCreateMutation>;
export type InvitesCreateMutationResult = Apollo.MutationResult<InvitesCreateMutation>;
export type InvitesCreateMutationOptions = Apollo.BaseMutationOptions<InvitesCreateMutation, InvitesCreateMutationVariables>;
export const InvitesCreateProvisionalDocument = gql`
    mutation InvitesCreateProvisional($provisionalInviteDetails: ProvisionalInviteDetails!) {
  invitesCreateProvisional(provisionalInviteDetails: $provisionalInviteDetails) {
    success
  }
}
    `;
export type InvitesCreateProvisionalMutationFn = Apollo.MutationFunction<InvitesCreateProvisionalMutation, InvitesCreateProvisionalMutationVariables>;

/**
 * __useInvitesCreateProvisionalMutation__
 *
 * To run a mutation, you first call `useInvitesCreateProvisionalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvitesCreateProvisionalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invitesCreateProvisionalMutation, { data, loading, error }] = useInvitesCreateProvisionalMutation({
 *   variables: {
 *      provisionalInviteDetails: // value for 'provisionalInviteDetails'
 *   },
 * });
 */
export function useInvitesCreateProvisionalMutation(baseOptions?: Apollo.MutationHookOptions<InvitesCreateProvisionalMutation, InvitesCreateProvisionalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvitesCreateProvisionalMutation, InvitesCreateProvisionalMutationVariables>(InvitesCreateProvisionalDocument, options);
      }
export type InvitesCreateProvisionalMutationHookResult = ReturnType<typeof useInvitesCreateProvisionalMutation>;
export type InvitesCreateProvisionalMutationResult = Apollo.MutationResult<InvitesCreateProvisionalMutation>;
export type InvitesCreateProvisionalMutationOptions = Apollo.BaseMutationOptions<InvitesCreateProvisionalMutation, InvitesCreateProvisionalMutationVariables>;
export const InvitesResendDocument = gql`
    mutation InvitesResend($inviteId: Int!) {
  invitesResend(inviteId: $inviteId) {
    success
  }
}
    `;
export type InvitesResendMutationFn = Apollo.MutationFunction<InvitesResendMutation, InvitesResendMutationVariables>;

/**
 * __useInvitesResendMutation__
 *
 * To run a mutation, you first call `useInvitesResendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvitesResendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invitesResendMutation, { data, loading, error }] = useInvitesResendMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useInvitesResendMutation(baseOptions?: Apollo.MutationHookOptions<InvitesResendMutation, InvitesResendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvitesResendMutation, InvitesResendMutationVariables>(InvitesResendDocument, options);
      }
export type InvitesResendMutationHookResult = ReturnType<typeof useInvitesResendMutation>;
export type InvitesResendMutationResult = Apollo.MutationResult<InvitesResendMutation>;
export type InvitesResendMutationOptions = Apollo.BaseMutationOptions<InvitesResendMutation, InvitesResendMutationVariables>;
export const LeagueRulesByIdDocument = gql`
    query LeagueRulesById($leagueRuleId: ID!) {
  leagueRulesById(leagueRuleId: $leagueRuleId) {
    leagueRuleId
    financierTypes
    financingTypes
    competitionIds
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useLeagueRulesByIdQuery__
 *
 * To run a query within a React component, call `useLeagueRulesByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeagueRulesByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeagueRulesByIdQuery({
 *   variables: {
 *      leagueRuleId: // value for 'leagueRuleId'
 *   },
 * });
 */
export function useLeagueRulesByIdQuery(baseOptions: Apollo.QueryHookOptions<LeagueRulesByIdQuery, LeagueRulesByIdQueryVariables> & ({ variables: LeagueRulesByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeagueRulesByIdQuery, LeagueRulesByIdQueryVariables>(LeagueRulesByIdDocument, options);
      }
export function useLeagueRulesByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeagueRulesByIdQuery, LeagueRulesByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeagueRulesByIdQuery, LeagueRulesByIdQueryVariables>(LeagueRulesByIdDocument, options);
        }
export function useLeagueRulesByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LeagueRulesByIdQuery, LeagueRulesByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LeagueRulesByIdQuery, LeagueRulesByIdQueryVariables>(LeagueRulesByIdDocument, options);
        }
export type LeagueRulesByIdQueryHookResult = ReturnType<typeof useLeagueRulesByIdQuery>;
export type LeagueRulesByIdLazyQueryHookResult = ReturnType<typeof useLeagueRulesByIdLazyQuery>;
export type LeagueRulesByIdSuspenseQueryHookResult = ReturnType<typeof useLeagueRulesByIdSuspenseQuery>;
export type LeagueRulesByIdQueryResult = Apollo.QueryResult<LeagueRulesByIdQuery, LeagueRulesByIdQueryVariables>;
export const LeagueRulesGetAllDocument = gql`
    query LeagueRulesGetAll {
  leagueRulesGetAll {
    leagueRuleId
    financierTypes
    financingTypes
    competitionIds
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useLeagueRulesGetAllQuery__
 *
 * To run a query within a React component, call `useLeagueRulesGetAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeagueRulesGetAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeagueRulesGetAllQuery({
 *   variables: {
 *   },
 * });
 */
export function useLeagueRulesGetAllQuery(baseOptions?: Apollo.QueryHookOptions<LeagueRulesGetAllQuery, LeagueRulesGetAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeagueRulesGetAllQuery, LeagueRulesGetAllQueryVariables>(LeagueRulesGetAllDocument, options);
      }
export function useLeagueRulesGetAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeagueRulesGetAllQuery, LeagueRulesGetAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeagueRulesGetAllQuery, LeagueRulesGetAllQueryVariables>(LeagueRulesGetAllDocument, options);
        }
export function useLeagueRulesGetAllSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LeagueRulesGetAllQuery, LeagueRulesGetAllQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LeagueRulesGetAllQuery, LeagueRulesGetAllQueryVariables>(LeagueRulesGetAllDocument, options);
        }
export type LeagueRulesGetAllQueryHookResult = ReturnType<typeof useLeagueRulesGetAllQuery>;
export type LeagueRulesGetAllLazyQueryHookResult = ReturnType<typeof useLeagueRulesGetAllLazyQuery>;
export type LeagueRulesGetAllSuspenseQueryHookResult = ReturnType<typeof useLeagueRulesGetAllSuspenseQuery>;
export type LeagueRulesGetAllQueryResult = Apollo.QueryResult<LeagueRulesGetAllQuery, LeagueRulesGetAllQueryVariables>;
export const LeagueRulesCreateDocument = gql`
    mutation LeagueRulesCreate($leagueRules: LeagueRulesInput!) {
  leagueRulesCreate(leagueRules: $leagueRules) {
    leagueRuleId
    financierTypes
    financingTypes
    competitionIds
    createdAt
    updatedAt
  }
}
    `;
export type LeagueRulesCreateMutationFn = Apollo.MutationFunction<LeagueRulesCreateMutation, LeagueRulesCreateMutationVariables>;

/**
 * __useLeagueRulesCreateMutation__
 *
 * To run a mutation, you first call `useLeagueRulesCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeagueRulesCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leagueRulesCreateMutation, { data, loading, error }] = useLeagueRulesCreateMutation({
 *   variables: {
 *      leagueRules: // value for 'leagueRules'
 *   },
 * });
 */
export function useLeagueRulesCreateMutation(baseOptions?: Apollo.MutationHookOptions<LeagueRulesCreateMutation, LeagueRulesCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeagueRulesCreateMutation, LeagueRulesCreateMutationVariables>(LeagueRulesCreateDocument, options);
      }
export type LeagueRulesCreateMutationHookResult = ReturnType<typeof useLeagueRulesCreateMutation>;
export type LeagueRulesCreateMutationResult = Apollo.MutationResult<LeagueRulesCreateMutation>;
export type LeagueRulesCreateMutationOptions = Apollo.BaseMutationOptions<LeagueRulesCreateMutation, LeagueRulesCreateMutationVariables>;
export const LeagueRulesUpdateDocument = gql`
    mutation LeagueRulesUpdate($leagueRuleId: ID!, $input: LeagueRulesInput!) {
  leagueRulesUpdate(leagueRuleId: $leagueRuleId, input: $input) {
    leagueRuleId
    financierTypes
    financingTypes
    competitionIds
    createdAt
    updatedAt
  }
}
    `;
export type LeagueRulesUpdateMutationFn = Apollo.MutationFunction<LeagueRulesUpdateMutation, LeagueRulesUpdateMutationVariables>;

/**
 * __useLeagueRulesUpdateMutation__
 *
 * To run a mutation, you first call `useLeagueRulesUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeagueRulesUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leagueRulesUpdateMutation, { data, loading, error }] = useLeagueRulesUpdateMutation({
 *   variables: {
 *      leagueRuleId: // value for 'leagueRuleId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLeagueRulesUpdateMutation(baseOptions?: Apollo.MutationHookOptions<LeagueRulesUpdateMutation, LeagueRulesUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeagueRulesUpdateMutation, LeagueRulesUpdateMutationVariables>(LeagueRulesUpdateDocument, options);
      }
export type LeagueRulesUpdateMutationHookResult = ReturnType<typeof useLeagueRulesUpdateMutation>;
export type LeagueRulesUpdateMutationResult = Apollo.MutationResult<LeagueRulesUpdateMutation>;
export type LeagueRulesUpdateMutationOptions = Apollo.BaseMutationOptions<LeagueRulesUpdateMutation, LeagueRulesUpdateMutationVariables>;
export const LeagueRulesDeleteDocument = gql`
    mutation LeagueRulesDelete($leagueRuleId: ID!) {
  leagueRulesDelete(leagueRuleId: $leagueRuleId)
}
    `;
export type LeagueRulesDeleteMutationFn = Apollo.MutationFunction<LeagueRulesDeleteMutation, LeagueRulesDeleteMutationVariables>;

/**
 * __useLeagueRulesDeleteMutation__
 *
 * To run a mutation, you first call `useLeagueRulesDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeagueRulesDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leagueRulesDeleteMutation, { data, loading, error }] = useLeagueRulesDeleteMutation({
 *   variables: {
 *      leagueRuleId: // value for 'leagueRuleId'
 *   },
 * });
 */
export function useLeagueRulesDeleteMutation(baseOptions?: Apollo.MutationHookOptions<LeagueRulesDeleteMutation, LeagueRulesDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeagueRulesDeleteMutation, LeagueRulesDeleteMutationVariables>(LeagueRulesDeleteDocument, options);
      }
export type LeagueRulesDeleteMutationHookResult = ReturnType<typeof useLeagueRulesDeleteMutation>;
export type LeagueRulesDeleteMutationResult = Apollo.MutationResult<LeagueRulesDeleteMutation>;
export type LeagueRulesDeleteMutationOptions = Apollo.BaseMutationOptions<LeagueRulesDeleteMutation, LeagueRulesDeleteMutationVariables>;
export const OnboardUserDocument = gql`
    mutation OnboardUser($inviteToken: String!, $userDetails: OnboardingUserDetails!) {
  onboardUser(inviteToken: $inviteToken, userDetails: $userDetails) {
    user {
      userId
      username
      email
      phoneNumber
      firstName
      middleName
      lastName
      userType
    }
    accessToken
  }
}
    `;
export type OnboardUserMutationFn = Apollo.MutationFunction<OnboardUserMutation, OnboardUserMutationVariables>;

/**
 * __useOnboardUserMutation__
 *
 * To run a mutation, you first call `useOnboardUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardUserMutation, { data, loading, error }] = useOnboardUserMutation({
 *   variables: {
 *      inviteToken: // value for 'inviteToken'
 *      userDetails: // value for 'userDetails'
 *   },
 * });
 */
export function useOnboardUserMutation(baseOptions?: Apollo.MutationHookOptions<OnboardUserMutation, OnboardUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardUserMutation, OnboardUserMutationVariables>(OnboardUserDocument, options);
      }
export type OnboardUserMutationHookResult = ReturnType<typeof useOnboardUserMutation>;
export type OnboardUserMutationResult = Apollo.MutationResult<OnboardUserMutation>;
export type OnboardUserMutationOptions = Apollo.BaseMutationOptions<OnboardUserMutation, OnboardUserMutationVariables>;
export const OnboardOrganisationDocument = gql`
    mutation OnboardOrganisation($inviteToken: String!, $organisationDetails: OnboardingOrganisationDetails!) {
  onboardOrganisation(
    inviteToken: $inviteToken
    organisationDetails: $organisationDetails
  ) {
    organisation {
      organisationId
      type
      licenseType
      name
      address
      postalCode
      billing {
        firstName
        lastName
        email
        phoneNumber
      }
      club {
        clubId
        officialName
      }
      player {
        playerId
        status
        firstName
        middleName
        lastName
        shortName
      }
    }
    accessToken
  }
}
    `;
export type OnboardOrganisationMutationFn = Apollo.MutationFunction<OnboardOrganisationMutation, OnboardOrganisationMutationVariables>;

/**
 * __useOnboardOrganisationMutation__
 *
 * To run a mutation, you first call `useOnboardOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardOrganisationMutation, { data, loading, error }] = useOnboardOrganisationMutation({
 *   variables: {
 *      inviteToken: // value for 'inviteToken'
 *      organisationDetails: // value for 'organisationDetails'
 *   },
 * });
 */
export function useOnboardOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<OnboardOrganisationMutation, OnboardOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardOrganisationMutation, OnboardOrganisationMutationVariables>(OnboardOrganisationDocument, options);
      }
export type OnboardOrganisationMutationHookResult = ReturnType<typeof useOnboardOrganisationMutation>;
export type OnboardOrganisationMutationResult = Apollo.MutationResult<OnboardOrganisationMutation>;
export type OnboardOrganisationMutationOptions = Apollo.BaseMutationOptions<OnboardOrganisationMutation, OnboardOrganisationMutationVariables>;
export const EnterOrganisationDocument = gql`
    mutation EnterOrganisation($inviteToken: String!) {
  enterOrganisation(inviteToken: $inviteToken)
}
    `;
export type EnterOrganisationMutationFn = Apollo.MutationFunction<EnterOrganisationMutation, EnterOrganisationMutationVariables>;

/**
 * __useEnterOrganisationMutation__
 *
 * To run a mutation, you first call `useEnterOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnterOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enterOrganisationMutation, { data, loading, error }] = useEnterOrganisationMutation({
 *   variables: {
 *      inviteToken: // value for 'inviteToken'
 *   },
 * });
 */
export function useEnterOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<EnterOrganisationMutation, EnterOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnterOrganisationMutation, EnterOrganisationMutationVariables>(EnterOrganisationDocument, options);
      }
export type EnterOrganisationMutationHookResult = ReturnType<typeof useEnterOrganisationMutation>;
export type EnterOrganisationMutationResult = Apollo.MutationResult<EnterOrganisationMutation>;
export type EnterOrganisationMutationOptions = Apollo.BaseMutationOptions<EnterOrganisationMutation, EnterOrganisationMutationVariables>;
export const UsersGetByOrganisationIdDocument = gql`
    query UsersGetByOrganisationId($organisationId: ID!) {
  usersGetByOrganisationId(organisationId: $organisationId) {
    userId
    username
    email
    phoneNumber
    firstName
    middleName
    lastName
    isEmailVerified
    userType
    createdAt
    lastLoginAt
    role
    permissions
  }
}
    `;

/**
 * __useUsersGetByOrganisationIdQuery__
 *
 * To run a query within a React component, call `useUsersGetByOrganisationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersGetByOrganisationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersGetByOrganisationIdQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useUsersGetByOrganisationIdQuery(baseOptions: Apollo.QueryHookOptions<UsersGetByOrganisationIdQuery, UsersGetByOrganisationIdQueryVariables> & ({ variables: UsersGetByOrganisationIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersGetByOrganisationIdQuery, UsersGetByOrganisationIdQueryVariables>(UsersGetByOrganisationIdDocument, options);
      }
export function useUsersGetByOrganisationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersGetByOrganisationIdQuery, UsersGetByOrganisationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersGetByOrganisationIdQuery, UsersGetByOrganisationIdQueryVariables>(UsersGetByOrganisationIdDocument, options);
        }
export function useUsersGetByOrganisationIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersGetByOrganisationIdQuery, UsersGetByOrganisationIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersGetByOrganisationIdQuery, UsersGetByOrganisationIdQueryVariables>(UsersGetByOrganisationIdDocument, options);
        }
export type UsersGetByOrganisationIdQueryHookResult = ReturnType<typeof useUsersGetByOrganisationIdQuery>;
export type UsersGetByOrganisationIdLazyQueryHookResult = ReturnType<typeof useUsersGetByOrganisationIdLazyQuery>;
export type UsersGetByOrganisationIdSuspenseQueryHookResult = ReturnType<typeof useUsersGetByOrganisationIdSuspenseQuery>;
export type UsersGetByOrganisationIdQueryResult = Apollo.QueryResult<UsersGetByOrganisationIdQuery, UsersGetByOrganisationIdQueryVariables>;
export const OrganisationsUpdateProfileDocument = gql`
    mutation OrganisationsUpdateProfile($organisationId: ID!, $organisationProfileDetails: OrganisationProfileDetails) {
  organisationsUpdateProfile(
    organisationId: $organisationId
    organisationProfileDetails: $organisationProfileDetails
  ) {
    success
  }
}
    `;
export type OrganisationsUpdateProfileMutationFn = Apollo.MutationFunction<OrganisationsUpdateProfileMutation, OrganisationsUpdateProfileMutationVariables>;

/**
 * __useOrganisationsUpdateProfileMutation__
 *
 * To run a mutation, you first call `useOrganisationsUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationsUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationsUpdateProfileMutation, { data, loading, error }] = useOrganisationsUpdateProfileMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      organisationProfileDetails: // value for 'organisationProfileDetails'
 *   },
 * });
 */
export function useOrganisationsUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationsUpdateProfileMutation, OrganisationsUpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationsUpdateProfileMutation, OrganisationsUpdateProfileMutationVariables>(OrganisationsUpdateProfileDocument, options);
      }
export type OrganisationsUpdateProfileMutationHookResult = ReturnType<typeof useOrganisationsUpdateProfileMutation>;
export type OrganisationsUpdateProfileMutationResult = Apollo.MutationResult<OrganisationsUpdateProfileMutation>;
export type OrganisationsUpdateProfileMutationOptions = Apollo.BaseMutationOptions<OrganisationsUpdateProfileMutation, OrganisationsUpdateProfileMutationVariables>;
export const OrganisationsGetAllByQueryDocument = gql`
    query OrganisationsGetAllByQuery($searchDetails: OrganisationsSearchDetails, $paginationDetails: PaginationDetails!) {
  organisationsGetAllByQuery(
    searchDetails: $searchDetails
    paginationDetails: $paginationDetails
  ) {
    organisationId
    name
    type
    address
    postalCode
    countryId
    createdAt
    usersCount
    club {
      officialName
    }
  }
}
    `;

/**
 * __useOrganisationsGetAllByQueryQuery__
 *
 * To run a query within a React component, call `useOrganisationsGetAllByQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationsGetAllByQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationsGetAllByQueryQuery({
 *   variables: {
 *      searchDetails: // value for 'searchDetails'
 *      paginationDetails: // value for 'paginationDetails'
 *   },
 * });
 */
export function useOrganisationsGetAllByQueryQuery(baseOptions: Apollo.QueryHookOptions<OrganisationsGetAllByQueryQuery, OrganisationsGetAllByQueryQueryVariables> & ({ variables: OrganisationsGetAllByQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationsGetAllByQueryQuery, OrganisationsGetAllByQueryQueryVariables>(OrganisationsGetAllByQueryDocument, options);
      }
export function useOrganisationsGetAllByQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationsGetAllByQueryQuery, OrganisationsGetAllByQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationsGetAllByQueryQuery, OrganisationsGetAllByQueryQueryVariables>(OrganisationsGetAllByQueryDocument, options);
        }
export function useOrganisationsGetAllByQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationsGetAllByQueryQuery, OrganisationsGetAllByQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationsGetAllByQueryQuery, OrganisationsGetAllByQueryQueryVariables>(OrganisationsGetAllByQueryDocument, options);
        }
export type OrganisationsGetAllByQueryQueryHookResult = ReturnType<typeof useOrganisationsGetAllByQueryQuery>;
export type OrganisationsGetAllByQueryLazyQueryHookResult = ReturnType<typeof useOrganisationsGetAllByQueryLazyQuery>;
export type OrganisationsGetAllByQuerySuspenseQueryHookResult = ReturnType<typeof useOrganisationsGetAllByQuerySuspenseQuery>;
export type OrganisationsGetAllByQueryQueryResult = Apollo.QueryResult<OrganisationsGetAllByQueryQuery, OrganisationsGetAllByQueryQueryVariables>;
export const OrganisationsUpdateFinancierProfileDocument = gql`
    mutation OrganisationsUpdateFinancierProfile($organisationId: ID!, $organisationFinancierProfileDetails: OrganisationFinancierProfileDetails) {
  organisationsUpdateFinancierProfile(
    organisationId: $organisationId
    organisationFinancierProfileDetails: $organisationFinancierProfileDetails
  ) {
    success
  }
}
    `;
export type OrganisationsUpdateFinancierProfileMutationFn = Apollo.MutationFunction<OrganisationsUpdateFinancierProfileMutation, OrganisationsUpdateFinancierProfileMutationVariables>;

/**
 * __useOrganisationsUpdateFinancierProfileMutation__
 *
 * To run a mutation, you first call `useOrganisationsUpdateFinancierProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationsUpdateFinancierProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationsUpdateFinancierProfileMutation, { data, loading, error }] = useOrganisationsUpdateFinancierProfileMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      organisationFinancierProfileDetails: // value for 'organisationFinancierProfileDetails'
 *   },
 * });
 */
export function useOrganisationsUpdateFinancierProfileMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationsUpdateFinancierProfileMutation, OrganisationsUpdateFinancierProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationsUpdateFinancierProfileMutation, OrganisationsUpdateFinancierProfileMutationVariables>(OrganisationsUpdateFinancierProfileDocument, options);
      }
export type OrganisationsUpdateFinancierProfileMutationHookResult = ReturnType<typeof useOrganisationsUpdateFinancierProfileMutation>;
export type OrganisationsUpdateFinancierProfileMutationResult = Apollo.MutationResult<OrganisationsUpdateFinancierProfileMutation>;
export type OrganisationsUpdateFinancierProfileMutationOptions = Apollo.BaseMutationOptions<OrganisationsUpdateFinancierProfileMutation, OrganisationsUpdateFinancierProfileMutationVariables>;
export const OrganisationsGetAllFinanciersDocument = gql`
    query OrganisationsGetAllFinanciers($paginationDetails: PaginationDetails!) {
  organisationsGetAllByQuery(
    searchDetails: {types: [FINANCIER]}
    paginationDetails: $paginationDetails
  ) {
    organisationId
    name
    type
    financierProfile {
      financingTypes
      allowedFinancingTypes
      privacyPolicyUrl
    }
  }
}
    `;

/**
 * __useOrganisationsGetAllFinanciersQuery__
 *
 * To run a query within a React component, call `useOrganisationsGetAllFinanciersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationsGetAllFinanciersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationsGetAllFinanciersQuery({
 *   variables: {
 *      paginationDetails: // value for 'paginationDetails'
 *   },
 * });
 */
export function useOrganisationsGetAllFinanciersQuery(baseOptions: Apollo.QueryHookOptions<OrganisationsGetAllFinanciersQuery, OrganisationsGetAllFinanciersQueryVariables> & ({ variables: OrganisationsGetAllFinanciersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationsGetAllFinanciersQuery, OrganisationsGetAllFinanciersQueryVariables>(OrganisationsGetAllFinanciersDocument, options);
      }
export function useOrganisationsGetAllFinanciersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationsGetAllFinanciersQuery, OrganisationsGetAllFinanciersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationsGetAllFinanciersQuery, OrganisationsGetAllFinanciersQueryVariables>(OrganisationsGetAllFinanciersDocument, options);
        }
export function useOrganisationsGetAllFinanciersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationsGetAllFinanciersQuery, OrganisationsGetAllFinanciersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationsGetAllFinanciersQuery, OrganisationsGetAllFinanciersQueryVariables>(OrganisationsGetAllFinanciersDocument, options);
        }
export type OrganisationsGetAllFinanciersQueryHookResult = ReturnType<typeof useOrganisationsGetAllFinanciersQuery>;
export type OrganisationsGetAllFinanciersLazyQueryHookResult = ReturnType<typeof useOrganisationsGetAllFinanciersLazyQuery>;
export type OrganisationsGetAllFinanciersSuspenseQueryHookResult = ReturnType<typeof useOrganisationsGetAllFinanciersSuspenseQuery>;
export type OrganisationsGetAllFinanciersQueryResult = Apollo.QueryResult<OrganisationsGetAllFinanciersQuery, OrganisationsGetAllFinanciersQueryVariables>;
export const OrganisationsGetFinancierProfileDocument = gql`
    query OrganisationsGetFinancierProfile($organisationId: ID!) {
  organisationsGetFinancierProfile(organisationId: $organisationId) {
    financingTypes
    allowedFinancingTypes
    financierType
    privacyPolicyUrl
    ticketSize
    criteria {
      groups {
        financingType
        organisationCountry
        organisationCountryInclude
        totalLoanAmount {
          min
          max
          calculationCurrency
          currency
        }
        loanTerm
        loanTermInclude
        organisationType {
          gpe
          club {
            competition
            competitionInclude
            country
            countryInclude
            debtorRiskCountry
            debtorRiskCountryInclude
            blacklistedClubIds
          }
        }
      }
    }
  }
}
    `;

/**
 * __useOrganisationsGetFinancierProfileQuery__
 *
 * To run a query within a React component, call `useOrganisationsGetFinancierProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationsGetFinancierProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationsGetFinancierProfileQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useOrganisationsGetFinancierProfileQuery(baseOptions: Apollo.QueryHookOptions<OrganisationsGetFinancierProfileQuery, OrganisationsGetFinancierProfileQueryVariables> & ({ variables: OrganisationsGetFinancierProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationsGetFinancierProfileQuery, OrganisationsGetFinancierProfileQueryVariables>(OrganisationsGetFinancierProfileDocument, options);
      }
export function useOrganisationsGetFinancierProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationsGetFinancierProfileQuery, OrganisationsGetFinancierProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationsGetFinancierProfileQuery, OrganisationsGetFinancierProfileQueryVariables>(OrganisationsGetFinancierProfileDocument, options);
        }
export function useOrganisationsGetFinancierProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationsGetFinancierProfileQuery, OrganisationsGetFinancierProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationsGetFinancierProfileQuery, OrganisationsGetFinancierProfileQueryVariables>(OrganisationsGetFinancierProfileDocument, options);
        }
export type OrganisationsGetFinancierProfileQueryHookResult = ReturnType<typeof useOrganisationsGetFinancierProfileQuery>;
export type OrganisationsGetFinancierProfileLazyQueryHookResult = ReturnType<typeof useOrganisationsGetFinancierProfileLazyQuery>;
export type OrganisationsGetFinancierProfileSuspenseQueryHookResult = ReturnType<typeof useOrganisationsGetFinancierProfileSuspenseQuery>;
export type OrganisationsGetFinancierProfileQueryResult = Apollo.QueryResult<OrganisationsGetFinancierProfileQuery, OrganisationsGetFinancierProfileQueryVariables>;
export const OrganisationsGetByCurrentUserDocument = gql`
    query OrganisationsGetByCurrentUser {
  organisationsGetByCurrentUser {
    organisationId
    type
    name
    role
    permissions
    isDefault
  }
}
    `;

/**
 * __useOrganisationsGetByCurrentUserQuery__
 *
 * To run a query within a React component, call `useOrganisationsGetByCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationsGetByCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationsGetByCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganisationsGetByCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<OrganisationsGetByCurrentUserQuery, OrganisationsGetByCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationsGetByCurrentUserQuery, OrganisationsGetByCurrentUserQueryVariables>(OrganisationsGetByCurrentUserDocument, options);
      }
export function useOrganisationsGetByCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationsGetByCurrentUserQuery, OrganisationsGetByCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationsGetByCurrentUserQuery, OrganisationsGetByCurrentUserQueryVariables>(OrganisationsGetByCurrentUserDocument, options);
        }
export function useOrganisationsGetByCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationsGetByCurrentUserQuery, OrganisationsGetByCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationsGetByCurrentUserQuery, OrganisationsGetByCurrentUserQueryVariables>(OrganisationsGetByCurrentUserDocument, options);
        }
export type OrganisationsGetByCurrentUserQueryHookResult = ReturnType<typeof useOrganisationsGetByCurrentUserQuery>;
export type OrganisationsGetByCurrentUserLazyQueryHookResult = ReturnType<typeof useOrganisationsGetByCurrentUserLazyQuery>;
export type OrganisationsGetByCurrentUserSuspenseQueryHookResult = ReturnType<typeof useOrganisationsGetByCurrentUserSuspenseQuery>;
export type OrganisationsGetByCurrentUserQueryResult = Apollo.QueryResult<OrganisationsGetByCurrentUserQuery, OrganisationsGetByCurrentUserQueryVariables>;
export const OrganisationsGetByIdDocument = gql`
    query OrganisationsGetById($organisationId: ID!) {
  organisationsGetById(organisationId: $organisationId) {
    organisationId
    type
    name
  }
}
    `;

/**
 * __useOrganisationsGetByIdQuery__
 *
 * To run a query within a React component, call `useOrganisationsGetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationsGetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationsGetByIdQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useOrganisationsGetByIdQuery(baseOptions: Apollo.QueryHookOptions<OrganisationsGetByIdQuery, OrganisationsGetByIdQueryVariables> & ({ variables: OrganisationsGetByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationsGetByIdQuery, OrganisationsGetByIdQueryVariables>(OrganisationsGetByIdDocument, options);
      }
export function useOrganisationsGetByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationsGetByIdQuery, OrganisationsGetByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationsGetByIdQuery, OrganisationsGetByIdQueryVariables>(OrganisationsGetByIdDocument, options);
        }
export function useOrganisationsGetByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationsGetByIdQuery, OrganisationsGetByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationsGetByIdQuery, OrganisationsGetByIdQueryVariables>(OrganisationsGetByIdDocument, options);
        }
export type OrganisationsGetByIdQueryHookResult = ReturnType<typeof useOrganisationsGetByIdQuery>;
export type OrganisationsGetByIdLazyQueryHookResult = ReturnType<typeof useOrganisationsGetByIdLazyQuery>;
export type OrganisationsGetByIdSuspenseQueryHookResult = ReturnType<typeof useOrganisationsGetByIdSuspenseQuery>;
export type OrganisationsGetByIdQueryResult = Apollo.QueryResult<OrganisationsGetByIdQuery, OrganisationsGetByIdQueryVariables>;
export const FinancingTypeExclusivityDocument = gql`
    query FinancingTypeExclusivity($financingType: FinancingType) {
  financingTypeExclusivity(financingType: $financingType) {
    financingType
    organisationIds
  }
}
    `;

/**
 * __useFinancingTypeExclusivityQuery__
 *
 * To run a query within a React component, call `useFinancingTypeExclusivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancingTypeExclusivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancingTypeExclusivityQuery({
 *   variables: {
 *      financingType: // value for 'financingType'
 *   },
 * });
 */
export function useFinancingTypeExclusivityQuery(baseOptions?: Apollo.QueryHookOptions<FinancingTypeExclusivityQuery, FinancingTypeExclusivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancingTypeExclusivityQuery, FinancingTypeExclusivityQueryVariables>(FinancingTypeExclusivityDocument, options);
      }
export function useFinancingTypeExclusivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancingTypeExclusivityQuery, FinancingTypeExclusivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancingTypeExclusivityQuery, FinancingTypeExclusivityQueryVariables>(FinancingTypeExclusivityDocument, options);
        }
export function useFinancingTypeExclusivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinancingTypeExclusivityQuery, FinancingTypeExclusivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinancingTypeExclusivityQuery, FinancingTypeExclusivityQueryVariables>(FinancingTypeExclusivityDocument, options);
        }
export type FinancingTypeExclusivityQueryHookResult = ReturnType<typeof useFinancingTypeExclusivityQuery>;
export type FinancingTypeExclusivityLazyQueryHookResult = ReturnType<typeof useFinancingTypeExclusivityLazyQuery>;
export type FinancingTypeExclusivitySuspenseQueryHookResult = ReturnType<typeof useFinancingTypeExclusivitySuspenseQuery>;
export type FinancingTypeExclusivityQueryResult = Apollo.QueryResult<FinancingTypeExclusivityQuery, FinancingTypeExclusivityQueryVariables>;
export const OrganisationsGetPaginatedDocument = gql`
    query OrganisationsGetPaginated($pagination: PaginationInput!, $sorting: SortInput, $filters: [FilterInput!], $search: String) {
  organisationsGetPaginated(
    pagination: $pagination
    sorting: $sorting
    filters: $filters
    search: $search
  ) {
    items {
      organisationId
      name
      type
      address
      postalCode
      countryId
      createdAt
      usersCount
      club {
        officialName
      }
    }
    pagination {
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useOrganisationsGetPaginatedQuery__
 *
 * To run a query within a React component, call `useOrganisationsGetPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationsGetPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationsGetPaginatedQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sorting: // value for 'sorting'
 *      filters: // value for 'filters'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useOrganisationsGetPaginatedQuery(baseOptions: Apollo.QueryHookOptions<OrganisationsGetPaginatedQuery, OrganisationsGetPaginatedQueryVariables> & ({ variables: OrganisationsGetPaginatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationsGetPaginatedQuery, OrganisationsGetPaginatedQueryVariables>(OrganisationsGetPaginatedDocument, options);
      }
export function useOrganisationsGetPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationsGetPaginatedQuery, OrganisationsGetPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationsGetPaginatedQuery, OrganisationsGetPaginatedQueryVariables>(OrganisationsGetPaginatedDocument, options);
        }
export function useOrganisationsGetPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationsGetPaginatedQuery, OrganisationsGetPaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationsGetPaginatedQuery, OrganisationsGetPaginatedQueryVariables>(OrganisationsGetPaginatedDocument, options);
        }
export type OrganisationsGetPaginatedQueryHookResult = ReturnType<typeof useOrganisationsGetPaginatedQuery>;
export type OrganisationsGetPaginatedLazyQueryHookResult = ReturnType<typeof useOrganisationsGetPaginatedLazyQuery>;
export type OrganisationsGetPaginatedSuspenseQueryHookResult = ReturnType<typeof useOrganisationsGetPaginatedSuspenseQuery>;
export type OrganisationsGetPaginatedQueryResult = Apollo.QueryResult<OrganisationsGetPaginatedQuery, OrganisationsGetPaginatedQueryVariables>;
export const FinancingTypeExclusivityGetDocument = gql`
    query FinancingTypeExclusivityGet($financingType: FinancingType) {
  financingTypeExclusivity(financingType: $financingType) {
    financingType
    organisationIds
  }
}
    `;

/**
 * __useFinancingTypeExclusivityGetQuery__
 *
 * To run a query within a React component, call `useFinancingTypeExclusivityGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancingTypeExclusivityGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancingTypeExclusivityGetQuery({
 *   variables: {
 *      financingType: // value for 'financingType'
 *   },
 * });
 */
export function useFinancingTypeExclusivityGetQuery(baseOptions?: Apollo.QueryHookOptions<FinancingTypeExclusivityGetQuery, FinancingTypeExclusivityGetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancingTypeExclusivityGetQuery, FinancingTypeExclusivityGetQueryVariables>(FinancingTypeExclusivityGetDocument, options);
      }
export function useFinancingTypeExclusivityGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancingTypeExclusivityGetQuery, FinancingTypeExclusivityGetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancingTypeExclusivityGetQuery, FinancingTypeExclusivityGetQueryVariables>(FinancingTypeExclusivityGetDocument, options);
        }
export function useFinancingTypeExclusivityGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinancingTypeExclusivityGetQuery, FinancingTypeExclusivityGetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinancingTypeExclusivityGetQuery, FinancingTypeExclusivityGetQueryVariables>(FinancingTypeExclusivityGetDocument, options);
        }
export type FinancingTypeExclusivityGetQueryHookResult = ReturnType<typeof useFinancingTypeExclusivityGetQuery>;
export type FinancingTypeExclusivityGetLazyQueryHookResult = ReturnType<typeof useFinancingTypeExclusivityGetLazyQuery>;
export type FinancingTypeExclusivityGetSuspenseQueryHookResult = ReturnType<typeof useFinancingTypeExclusivityGetSuspenseQuery>;
export type FinancingTypeExclusivityGetQueryResult = Apollo.QueryResult<FinancingTypeExclusivityGetQuery, FinancingTypeExclusivityGetQueryVariables>;
export const FinancingTypeExclusivityHasExclusivityDocument = gql`
    query FinancingTypeExclusivityHasExclusivity($financingType: FinancingType!) {
  financingTypeExclusivityHasExclusivity(financingType: $financingType)
}
    `;

/**
 * __useFinancingTypeExclusivityHasExclusivityQuery__
 *
 * To run a query within a React component, call `useFinancingTypeExclusivityHasExclusivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancingTypeExclusivityHasExclusivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancingTypeExclusivityHasExclusivityQuery({
 *   variables: {
 *      financingType: // value for 'financingType'
 *   },
 * });
 */
export function useFinancingTypeExclusivityHasExclusivityQuery(baseOptions: Apollo.QueryHookOptions<FinancingTypeExclusivityHasExclusivityQuery, FinancingTypeExclusivityHasExclusivityQueryVariables> & ({ variables: FinancingTypeExclusivityHasExclusivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancingTypeExclusivityHasExclusivityQuery, FinancingTypeExclusivityHasExclusivityQueryVariables>(FinancingTypeExclusivityHasExclusivityDocument, options);
      }
export function useFinancingTypeExclusivityHasExclusivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancingTypeExclusivityHasExclusivityQuery, FinancingTypeExclusivityHasExclusivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancingTypeExclusivityHasExclusivityQuery, FinancingTypeExclusivityHasExclusivityQueryVariables>(FinancingTypeExclusivityHasExclusivityDocument, options);
        }
export function useFinancingTypeExclusivityHasExclusivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinancingTypeExclusivityHasExclusivityQuery, FinancingTypeExclusivityHasExclusivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinancingTypeExclusivityHasExclusivityQuery, FinancingTypeExclusivityHasExclusivityQueryVariables>(FinancingTypeExclusivityHasExclusivityDocument, options);
        }
export type FinancingTypeExclusivityHasExclusivityQueryHookResult = ReturnType<typeof useFinancingTypeExclusivityHasExclusivityQuery>;
export type FinancingTypeExclusivityHasExclusivityLazyQueryHookResult = ReturnType<typeof useFinancingTypeExclusivityHasExclusivityLazyQuery>;
export type FinancingTypeExclusivityHasExclusivitySuspenseQueryHookResult = ReturnType<typeof useFinancingTypeExclusivityHasExclusivitySuspenseQuery>;
export type FinancingTypeExclusivityHasExclusivityQueryResult = Apollo.QueryResult<FinancingTypeExclusivityHasExclusivityQuery, FinancingTypeExclusivityHasExclusivityQueryVariables>;
export const FinancingTypeExclusivityGetExclusiveOrganisationIdsDocument = gql`
    query FinancingTypeExclusivityGetExclusiveOrganisationIds($financingType: FinancingType!) {
  financingTypeExclusivityGetExclusiveOrganisationIds(
    financingType: $financingType
  )
}
    `;

/**
 * __useFinancingTypeExclusivityGetExclusiveOrganisationIdsQuery__
 *
 * To run a query within a React component, call `useFinancingTypeExclusivityGetExclusiveOrganisationIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancingTypeExclusivityGetExclusiveOrganisationIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancingTypeExclusivityGetExclusiveOrganisationIdsQuery({
 *   variables: {
 *      financingType: // value for 'financingType'
 *   },
 * });
 */
export function useFinancingTypeExclusivityGetExclusiveOrganisationIdsQuery(baseOptions: Apollo.QueryHookOptions<FinancingTypeExclusivityGetExclusiveOrganisationIdsQuery, FinancingTypeExclusivityGetExclusiveOrganisationIdsQueryVariables> & ({ variables: FinancingTypeExclusivityGetExclusiveOrganisationIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancingTypeExclusivityGetExclusiveOrganisationIdsQuery, FinancingTypeExclusivityGetExclusiveOrganisationIdsQueryVariables>(FinancingTypeExclusivityGetExclusiveOrganisationIdsDocument, options);
      }
export function useFinancingTypeExclusivityGetExclusiveOrganisationIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancingTypeExclusivityGetExclusiveOrganisationIdsQuery, FinancingTypeExclusivityGetExclusiveOrganisationIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancingTypeExclusivityGetExclusiveOrganisationIdsQuery, FinancingTypeExclusivityGetExclusiveOrganisationIdsQueryVariables>(FinancingTypeExclusivityGetExclusiveOrganisationIdsDocument, options);
        }
export function useFinancingTypeExclusivityGetExclusiveOrganisationIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinancingTypeExclusivityGetExclusiveOrganisationIdsQuery, FinancingTypeExclusivityGetExclusiveOrganisationIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinancingTypeExclusivityGetExclusiveOrganisationIdsQuery, FinancingTypeExclusivityGetExclusiveOrganisationIdsQueryVariables>(FinancingTypeExclusivityGetExclusiveOrganisationIdsDocument, options);
        }
export type FinancingTypeExclusivityGetExclusiveOrganisationIdsQueryHookResult = ReturnType<typeof useFinancingTypeExclusivityGetExclusiveOrganisationIdsQuery>;
export type FinancingTypeExclusivityGetExclusiveOrganisationIdsLazyQueryHookResult = ReturnType<typeof useFinancingTypeExclusivityGetExclusiveOrganisationIdsLazyQuery>;
export type FinancingTypeExclusivityGetExclusiveOrganisationIdsSuspenseQueryHookResult = ReturnType<typeof useFinancingTypeExclusivityGetExclusiveOrganisationIdsSuspenseQuery>;
export type FinancingTypeExclusivityGetExclusiveOrganisationIdsQueryResult = Apollo.QueryResult<FinancingTypeExclusivityGetExclusiveOrganisationIdsQuery, FinancingTypeExclusivityGetExclusiveOrganisationIdsQueryVariables>;
export const FinancingTypeExclusivityIsOrganisationExclusiveDocument = gql`
    query FinancingTypeExclusivityIsOrganisationExclusive($financingType: FinancingType!, $organisationId: ID!) {
  financingTypeExclusivityIsOrganisationExclusive(
    financingType: $financingType
    organisationId: $organisationId
  )
}
    `;

/**
 * __useFinancingTypeExclusivityIsOrganisationExclusiveQuery__
 *
 * To run a query within a React component, call `useFinancingTypeExclusivityIsOrganisationExclusiveQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancingTypeExclusivityIsOrganisationExclusiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancingTypeExclusivityIsOrganisationExclusiveQuery({
 *   variables: {
 *      financingType: // value for 'financingType'
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useFinancingTypeExclusivityIsOrganisationExclusiveQuery(baseOptions: Apollo.QueryHookOptions<FinancingTypeExclusivityIsOrganisationExclusiveQuery, FinancingTypeExclusivityIsOrganisationExclusiveQueryVariables> & ({ variables: FinancingTypeExclusivityIsOrganisationExclusiveQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancingTypeExclusivityIsOrganisationExclusiveQuery, FinancingTypeExclusivityIsOrganisationExclusiveQueryVariables>(FinancingTypeExclusivityIsOrganisationExclusiveDocument, options);
      }
export function useFinancingTypeExclusivityIsOrganisationExclusiveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancingTypeExclusivityIsOrganisationExclusiveQuery, FinancingTypeExclusivityIsOrganisationExclusiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancingTypeExclusivityIsOrganisationExclusiveQuery, FinancingTypeExclusivityIsOrganisationExclusiveQueryVariables>(FinancingTypeExclusivityIsOrganisationExclusiveDocument, options);
        }
export function useFinancingTypeExclusivityIsOrganisationExclusiveSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinancingTypeExclusivityIsOrganisationExclusiveQuery, FinancingTypeExclusivityIsOrganisationExclusiveQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinancingTypeExclusivityIsOrganisationExclusiveQuery, FinancingTypeExclusivityIsOrganisationExclusiveQueryVariables>(FinancingTypeExclusivityIsOrganisationExclusiveDocument, options);
        }
export type FinancingTypeExclusivityIsOrganisationExclusiveQueryHookResult = ReturnType<typeof useFinancingTypeExclusivityIsOrganisationExclusiveQuery>;
export type FinancingTypeExclusivityIsOrganisationExclusiveLazyQueryHookResult = ReturnType<typeof useFinancingTypeExclusivityIsOrganisationExclusiveLazyQuery>;
export type FinancingTypeExclusivityIsOrganisationExclusiveSuspenseQueryHookResult = ReturnType<typeof useFinancingTypeExclusivityIsOrganisationExclusiveSuspenseQuery>;
export type FinancingTypeExclusivityIsOrganisationExclusiveQueryResult = Apollo.QueryResult<FinancingTypeExclusivityIsOrganisationExclusiveQuery, FinancingTypeExclusivityIsOrganisationExclusiveQueryVariables>;
export const FinancingTypeExclusivityGetAllDocument = gql`
    query FinancingTypeExclusivityGetAll {
  financingTypeExclusivityGetAll {
    financingTypeExclusivityId
    financingType
    organisationId
    isActive
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useFinancingTypeExclusivityGetAllQuery__
 *
 * To run a query within a React component, call `useFinancingTypeExclusivityGetAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancingTypeExclusivityGetAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancingTypeExclusivityGetAllQuery({
 *   variables: {
 *   },
 * });
 */
export function useFinancingTypeExclusivityGetAllQuery(baseOptions?: Apollo.QueryHookOptions<FinancingTypeExclusivityGetAllQuery, FinancingTypeExclusivityGetAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancingTypeExclusivityGetAllQuery, FinancingTypeExclusivityGetAllQueryVariables>(FinancingTypeExclusivityGetAllDocument, options);
      }
export function useFinancingTypeExclusivityGetAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancingTypeExclusivityGetAllQuery, FinancingTypeExclusivityGetAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancingTypeExclusivityGetAllQuery, FinancingTypeExclusivityGetAllQueryVariables>(FinancingTypeExclusivityGetAllDocument, options);
        }
export function useFinancingTypeExclusivityGetAllSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinancingTypeExclusivityGetAllQuery, FinancingTypeExclusivityGetAllQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinancingTypeExclusivityGetAllQuery, FinancingTypeExclusivityGetAllQueryVariables>(FinancingTypeExclusivityGetAllDocument, options);
        }
export type FinancingTypeExclusivityGetAllQueryHookResult = ReturnType<typeof useFinancingTypeExclusivityGetAllQuery>;
export type FinancingTypeExclusivityGetAllLazyQueryHookResult = ReturnType<typeof useFinancingTypeExclusivityGetAllLazyQuery>;
export type FinancingTypeExclusivityGetAllSuspenseQueryHookResult = ReturnType<typeof useFinancingTypeExclusivityGetAllSuspenseQuery>;
export type FinancingTypeExclusivityGetAllQueryResult = Apollo.QueryResult<FinancingTypeExclusivityGetAllQuery, FinancingTypeExclusivityGetAllQueryVariables>;
export const FinancingTypeExclusivityGetGroupedByTypeDocument = gql`
    query FinancingTypeExclusivityGetGroupedByType {
  financingTypeExclusivityGetGroupedByType {
    financingType
    organisationIds
  }
}
    `;

/**
 * __useFinancingTypeExclusivityGetGroupedByTypeQuery__
 *
 * To run a query within a React component, call `useFinancingTypeExclusivityGetGroupedByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancingTypeExclusivityGetGroupedByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancingTypeExclusivityGetGroupedByTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useFinancingTypeExclusivityGetGroupedByTypeQuery(baseOptions?: Apollo.QueryHookOptions<FinancingTypeExclusivityGetGroupedByTypeQuery, FinancingTypeExclusivityGetGroupedByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancingTypeExclusivityGetGroupedByTypeQuery, FinancingTypeExclusivityGetGroupedByTypeQueryVariables>(FinancingTypeExclusivityGetGroupedByTypeDocument, options);
      }
export function useFinancingTypeExclusivityGetGroupedByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancingTypeExclusivityGetGroupedByTypeQuery, FinancingTypeExclusivityGetGroupedByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancingTypeExclusivityGetGroupedByTypeQuery, FinancingTypeExclusivityGetGroupedByTypeQueryVariables>(FinancingTypeExclusivityGetGroupedByTypeDocument, options);
        }
export function useFinancingTypeExclusivityGetGroupedByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinancingTypeExclusivityGetGroupedByTypeQuery, FinancingTypeExclusivityGetGroupedByTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinancingTypeExclusivityGetGroupedByTypeQuery, FinancingTypeExclusivityGetGroupedByTypeQueryVariables>(FinancingTypeExclusivityGetGroupedByTypeDocument, options);
        }
export type FinancingTypeExclusivityGetGroupedByTypeQueryHookResult = ReturnType<typeof useFinancingTypeExclusivityGetGroupedByTypeQuery>;
export type FinancingTypeExclusivityGetGroupedByTypeLazyQueryHookResult = ReturnType<typeof useFinancingTypeExclusivityGetGroupedByTypeLazyQuery>;
export type FinancingTypeExclusivityGetGroupedByTypeSuspenseQueryHookResult = ReturnType<typeof useFinancingTypeExclusivityGetGroupedByTypeSuspenseQuery>;
export type FinancingTypeExclusivityGetGroupedByTypeQueryResult = Apollo.QueryResult<FinancingTypeExclusivityGetGroupedByTypeQuery, FinancingTypeExclusivityGetGroupedByTypeQueryVariables>;
export const OrganisationsUpdateFinancingTypeExclusivityDocument = gql`
    mutation OrganisationsUpdateFinancingTypeExclusivity($financingTypes: [FinancingType!]!, $exclusivityAction: ExclusivityAction!, $organisationIds: [ID!]!) {
  organisationsUpdateFinancingTypeExclusivity(
    financingTypes: $financingTypes
    exclusivityAction: $exclusivityAction
    organisationIds: $organisationIds
  ) {
    success
  }
}
    `;
export type OrganisationsUpdateFinancingTypeExclusivityMutationFn = Apollo.MutationFunction<OrganisationsUpdateFinancingTypeExclusivityMutation, OrganisationsUpdateFinancingTypeExclusivityMutationVariables>;

/**
 * __useOrganisationsUpdateFinancingTypeExclusivityMutation__
 *
 * To run a mutation, you first call `useOrganisationsUpdateFinancingTypeExclusivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationsUpdateFinancingTypeExclusivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationsUpdateFinancingTypeExclusivityMutation, { data, loading, error }] = useOrganisationsUpdateFinancingTypeExclusivityMutation({
 *   variables: {
 *      financingTypes: // value for 'financingTypes'
 *      exclusivityAction: // value for 'exclusivityAction'
 *      organisationIds: // value for 'organisationIds'
 *   },
 * });
 */
export function useOrganisationsUpdateFinancingTypeExclusivityMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationsUpdateFinancingTypeExclusivityMutation, OrganisationsUpdateFinancingTypeExclusivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationsUpdateFinancingTypeExclusivityMutation, OrganisationsUpdateFinancingTypeExclusivityMutationVariables>(OrganisationsUpdateFinancingTypeExclusivityDocument, options);
      }
export type OrganisationsUpdateFinancingTypeExclusivityMutationHookResult = ReturnType<typeof useOrganisationsUpdateFinancingTypeExclusivityMutation>;
export type OrganisationsUpdateFinancingTypeExclusivityMutationResult = Apollo.MutationResult<OrganisationsUpdateFinancingTypeExclusivityMutation>;
export type OrganisationsUpdateFinancingTypeExclusivityMutationOptions = Apollo.BaseMutationOptions<OrganisationsUpdateFinancingTypeExclusivityMutation, OrganisationsUpdateFinancingTypeExclusivityMutationVariables>;
export const OrganisationsRemoveUserDocument = gql`
    mutation OrganisationsRemoveUser($organisationId: ID!, $userId: ID!) {
  organisationsRemoveUser(organisationId: $organisationId, userId: $userId) {
    success
  }
}
    `;
export type OrganisationsRemoveUserMutationFn = Apollo.MutationFunction<OrganisationsRemoveUserMutation, OrganisationsRemoveUserMutationVariables>;

/**
 * __useOrganisationsRemoveUserMutation__
 *
 * To run a mutation, you first call `useOrganisationsRemoveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationsRemoveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationsRemoveUserMutation, { data, loading, error }] = useOrganisationsRemoveUserMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useOrganisationsRemoveUserMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationsRemoveUserMutation, OrganisationsRemoveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationsRemoveUserMutation, OrganisationsRemoveUserMutationVariables>(OrganisationsRemoveUserDocument, options);
      }
export type OrganisationsRemoveUserMutationHookResult = ReturnType<typeof useOrganisationsRemoveUserMutation>;
export type OrganisationsRemoveUserMutationResult = Apollo.MutationResult<OrganisationsRemoveUserMutation>;
export type OrganisationsRemoveUserMutationOptions = Apollo.BaseMutationOptions<OrganisationsRemoveUserMutation, OrganisationsRemoveUserMutationVariables>;
export const PlayersGetAllByNameDocument = gql`
    query PlayersGetAllByName($name: String!, $paginationDetails: PaginationDetails!) {
  playersGetAllByName(name: $name, paginationDetails: $paginationDetails) {
    playerId
    firstName
    middleName
    lastName
    imageUrl
  }
}
    `;

/**
 * __usePlayersGetAllByNameQuery__
 *
 * To run a query within a React component, call `usePlayersGetAllByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayersGetAllByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayersGetAllByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *      paginationDetails: // value for 'paginationDetails'
 *   },
 * });
 */
export function usePlayersGetAllByNameQuery(baseOptions: Apollo.QueryHookOptions<PlayersGetAllByNameQuery, PlayersGetAllByNameQueryVariables> & ({ variables: PlayersGetAllByNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayersGetAllByNameQuery, PlayersGetAllByNameQueryVariables>(PlayersGetAllByNameDocument, options);
      }
export function usePlayersGetAllByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayersGetAllByNameQuery, PlayersGetAllByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayersGetAllByNameQuery, PlayersGetAllByNameQueryVariables>(PlayersGetAllByNameDocument, options);
        }
export function usePlayersGetAllByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayersGetAllByNameQuery, PlayersGetAllByNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayersGetAllByNameQuery, PlayersGetAllByNameQueryVariables>(PlayersGetAllByNameDocument, options);
        }
export type PlayersGetAllByNameQueryHookResult = ReturnType<typeof usePlayersGetAllByNameQuery>;
export type PlayersGetAllByNameLazyQueryHookResult = ReturnType<typeof usePlayersGetAllByNameLazyQuery>;
export type PlayersGetAllByNameSuspenseQueryHookResult = ReturnType<typeof usePlayersGetAllByNameSuspenseQuery>;
export type PlayersGetAllByNameQueryResult = Apollo.QueryResult<PlayersGetAllByNameQuery, PlayersGetAllByNameQueryVariables>;
export const PlayersGetByIdDocument = gql`
    query PlayersGetById($playerId: ID!) {
  playersGetById(playerId: $playerId) {
    playerId
    firstName
    middleName
    lastName
    imageUrl
  }
}
    `;

/**
 * __usePlayersGetByIdQuery__
 *
 * To run a query within a React component, call `usePlayersGetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayersGetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayersGetByIdQuery({
 *   variables: {
 *      playerId: // value for 'playerId'
 *   },
 * });
 */
export function usePlayersGetByIdQuery(baseOptions: Apollo.QueryHookOptions<PlayersGetByIdQuery, PlayersGetByIdQueryVariables> & ({ variables: PlayersGetByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayersGetByIdQuery, PlayersGetByIdQueryVariables>(PlayersGetByIdDocument, options);
      }
export function usePlayersGetByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayersGetByIdQuery, PlayersGetByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayersGetByIdQuery, PlayersGetByIdQueryVariables>(PlayersGetByIdDocument, options);
        }
export function usePlayersGetByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayersGetByIdQuery, PlayersGetByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayersGetByIdQuery, PlayersGetByIdQueryVariables>(PlayersGetByIdDocument, options);
        }
export type PlayersGetByIdQueryHookResult = ReturnType<typeof usePlayersGetByIdQuery>;
export type PlayersGetByIdLazyQueryHookResult = ReturnType<typeof usePlayersGetByIdLazyQuery>;
export type PlayersGetByIdSuspenseQueryHookResult = ReturnType<typeof usePlayersGetByIdSuspenseQuery>;
export type PlayersGetByIdQueryResult = Apollo.QueryResult<PlayersGetByIdQuery, PlayersGetByIdQueryVariables>;
export const PlayersWithClubGetByIdDocument = gql`
    query PlayersWithClubGetById($playerId: ID!) {
  playersGetById(playerId: $playerId) {
    playerId
    firstName
    middleName
    lastName
    imageUrl
    club {
      clubId
      officialName
      imageUrl
    }
  }
}
    `;

/**
 * __usePlayersWithClubGetByIdQuery__
 *
 * To run a query within a React component, call `usePlayersWithClubGetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayersWithClubGetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayersWithClubGetByIdQuery({
 *   variables: {
 *      playerId: // value for 'playerId'
 *   },
 * });
 */
export function usePlayersWithClubGetByIdQuery(baseOptions: Apollo.QueryHookOptions<PlayersWithClubGetByIdQuery, PlayersWithClubGetByIdQueryVariables> & ({ variables: PlayersWithClubGetByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayersWithClubGetByIdQuery, PlayersWithClubGetByIdQueryVariables>(PlayersWithClubGetByIdDocument, options);
      }
export function usePlayersWithClubGetByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayersWithClubGetByIdQuery, PlayersWithClubGetByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayersWithClubGetByIdQuery, PlayersWithClubGetByIdQueryVariables>(PlayersWithClubGetByIdDocument, options);
        }
export function usePlayersWithClubGetByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayersWithClubGetByIdQuery, PlayersWithClubGetByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayersWithClubGetByIdQuery, PlayersWithClubGetByIdQueryVariables>(PlayersWithClubGetByIdDocument, options);
        }
export type PlayersWithClubGetByIdQueryHookResult = ReturnType<typeof usePlayersWithClubGetByIdQuery>;
export type PlayersWithClubGetByIdLazyQueryHookResult = ReturnType<typeof usePlayersWithClubGetByIdLazyQuery>;
export type PlayersWithClubGetByIdSuspenseQueryHookResult = ReturnType<typeof usePlayersWithClubGetByIdSuspenseQuery>;
export type PlayersWithClubGetByIdQueryResult = Apollo.QueryResult<PlayersWithClubGetByIdQuery, PlayersWithClubGetByIdQueryVariables>;
export const PlayersWithDetailsGetByIdDocument = gql`
    query PlayersWithDetailsGetById($playerId: ID!, $filter: FilterContractsParams, $contractsFilter2: FilterContractsParams) {
  playersGetById(playerId: $playerId) {
    playerId
    firstName
    middleName
    lastName
    imageUrl
    organisation {
      organisationId
      type
      name
      contracts(filter: $filter) {
        contractId
        createdByOrganisationId
        sentToOrganisationId
        type
        status
      }
      users {
        userId
        email
        phoneNumber
        firstName
        middleName
        lastName
        role
      }
    }
    club {
      clubId
      officialName
      imageUrl
      organisation {
        organisationId
        type
        name
        contracts(filter: $contractsFilter2) {
          contractId
          createdByOrganisationId
          sentToOrganisationId
          type
          status
        }
        users {
          userId
          email
          phoneNumber
          firstName
          middleName
          lastName
          role
        }
      }
    }
  }
}
    `;

/**
 * __usePlayersWithDetailsGetByIdQuery__
 *
 * To run a query within a React component, call `usePlayersWithDetailsGetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayersWithDetailsGetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayersWithDetailsGetByIdQuery({
 *   variables: {
 *      playerId: // value for 'playerId'
 *      filter: // value for 'filter'
 *      contractsFilter2: // value for 'contractsFilter2'
 *   },
 * });
 */
export function usePlayersWithDetailsGetByIdQuery(baseOptions: Apollo.QueryHookOptions<PlayersWithDetailsGetByIdQuery, PlayersWithDetailsGetByIdQueryVariables> & ({ variables: PlayersWithDetailsGetByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayersWithDetailsGetByIdQuery, PlayersWithDetailsGetByIdQueryVariables>(PlayersWithDetailsGetByIdDocument, options);
      }
export function usePlayersWithDetailsGetByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayersWithDetailsGetByIdQuery, PlayersWithDetailsGetByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayersWithDetailsGetByIdQuery, PlayersWithDetailsGetByIdQueryVariables>(PlayersWithDetailsGetByIdDocument, options);
        }
export function usePlayersWithDetailsGetByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayersWithDetailsGetByIdQuery, PlayersWithDetailsGetByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayersWithDetailsGetByIdQuery, PlayersWithDetailsGetByIdQueryVariables>(PlayersWithDetailsGetByIdDocument, options);
        }
export type PlayersWithDetailsGetByIdQueryHookResult = ReturnType<typeof usePlayersWithDetailsGetByIdQuery>;
export type PlayersWithDetailsGetByIdLazyQueryHookResult = ReturnType<typeof usePlayersWithDetailsGetByIdLazyQuery>;
export type PlayersWithDetailsGetByIdSuspenseQueryHookResult = ReturnType<typeof usePlayersWithDetailsGetByIdSuspenseQuery>;
export type PlayersWithDetailsGetByIdQueryResult = Apollo.QueryResult<PlayersWithDetailsGetByIdQuery, PlayersWithDetailsGetByIdQueryVariables>;
export const ScopedUsageGetByFilterDocument = gql`
    query scopedUsageGetByFilter($filter: ScopedUsageFilter!) {
  scopedUsageGetByFilter(filter: $filter) {
    organisationId
    parentType
    parentId
    resourceType
    quotaUsed
    quota
  }
}
    `;

/**
 * __useScopedUsageGetByFilterQuery__
 *
 * To run a query within a React component, call `useScopedUsageGetByFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useScopedUsageGetByFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScopedUsageGetByFilterQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useScopedUsageGetByFilterQuery(baseOptions: Apollo.QueryHookOptions<ScopedUsageGetByFilterQuery, ScopedUsageGetByFilterQueryVariables> & ({ variables: ScopedUsageGetByFilterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScopedUsageGetByFilterQuery, ScopedUsageGetByFilterQueryVariables>(ScopedUsageGetByFilterDocument, options);
      }
export function useScopedUsageGetByFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScopedUsageGetByFilterQuery, ScopedUsageGetByFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScopedUsageGetByFilterQuery, ScopedUsageGetByFilterQueryVariables>(ScopedUsageGetByFilterDocument, options);
        }
export function useScopedUsageGetByFilterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScopedUsageGetByFilterQuery, ScopedUsageGetByFilterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScopedUsageGetByFilterQuery, ScopedUsageGetByFilterQueryVariables>(ScopedUsageGetByFilterDocument, options);
        }
export type ScopedUsageGetByFilterQueryHookResult = ReturnType<typeof useScopedUsageGetByFilterQuery>;
export type ScopedUsageGetByFilterLazyQueryHookResult = ReturnType<typeof useScopedUsageGetByFilterLazyQuery>;
export type ScopedUsageGetByFilterSuspenseQueryHookResult = ReturnType<typeof useScopedUsageGetByFilterSuspenseQuery>;
export type ScopedUsageGetByFilterQueryResult = Apollo.QueryResult<ScopedUsageGetByFilterQuery, ScopedUsageGetByFilterQueryVariables>;
export const SessionsGetCurrentDocument = gql`
    query SessionsGetCurrent {
  sessionsGetCurrent {
    isAuthenticated
    invite {
      inviteId
      token
      status
      contract
      transferDeal
    }
    user {
      userId
      username
      email
      phoneNumber
      firstName
      middleName
      lastName
      isEmailVerified
      userType
    }
    organisation {
      organisationId
      type
      licenseType
      name
      countryId
      address
      postalCode
      billing {
        firstName
        lastName
        email
        phoneNumber
      }
      club {
        clubId
        officialName
        imageUrl
      }
      role
      permissions
    }
  }
}
    `;

/**
 * __useSessionsGetCurrentQuery__
 *
 * To run a query within a React component, call `useSessionsGetCurrentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionsGetCurrentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionsGetCurrentQuery({
 *   variables: {
 *   },
 * });
 */
export function useSessionsGetCurrentQuery(baseOptions?: Apollo.QueryHookOptions<SessionsGetCurrentQuery, SessionsGetCurrentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SessionsGetCurrentQuery, SessionsGetCurrentQueryVariables>(SessionsGetCurrentDocument, options);
      }
export function useSessionsGetCurrentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SessionsGetCurrentQuery, SessionsGetCurrentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SessionsGetCurrentQuery, SessionsGetCurrentQueryVariables>(SessionsGetCurrentDocument, options);
        }
export function useSessionsGetCurrentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SessionsGetCurrentQuery, SessionsGetCurrentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SessionsGetCurrentQuery, SessionsGetCurrentQueryVariables>(SessionsGetCurrentDocument, options);
        }
export type SessionsGetCurrentQueryHookResult = ReturnType<typeof useSessionsGetCurrentQuery>;
export type SessionsGetCurrentLazyQueryHookResult = ReturnType<typeof useSessionsGetCurrentLazyQuery>;
export type SessionsGetCurrentSuspenseQueryHookResult = ReturnType<typeof useSessionsGetCurrentSuspenseQuery>;
export type SessionsGetCurrentQueryResult = Apollo.QueryResult<SessionsGetCurrentQuery, SessionsGetCurrentQueryVariables>;
export const TransferDealsGetByIdDocument = gql`
    query TransferDealsGetById($transferDealId: ID!) {
  transferDealsGetById(transferDealId: $transferDealId) {
    transferDealId
    buyingClubOrganisationId
    sellingClubOrganisationId
    playerOrganisationId
    playerTransferContractId
    playerContractId
    playerTransferContractDueDate
    playerContractDueDate
    executionDueDate
    status
    executionCreatedAt
    executedAt
    createdAt
    buyingClubOrganisation {
      users {
        firstName
        lastName
        middleName
        role
      }
      club {
        imageUrl
      }
    }
    sellingClubOrganisation {
      users {
        firstName
        lastName
        middleName
        role
      }
      club {
        imageUrl
      }
    }
    playerOrganisation {
      users {
        firstName
        lastName
        middleName
        role
      }
      player {
        imageUrl
      }
    }
    documents {
      buyingClubOrganisationAcceptedAt
      playerOrganisationAcceptedAt
      sellingClubOrganisationAcceptedAt
      uploadedByOrganisationId
    }
    playerContract {
      contractId
      createdByOrganisationId
      sentToOrganisationId
      type
      name
      status
      clauses {
        label
        isAccepted
        isModified
        versions {
          DRAFT {
            data
          }
          PROPOSED {
            data
            createdAt
          }
          ACCEPTED {
            data
            createdAt
          }
          REJECTED {
            data
            createdAt
          }
        }
      }
    }
    playerTransferContract {
      contractId
      createdByOrganisationId
      sentToOrganisationId
      type
      name
      status
      clauses {
        label
        isAccepted
        isModified
        versions {
          DRAFT {
            data
          }
          PROPOSED {
            data
            createdAt
          }
          ACCEPTED {
            data
            createdAt
          }
          REJECTED {
            data
            createdAt
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTransferDealsGetByIdQuery__
 *
 * To run a query within a React component, call `useTransferDealsGetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransferDealsGetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransferDealsGetByIdQuery({
 *   variables: {
 *      transferDealId: // value for 'transferDealId'
 *   },
 * });
 */
export function useTransferDealsGetByIdQuery(baseOptions: Apollo.QueryHookOptions<TransferDealsGetByIdQuery, TransferDealsGetByIdQueryVariables> & ({ variables: TransferDealsGetByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransferDealsGetByIdQuery, TransferDealsGetByIdQueryVariables>(TransferDealsGetByIdDocument, options);
      }
export function useTransferDealsGetByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransferDealsGetByIdQuery, TransferDealsGetByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransferDealsGetByIdQuery, TransferDealsGetByIdQueryVariables>(TransferDealsGetByIdDocument, options);
        }
export function useTransferDealsGetByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransferDealsGetByIdQuery, TransferDealsGetByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransferDealsGetByIdQuery, TransferDealsGetByIdQueryVariables>(TransferDealsGetByIdDocument, options);
        }
export type TransferDealsGetByIdQueryHookResult = ReturnType<typeof useTransferDealsGetByIdQuery>;
export type TransferDealsGetByIdLazyQueryHookResult = ReturnType<typeof useTransferDealsGetByIdLazyQuery>;
export type TransferDealsGetByIdSuspenseQueryHookResult = ReturnType<typeof useTransferDealsGetByIdSuspenseQuery>;
export type TransferDealsGetByIdQueryResult = Apollo.QueryResult<TransferDealsGetByIdQuery, TransferDealsGetByIdQueryVariables>;
export const TransferDealsEnterExecutionDocument = gql`
    mutation TransferDealsEnterExecution($transferDealId: ID!) {
  transferDealsEnterExecution(transferDealId: $transferDealId) {
    status
    executionCreatedAt
    executedAt
    createdAt
  }
}
    `;
export type TransferDealsEnterExecutionMutationFn = Apollo.MutationFunction<TransferDealsEnterExecutionMutation, TransferDealsEnterExecutionMutationVariables>;

/**
 * __useTransferDealsEnterExecutionMutation__
 *
 * To run a mutation, you first call `useTransferDealsEnterExecutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferDealsEnterExecutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferDealsEnterExecutionMutation, { data, loading, error }] = useTransferDealsEnterExecutionMutation({
 *   variables: {
 *      transferDealId: // value for 'transferDealId'
 *   },
 * });
 */
export function useTransferDealsEnterExecutionMutation(baseOptions?: Apollo.MutationHookOptions<TransferDealsEnterExecutionMutation, TransferDealsEnterExecutionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferDealsEnterExecutionMutation, TransferDealsEnterExecutionMutationVariables>(TransferDealsEnterExecutionDocument, options);
      }
export type TransferDealsEnterExecutionMutationHookResult = ReturnType<typeof useTransferDealsEnterExecutionMutation>;
export type TransferDealsEnterExecutionMutationResult = Apollo.MutationResult<TransferDealsEnterExecutionMutation>;
export type TransferDealsEnterExecutionMutationOptions = Apollo.BaseMutationOptions<TransferDealsEnterExecutionMutation, TransferDealsEnterExecutionMutationVariables>;
export const TransferDealsLinkDocumentDocument = gql`
    mutation TransferDealsLinkDocument($transferDealId: ID!, $fileDetails: FileDetailsInput!) {
  transferDealsLinkDocument(
    transferDealId: $transferDealId
    fileDetails: $fileDetails
  ) {
    uploadId
    buyingClubOrganisationAcceptedAt
    sellingClubOrganisationAcceptedAt
    playerOrganisationAcceptedAt
    buyingClubOrganisationViewedAt
    sellingClubOrganisationViewedAt
    playerOrganisationViewedAt
    documentType
  }
}
    `;
export type TransferDealsLinkDocumentMutationFn = Apollo.MutationFunction<TransferDealsLinkDocumentMutation, TransferDealsLinkDocumentMutationVariables>;

/**
 * __useTransferDealsLinkDocumentMutation__
 *
 * To run a mutation, you first call `useTransferDealsLinkDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferDealsLinkDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferDealsLinkDocumentMutation, { data, loading, error }] = useTransferDealsLinkDocumentMutation({
 *   variables: {
 *      transferDealId: // value for 'transferDealId'
 *      fileDetails: // value for 'fileDetails'
 *   },
 * });
 */
export function useTransferDealsLinkDocumentMutation(baseOptions?: Apollo.MutationHookOptions<TransferDealsLinkDocumentMutation, TransferDealsLinkDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferDealsLinkDocumentMutation, TransferDealsLinkDocumentMutationVariables>(TransferDealsLinkDocumentDocument, options);
      }
export type TransferDealsLinkDocumentMutationHookResult = ReturnType<typeof useTransferDealsLinkDocumentMutation>;
export type TransferDealsLinkDocumentMutationResult = Apollo.MutationResult<TransferDealsLinkDocumentMutation>;
export type TransferDealsLinkDocumentMutationOptions = Apollo.BaseMutationOptions<TransferDealsLinkDocumentMutation, TransferDealsLinkDocumentMutationVariables>;
export const TransferDealsAcceptDocumentDocument = gql`
    mutation TransferDealsAcceptDocument($details: AcceptTransferDealInput!) {
  transferDealsAcceptDocument(details: $details) {
    success
  }
}
    `;
export type TransferDealsAcceptDocumentMutationFn = Apollo.MutationFunction<TransferDealsAcceptDocumentMutation, TransferDealsAcceptDocumentMutationVariables>;

/**
 * __useTransferDealsAcceptDocumentMutation__
 *
 * To run a mutation, you first call `useTransferDealsAcceptDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferDealsAcceptDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferDealsAcceptDocumentMutation, { data, loading, error }] = useTransferDealsAcceptDocumentMutation({
 *   variables: {
 *      details: // value for 'details'
 *   },
 * });
 */
export function useTransferDealsAcceptDocumentMutation(baseOptions?: Apollo.MutationHookOptions<TransferDealsAcceptDocumentMutation, TransferDealsAcceptDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferDealsAcceptDocumentMutation, TransferDealsAcceptDocumentMutationVariables>(TransferDealsAcceptDocumentDocument, options);
      }
export type TransferDealsAcceptDocumentMutationHookResult = ReturnType<typeof useTransferDealsAcceptDocumentMutation>;
export type TransferDealsAcceptDocumentMutationResult = Apollo.MutationResult<TransferDealsAcceptDocumentMutation>;
export type TransferDealsAcceptDocumentMutationOptions = Apollo.BaseMutationOptions<TransferDealsAcceptDocumentMutation, TransferDealsAcceptDocumentMutationVariables>;
export const EnterTransferDealDocument = gql`
    mutation EnterTransferDeal($inviteToken: String!) {
  enterTransferDeal(inviteToken: $inviteToken) {
    transferDeal {
      transferDealId
      status
    }
  }
}
    `;
export type EnterTransferDealMutationFn = Apollo.MutationFunction<EnterTransferDealMutation, EnterTransferDealMutationVariables>;

/**
 * __useEnterTransferDealMutation__
 *
 * To run a mutation, you first call `useEnterTransferDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnterTransferDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enterTransferDealMutation, { data, loading, error }] = useEnterTransferDealMutation({
 *   variables: {
 *      inviteToken: // value for 'inviteToken'
 *   },
 * });
 */
export function useEnterTransferDealMutation(baseOptions?: Apollo.MutationHookOptions<EnterTransferDealMutation, EnterTransferDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnterTransferDealMutation, EnterTransferDealMutationVariables>(EnterTransferDealDocument, options);
      }
export type EnterTransferDealMutationHookResult = ReturnType<typeof useEnterTransferDealMutation>;
export type EnterTransferDealMutationResult = Apollo.MutationResult<EnterTransferDealMutation>;
export type EnterTransferDealMutationOptions = Apollo.BaseMutationOptions<EnterTransferDealMutation, EnterTransferDealMutationVariables>;
export const TransferDealsSetupDocument = gql`
    mutation TransferDealsSetup($details: SetupTransferDealInput!) {
  transferDealsSetup(details: $details) {
    transferDealId
    status
  }
}
    `;
export type TransferDealsSetupMutationFn = Apollo.MutationFunction<TransferDealsSetupMutation, TransferDealsSetupMutationVariables>;

/**
 * __useTransferDealsSetupMutation__
 *
 * To run a mutation, you first call `useTransferDealsSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferDealsSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferDealsSetupMutation, { data, loading, error }] = useTransferDealsSetupMutation({
 *   variables: {
 *      details: // value for 'details'
 *   },
 * });
 */
export function useTransferDealsSetupMutation(baseOptions?: Apollo.MutationHookOptions<TransferDealsSetupMutation, TransferDealsSetupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferDealsSetupMutation, TransferDealsSetupMutationVariables>(TransferDealsSetupDocument, options);
      }
export type TransferDealsSetupMutationHookResult = ReturnType<typeof useTransferDealsSetupMutation>;
export type TransferDealsSetupMutationResult = Apollo.MutationResult<TransferDealsSetupMutation>;
export type TransferDealsSetupMutationOptions = Apollo.BaseMutationOptions<TransferDealsSetupMutation, TransferDealsSetupMutationVariables>;
export const TransferDealsGetAllByOrganisationIdDocument = gql`
    query TransferDealsGetAllByOrganisationId {
  transferDealsGetAllByOrganisationId {
    buyingClubOrganisation {
      name
    }
    sellingClubOrganisation {
      name
    }
    playerOrganisation {
      name
    }
    playerContractId
    playerTransferContractId
    transferDealId
    status
    createdAt
  }
}
    `;

/**
 * __useTransferDealsGetAllByOrganisationIdQuery__
 *
 * To run a query within a React component, call `useTransferDealsGetAllByOrganisationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransferDealsGetAllByOrganisationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransferDealsGetAllByOrganisationIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useTransferDealsGetAllByOrganisationIdQuery(baseOptions?: Apollo.QueryHookOptions<TransferDealsGetAllByOrganisationIdQuery, TransferDealsGetAllByOrganisationIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransferDealsGetAllByOrganisationIdQuery, TransferDealsGetAllByOrganisationIdQueryVariables>(TransferDealsGetAllByOrganisationIdDocument, options);
      }
export function useTransferDealsGetAllByOrganisationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransferDealsGetAllByOrganisationIdQuery, TransferDealsGetAllByOrganisationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransferDealsGetAllByOrganisationIdQuery, TransferDealsGetAllByOrganisationIdQueryVariables>(TransferDealsGetAllByOrganisationIdDocument, options);
        }
export function useTransferDealsGetAllByOrganisationIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransferDealsGetAllByOrganisationIdQuery, TransferDealsGetAllByOrganisationIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransferDealsGetAllByOrganisationIdQuery, TransferDealsGetAllByOrganisationIdQueryVariables>(TransferDealsGetAllByOrganisationIdDocument, options);
        }
export type TransferDealsGetAllByOrganisationIdQueryHookResult = ReturnType<typeof useTransferDealsGetAllByOrganisationIdQuery>;
export type TransferDealsGetAllByOrganisationIdLazyQueryHookResult = ReturnType<typeof useTransferDealsGetAllByOrganisationIdLazyQuery>;
export type TransferDealsGetAllByOrganisationIdSuspenseQueryHookResult = ReturnType<typeof useTransferDealsGetAllByOrganisationIdSuspenseQuery>;
export type TransferDealsGetAllByOrganisationIdQueryResult = Apollo.QueryResult<TransferDealsGetAllByOrganisationIdQuery, TransferDealsGetAllByOrganisationIdQueryVariables>;
export const TransferDealsGetExecuteDocument = gql`
    query TransferDealsGetExecute($transferDealId: ID!) {
  transferDealsGetById(transferDealId: $transferDealId) {
    status
    buyingClubOrganisation {
      users {
        email
        firstName
        lastName
        middleName
        phoneNumber
        role
      }
    }
    sellingClubOrganisation {
      users {
        email
        firstName
        lastName
        middleName
        phoneNumber
        role
      }
    }
    playerOrganisation {
      users {
        firstName
        lastName
        middleName
        phoneNumber
        role
        email
      }
    }
    documents {
      mimeType
      fileName
      documentType
      buyingClubOrganisationViewedAt
      buyingClubOrganisationAcceptedAt
      playerOrganisationAcceptedAt
      playerOrganisationViewedAt
      sellingClubOrganisationAcceptedAt
      sellingClubOrganisationViewedAt
      uploadId
      uploadedByOrganisationId
      uploadedByUserId
    }
  }
}
    `;

/**
 * __useTransferDealsGetExecuteQuery__
 *
 * To run a query within a React component, call `useTransferDealsGetExecuteQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransferDealsGetExecuteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransferDealsGetExecuteQuery({
 *   variables: {
 *      transferDealId: // value for 'transferDealId'
 *   },
 * });
 */
export function useTransferDealsGetExecuteQuery(baseOptions: Apollo.QueryHookOptions<TransferDealsGetExecuteQuery, TransferDealsGetExecuteQueryVariables> & ({ variables: TransferDealsGetExecuteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransferDealsGetExecuteQuery, TransferDealsGetExecuteQueryVariables>(TransferDealsGetExecuteDocument, options);
      }
export function useTransferDealsGetExecuteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransferDealsGetExecuteQuery, TransferDealsGetExecuteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransferDealsGetExecuteQuery, TransferDealsGetExecuteQueryVariables>(TransferDealsGetExecuteDocument, options);
        }
export function useTransferDealsGetExecuteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransferDealsGetExecuteQuery, TransferDealsGetExecuteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransferDealsGetExecuteQuery, TransferDealsGetExecuteQueryVariables>(TransferDealsGetExecuteDocument, options);
        }
export type TransferDealsGetExecuteQueryHookResult = ReturnType<typeof useTransferDealsGetExecuteQuery>;
export type TransferDealsGetExecuteLazyQueryHookResult = ReturnType<typeof useTransferDealsGetExecuteLazyQuery>;
export type TransferDealsGetExecuteSuspenseQueryHookResult = ReturnType<typeof useTransferDealsGetExecuteSuspenseQuery>;
export type TransferDealsGetExecuteQueryResult = Apollo.QueryResult<TransferDealsGetExecuteQuery, TransferDealsGetExecuteQueryVariables>;
export const TransferDealsExecuteDealDocument = gql`
    mutation TransferDealsExecuteDeal($transferDealId: ID!) {
  transferDealsExecuteDeal(transferDealId: $transferDealId) {
    status
  }
}
    `;
export type TransferDealsExecuteDealMutationFn = Apollo.MutationFunction<TransferDealsExecuteDealMutation, TransferDealsExecuteDealMutationVariables>;

/**
 * __useTransferDealsExecuteDealMutation__
 *
 * To run a mutation, you first call `useTransferDealsExecuteDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferDealsExecuteDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferDealsExecuteDealMutation, { data, loading, error }] = useTransferDealsExecuteDealMutation({
 *   variables: {
 *      transferDealId: // value for 'transferDealId'
 *   },
 * });
 */
export function useTransferDealsExecuteDealMutation(baseOptions?: Apollo.MutationHookOptions<TransferDealsExecuteDealMutation, TransferDealsExecuteDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferDealsExecuteDealMutation, TransferDealsExecuteDealMutationVariables>(TransferDealsExecuteDealDocument, options);
      }
export type TransferDealsExecuteDealMutationHookResult = ReturnType<typeof useTransferDealsExecuteDealMutation>;
export type TransferDealsExecuteDealMutationResult = Apollo.MutationResult<TransferDealsExecuteDealMutation>;
export type TransferDealsExecuteDealMutationOptions = Apollo.BaseMutationOptions<TransferDealsExecuteDealMutation, TransferDealsExecuteDealMutationVariables>;
export const UploadsGetPresignedDownloadUrlDocument = gql`
    query UploadsGetPresignedDownloadUrl($uploadId: Int!) {
  uploadsGetPresignedDownloadUrl(uploadId: $uploadId)
}
    `;

/**
 * __useUploadsGetPresignedDownloadUrlQuery__
 *
 * To run a query within a React component, call `useUploadsGetPresignedDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useUploadsGetPresignedDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUploadsGetPresignedDownloadUrlQuery({
 *   variables: {
 *      uploadId: // value for 'uploadId'
 *   },
 * });
 */
export function useUploadsGetPresignedDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<UploadsGetPresignedDownloadUrlQuery, UploadsGetPresignedDownloadUrlQueryVariables> & ({ variables: UploadsGetPresignedDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UploadsGetPresignedDownloadUrlQuery, UploadsGetPresignedDownloadUrlQueryVariables>(UploadsGetPresignedDownloadUrlDocument, options);
      }
export function useUploadsGetPresignedDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UploadsGetPresignedDownloadUrlQuery, UploadsGetPresignedDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UploadsGetPresignedDownloadUrlQuery, UploadsGetPresignedDownloadUrlQueryVariables>(UploadsGetPresignedDownloadUrlDocument, options);
        }
export function useUploadsGetPresignedDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UploadsGetPresignedDownloadUrlQuery, UploadsGetPresignedDownloadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UploadsGetPresignedDownloadUrlQuery, UploadsGetPresignedDownloadUrlQueryVariables>(UploadsGetPresignedDownloadUrlDocument, options);
        }
export type UploadsGetPresignedDownloadUrlQueryHookResult = ReturnType<typeof useUploadsGetPresignedDownloadUrlQuery>;
export type UploadsGetPresignedDownloadUrlLazyQueryHookResult = ReturnType<typeof useUploadsGetPresignedDownloadUrlLazyQuery>;
export type UploadsGetPresignedDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useUploadsGetPresignedDownloadUrlSuspenseQuery>;
export type UploadsGetPresignedDownloadUrlQueryResult = Apollo.QueryResult<UploadsGetPresignedDownloadUrlQuery, UploadsGetPresignedDownloadUrlQueryVariables>;
export const UploadsCreateDocument = gql`
    mutation UploadsCreate($details: FileDetailsInput!) {
  uploadsCreate(details: $details) {
    uploadId
    s3Key
    fileName
    mimeType
  }
}
    `;
export type UploadsCreateMutationFn = Apollo.MutationFunction<UploadsCreateMutation, UploadsCreateMutationVariables>;

/**
 * __useUploadsCreateMutation__
 *
 * To run a mutation, you first call `useUploadsCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadsCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadsCreateMutation, { data, loading, error }] = useUploadsCreateMutation({
 *   variables: {
 *      details: // value for 'details'
 *   },
 * });
 */
export function useUploadsCreateMutation(baseOptions?: Apollo.MutationHookOptions<UploadsCreateMutation, UploadsCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadsCreateMutation, UploadsCreateMutationVariables>(UploadsCreateDocument, options);
      }
export type UploadsCreateMutationHookResult = ReturnType<typeof useUploadsCreateMutation>;
export type UploadsCreateMutationResult = Apollo.MutationResult<UploadsCreateMutation>;
export type UploadsCreateMutationOptions = Apollo.BaseMutationOptions<UploadsCreateMutation, UploadsCreateMutationVariables>;
export const UploadsGetByIdDocument = gql`
    query UploadsGetById($uploadId: Int!) {
  uploadsGetById(uploadId: $uploadId) {
    uploadId
    s3Key
    fileName
    mimeType
  }
}
    `;

/**
 * __useUploadsGetByIdQuery__
 *
 * To run a query within a React component, call `useUploadsGetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUploadsGetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUploadsGetByIdQuery({
 *   variables: {
 *      uploadId: // value for 'uploadId'
 *   },
 * });
 */
export function useUploadsGetByIdQuery(baseOptions: Apollo.QueryHookOptions<UploadsGetByIdQuery, UploadsGetByIdQueryVariables> & ({ variables: UploadsGetByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UploadsGetByIdQuery, UploadsGetByIdQueryVariables>(UploadsGetByIdDocument, options);
      }
export function useUploadsGetByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UploadsGetByIdQuery, UploadsGetByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UploadsGetByIdQuery, UploadsGetByIdQueryVariables>(UploadsGetByIdDocument, options);
        }
export function useUploadsGetByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UploadsGetByIdQuery, UploadsGetByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UploadsGetByIdQuery, UploadsGetByIdQueryVariables>(UploadsGetByIdDocument, options);
        }
export type UploadsGetByIdQueryHookResult = ReturnType<typeof useUploadsGetByIdQuery>;
export type UploadsGetByIdLazyQueryHookResult = ReturnType<typeof useUploadsGetByIdLazyQuery>;
export type UploadsGetByIdSuspenseQueryHookResult = ReturnType<typeof useUploadsGetByIdSuspenseQuery>;
export type UploadsGetByIdQueryResult = Apollo.QueryResult<UploadsGetByIdQuery, UploadsGetByIdQueryVariables>;
export const UploadsDeleteDocument = gql`
    mutation UploadsDelete($uploadId: Int!) {
  uploadsDelete(uploadId: $uploadId)
}
    `;
export type UploadsDeleteMutationFn = Apollo.MutationFunction<UploadsDeleteMutation, UploadsDeleteMutationVariables>;

/**
 * __useUploadsDeleteMutation__
 *
 * To run a mutation, you first call `useUploadsDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadsDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadsDeleteMutation, { data, loading, error }] = useUploadsDeleteMutation({
 *   variables: {
 *      uploadId: // value for 'uploadId'
 *   },
 * });
 */
export function useUploadsDeleteMutation(baseOptions?: Apollo.MutationHookOptions<UploadsDeleteMutation, UploadsDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadsDeleteMutation, UploadsDeleteMutationVariables>(UploadsDeleteDocument, options);
      }
export type UploadsDeleteMutationHookResult = ReturnType<typeof useUploadsDeleteMutation>;
export type UploadsDeleteMutationResult = Apollo.MutationResult<UploadsDeleteMutation>;
export type UploadsDeleteMutationOptions = Apollo.BaseMutationOptions<UploadsDeleteMutation, UploadsDeleteMutationVariables>;
export const UsersGetByIdDocument = gql`
    query UsersGetById($userId: ID!) {
  usersGetById(userId: $userId) {
    userId
    username
    email
    phoneNumber
    firstName
    middleName
    lastName
    userType
    createdAt
  }
}
    `;

/**
 * __useUsersGetByIdQuery__
 *
 * To run a query within a React component, call `useUsersGetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersGetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersGetByIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUsersGetByIdQuery(baseOptions: Apollo.QueryHookOptions<UsersGetByIdQuery, UsersGetByIdQueryVariables> & ({ variables: UsersGetByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersGetByIdQuery, UsersGetByIdQueryVariables>(UsersGetByIdDocument, options);
      }
export function useUsersGetByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersGetByIdQuery, UsersGetByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersGetByIdQuery, UsersGetByIdQueryVariables>(UsersGetByIdDocument, options);
        }
export function useUsersGetByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersGetByIdQuery, UsersGetByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersGetByIdQuery, UsersGetByIdQueryVariables>(UsersGetByIdDocument, options);
        }
export type UsersGetByIdQueryHookResult = ReturnType<typeof useUsersGetByIdQuery>;
export type UsersGetByIdLazyQueryHookResult = ReturnType<typeof useUsersGetByIdLazyQuery>;
export type UsersGetByIdSuspenseQueryHookResult = ReturnType<typeof useUsersGetByIdSuspenseQuery>;
export type UsersGetByIdQueryResult = Apollo.QueryResult<UsersGetByIdQuery, UsersGetByIdQueryVariables>;
export const UsersUpdateProfileDocument = gql`
    mutation UsersUpdateProfile($userId: ID!, $userProfileDetails: UserProfileDetails) {
  usersUpdateProfile(userId: $userId, userProfileDetails: $userProfileDetails) {
    success
  }
}
    `;
export type UsersUpdateProfileMutationFn = Apollo.MutationFunction<UsersUpdateProfileMutation, UsersUpdateProfileMutationVariables>;

/**
 * __useUsersUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUsersUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersUpdateProfileMutation, { data, loading, error }] = useUsersUpdateProfileMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      userProfileDetails: // value for 'userProfileDetails'
 *   },
 * });
 */
export function useUsersUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<UsersUpdateProfileMutation, UsersUpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UsersUpdateProfileMutation, UsersUpdateProfileMutationVariables>(UsersUpdateProfileDocument, options);
      }
export type UsersUpdateProfileMutationHookResult = ReturnType<typeof useUsersUpdateProfileMutation>;
export type UsersUpdateProfileMutationResult = Apollo.MutationResult<UsersUpdateProfileMutation>;
export type UsersUpdateProfileMutationOptions = Apollo.BaseMutationOptions<UsersUpdateProfileMutation, UsersUpdateProfileMutationVariables>;
export const UsersSetDefaultOrganisationDocument = gql`
    mutation UsersSetDefaultOrganisation($organisationId: ID!) {
  usersSetDefaultOrganisation(organisationId: $organisationId) {
    success
  }
}
    `;
export type UsersSetDefaultOrganisationMutationFn = Apollo.MutationFunction<UsersSetDefaultOrganisationMutation, UsersSetDefaultOrganisationMutationVariables>;

/**
 * __useUsersSetDefaultOrganisationMutation__
 *
 * To run a mutation, you first call `useUsersSetDefaultOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersSetDefaultOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersSetDefaultOrganisationMutation, { data, loading, error }] = useUsersSetDefaultOrganisationMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useUsersSetDefaultOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<UsersSetDefaultOrganisationMutation, UsersSetDefaultOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UsersSetDefaultOrganisationMutation, UsersSetDefaultOrganisationMutationVariables>(UsersSetDefaultOrganisationDocument, options);
      }
export type UsersSetDefaultOrganisationMutationHookResult = ReturnType<typeof useUsersSetDefaultOrganisationMutation>;
export type UsersSetDefaultOrganisationMutationResult = Apollo.MutationResult<UsersSetDefaultOrganisationMutation>;
export type UsersSetDefaultOrganisationMutationOptions = Apollo.BaseMutationOptions<UsersSetDefaultOrganisationMutation, UsersSetDefaultOrganisationMutationVariables>;
export const UsersUpdateLastLoginDocument = gql`
    mutation UsersUpdateLastLogin {
  usersUpdateLastLogin {
    success
  }
}
    `;
export type UsersUpdateLastLoginMutationFn = Apollo.MutationFunction<UsersUpdateLastLoginMutation, UsersUpdateLastLoginMutationVariables>;

/**
 * __useUsersUpdateLastLoginMutation__
 *
 * To run a mutation, you first call `useUsersUpdateLastLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersUpdateLastLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersUpdateLastLoginMutation, { data, loading, error }] = useUsersUpdateLastLoginMutation({
 *   variables: {
 *   },
 * });
 */
export function useUsersUpdateLastLoginMutation(baseOptions?: Apollo.MutationHookOptions<UsersUpdateLastLoginMutation, UsersUpdateLastLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UsersUpdateLastLoginMutation, UsersUpdateLastLoginMutationVariables>(UsersUpdateLastLoginDocument, options);
      }
export type UsersUpdateLastLoginMutationHookResult = ReturnType<typeof useUsersUpdateLastLoginMutation>;
export type UsersUpdateLastLoginMutationResult = Apollo.MutationResult<UsersUpdateLastLoginMutation>;
export type UsersUpdateLastLoginMutationOptions = Apollo.BaseMutationOptions<UsersUpdateLastLoginMutation, UsersUpdateLastLoginMutationVariables>;
export const UsersGetAllDocument = gql`
    query UsersGetAll {
  usersGetAll {
    userId
    username
    email
    phoneNumber
    firstName
    middleName
    lastName
    userType
    createdAt
    lastLoginAt
    organisations {
      organisationId
      name
      type
      role
    }
  }
}
    `;

/**
 * __useUsersGetAllQuery__
 *
 * To run a query within a React component, call `useUsersGetAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersGetAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersGetAllQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersGetAllQuery(baseOptions?: Apollo.QueryHookOptions<UsersGetAllQuery, UsersGetAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersGetAllQuery, UsersGetAllQueryVariables>(UsersGetAllDocument, options);
      }
export function useUsersGetAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersGetAllQuery, UsersGetAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersGetAllQuery, UsersGetAllQueryVariables>(UsersGetAllDocument, options);
        }
export function useUsersGetAllSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersGetAllQuery, UsersGetAllQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersGetAllQuery, UsersGetAllQueryVariables>(UsersGetAllDocument, options);
        }
export type UsersGetAllQueryHookResult = ReturnType<typeof useUsersGetAllQuery>;
export type UsersGetAllLazyQueryHookResult = ReturnType<typeof useUsersGetAllLazyQuery>;
export type UsersGetAllSuspenseQueryHookResult = ReturnType<typeof useUsersGetAllSuspenseQuery>;
export type UsersGetAllQueryResult = Apollo.QueryResult<UsersGetAllQuery, UsersGetAllQueryVariables>;
export const UsersGetPaginatedDocument = gql`
    query UsersGetPaginated($pagination: PaginationInput!, $sorting: SortInput, $filters: [FilterInput!], $search: String) {
  usersGetPaginated(
    pagination: $pagination
    sorting: $sorting
    filters: $filters
    search: $search
  ) {
    items {
      userId
      username
      email
      phoneNumber
      firstName
      middleName
      lastName
      userType
      createdAt
      lastLoginAt
      organisations {
        organisationId
        name
        type
        role
      }
    }
    pagination {
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useUsersGetPaginatedQuery__
 *
 * To run a query within a React component, call `useUsersGetPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersGetPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersGetPaginatedQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sorting: // value for 'sorting'
 *      filters: // value for 'filters'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useUsersGetPaginatedQuery(baseOptions: Apollo.QueryHookOptions<UsersGetPaginatedQuery, UsersGetPaginatedQueryVariables> & ({ variables: UsersGetPaginatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersGetPaginatedQuery, UsersGetPaginatedQueryVariables>(UsersGetPaginatedDocument, options);
      }
export function useUsersGetPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersGetPaginatedQuery, UsersGetPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersGetPaginatedQuery, UsersGetPaginatedQueryVariables>(UsersGetPaginatedDocument, options);
        }
export function useUsersGetPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersGetPaginatedQuery, UsersGetPaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersGetPaginatedQuery, UsersGetPaginatedQueryVariables>(UsersGetPaginatedDocument, options);
        }
export type UsersGetPaginatedQueryHookResult = ReturnType<typeof useUsersGetPaginatedQuery>;
export type UsersGetPaginatedLazyQueryHookResult = ReturnType<typeof useUsersGetPaginatedLazyQuery>;
export type UsersGetPaginatedSuspenseQueryHookResult = ReturnType<typeof useUsersGetPaginatedSuspenseQuery>;
export type UsersGetPaginatedQueryResult = Apollo.QueryResult<UsersGetPaginatedQuery, UsersGetPaginatedQueryVariables>;
export const UsersVerifyOtpDocument = gql`
    query UsersVerifyOTP {
  usersVerifyOTP {
    success
  }
}
    `;

/**
 * __useUsersVerifyOtpQuery__
 *
 * To run a query within a React component, call `useUsersVerifyOtpQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersVerifyOtpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersVerifyOtpQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersVerifyOtpQuery(baseOptions?: Apollo.QueryHookOptions<UsersVerifyOtpQuery, UsersVerifyOtpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersVerifyOtpQuery, UsersVerifyOtpQueryVariables>(UsersVerifyOtpDocument, options);
      }
export function useUsersVerifyOtpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersVerifyOtpQuery, UsersVerifyOtpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersVerifyOtpQuery, UsersVerifyOtpQueryVariables>(UsersVerifyOtpDocument, options);
        }
export function useUsersVerifyOtpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersVerifyOtpQuery, UsersVerifyOtpQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersVerifyOtpQuery, UsersVerifyOtpQueryVariables>(UsersVerifyOtpDocument, options);
        }
export type UsersVerifyOtpQueryHookResult = ReturnType<typeof useUsersVerifyOtpQuery>;
export type UsersVerifyOtpLazyQueryHookResult = ReturnType<typeof useUsersVerifyOtpLazyQuery>;
export type UsersVerifyOtpSuspenseQueryHookResult = ReturnType<typeof useUsersVerifyOtpSuspenseQuery>;
export type UsersVerifyOtpQueryResult = Apollo.QueryResult<UsersVerifyOtpQuery, UsersVerifyOtpQueryVariables>;
export const UsersSendPasswordResetEmailDocument = gql`
    mutation UsersSendPasswordResetEmail($userId: ID!) {
  usersSendPasswordResetEmail(userId: $userId) {
    success
  }
}
    `;
export type UsersSendPasswordResetEmailMutationFn = Apollo.MutationFunction<UsersSendPasswordResetEmailMutation, UsersSendPasswordResetEmailMutationVariables>;

/**
 * __useUsersSendPasswordResetEmailMutation__
 *
 * To run a mutation, you first call `useUsersSendPasswordResetEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersSendPasswordResetEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersSendPasswordResetEmailMutation, { data, loading, error }] = useUsersSendPasswordResetEmailMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUsersSendPasswordResetEmailMutation(baseOptions?: Apollo.MutationHookOptions<UsersSendPasswordResetEmailMutation, UsersSendPasswordResetEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UsersSendPasswordResetEmailMutation, UsersSendPasswordResetEmailMutationVariables>(UsersSendPasswordResetEmailDocument, options);
      }
export type UsersSendPasswordResetEmailMutationHookResult = ReturnType<typeof useUsersSendPasswordResetEmailMutation>;
export type UsersSendPasswordResetEmailMutationResult = Apollo.MutationResult<UsersSendPasswordResetEmailMutation>;
export type UsersSendPasswordResetEmailMutationOptions = Apollo.BaseMutationOptions<UsersSendPasswordResetEmailMutation, UsersSendPasswordResetEmailMutationVariables>;